export const nl = {
  app: {
    home: 'Home',
    playerScout: 'Spelerscout',
    playerComparison: 'Spelersvergelijking',
    playerRecruitment: 'Radar',
    collections: 'Collecties',
    favoritePlayers: 'Favoriete Spelers',
    teamAnalytics: 'Team Analytics',
    gameAnalysis: 'Wedstrijdanalyse',
    seasonStats: 'Seizoenstatistieken',
    leagueTable: 'Competitiestand',
    scoresAndFixtures: 'Uitslagen & Programma',
    notifications: 'Meldingen',
    administration: 'Administratie',
    inbox: 'Postvak IN',
    teamStats: 'Teamstatistieken',
    blog: 'Blog',
    leagues: 'Competities',
    squadBuilder: 'Selectie Bouwer',
    playerAlerts: 'Spelermeldingen',
    searchAlerts: 'Zoekmeldingen',
    videoUploadTool: 'Video Upload Tool',
    videoPlaylists: 'Afspeellijsten',
    uploadedGames: 'Geüploade wedstrijden',
    favoriteTeams: 'Favoriete Teams',
    arrigo: 'Arrigo',
    validateEvents: 'Valideer gebeurtenissen'
  },
  playerRecruitment: {
    title: 'Spelersprofiel',
    subtitle: 'Ga dieper in op de kenmerken en statistieken van de speler',
    league: 'Competitie',
    selectedSeason: 'Geselecteerd seizoen',
    year: 'Jaar',
    radar: 'Radar',
    positions: 'Posities',
    numberOfPlayers: 'Aantal spelers',
    template: 'Sjabloon',
    compareWith: 'Vergelijk met',
    previousPerformance: 'Vorige prestatie',
    xGames: '{0} wedstrijden',
    average: 'Gemiddelde',
    leagueAverage: 'Competitiegemiddelde',
    selectSeason: 'Selecteer een seizoen',
    positionsPlayed: 'Gespeelde posities',
    minMax: 'Min & max',
    top5Leagues: 'Top 5 competities',
    infoMessage: 'Selecteer slechts één seizoen om seizoen Min & Max in te schakelen',
    infoMessage2: 'Selecteer hetzelfde seizoen voor beide spelers',
    dataPer90MinText: 'Gegevens per 90 minuten',
    adjustToPossessionText: '* Aangepast aan balbezit',
    text: 'Tekst',
    lollipop: 'Lolly',
    polar: 'Polair',
    noGamesBetweenDates: 'Geen wedstrijden gevonden tussen de geselecteerde datums',
    radarTemplates: {
      Goalkeeper: 'Doelman',
      GoalkeeperCustom: 'Doelman aangepast',
      GoalkeeperCustom1: 'Doelman aangepast 1',
      GoalkeeperCustom2: 'Doelman aangepast 2',
      GoalkeeperCustom3: 'Doelman aangepast 3',
      GoalkeeperCustom4: 'Doelman aangepast 4',
      GoalkeeperCustom5: 'Doelman aangepast 5',
      GoalkeeperCustom6: 'Doelman aangepast 6',
      Defender: 'Verdediger',
      DefenderCustom: 'Verdediger aangepast',
      DefenderCustom1: 'Verdediger aangepast 1',
      DefenderCustom2: 'Verdediger aangepast 2',
      DefenderCustom3: 'Verdediger aangepast 3',
      DefenderCustom4: 'Verdediger aangepast 4',
      DefenderCustom5: 'Verdediger aangepast 5',
      DefenderCustom6: 'Verdediger aangepast 6',
      FullBack: 'Vleugelverdediger',
      FullBackCustom: 'Vleugelverdediger aangepast',
      FullBackCustom1: 'Vleugelverdediger aangepast 1',
      FullBackCustom2: 'Vleugelverdediger aangepast 2',
      FullBackCustom3: 'Vleugelverdediger aangepast 3',
      FullBackCustom4: 'Vleugelverdediger aangepast 4',
      FullBackCustom5: 'Vleugelverdediger aangepast 5',
      FullBackCustom6: 'Vleugelverdediger aangepast 6',
      FullBackPredictive: 'Vleugelverdediger',
      Midfielder: 'Middenvelder',
      MidfielderCustom: 'Middenvelder aangepast',
      MidfielderCustom1: 'Middenvelder aangepast 1',
      MidfielderCustom2: 'Middenvelder aangepast 2',
      MidfielderCustom3: 'Middenvelder aangepast 3',
      MidfielderCustom4: 'Middenvelder aangepast 4',
      MidfielderCustom5: 'Middenvelder aangepast 5',
      MidfielderCustom6: 'Middenvelder aangepast 6',
      MidfielderPredictive: 'Middenvelder',
      MidfielderDefensive: 'Defensieve middenvelder',
      MidfielderOffensive: 'Offensieve middenvelder',
      AttackingMidfielder: 'Aanvallende middenvelder',
      MidfielderWing: 'Vleugelmiddenvelder',
      Winger: 'Vleugelspeler',
      WingerCustom: 'Vleugelspeler aangepast',
      WingerCustom1: 'Vleugelspeler aangepast 1',
      WingerCustom2: 'Vleugelspeler aangepast 2',
      WingerCustom3: 'Vleugelspeler aangepast 3',
      WingerCustom4: 'Vleugelspeler aangepast 4',
      WingerCustom5: 'Vleugelspeler aangepast 5',
      WingerCustom6: 'Vleugelspeler aangepast 6',
      WingerOffensive: 'Offensieve vleugelspeler',
      Forward: 'Aanvaller',
      ForwardCustom: 'Aanvaller aangepast',
      ForwardCustom1: 'Aanvaller aangepast 1',
      ForwardCustom2: 'Aanvaller aangepast 2',
      ForwardCustom3: 'Aanvaller aangepast 3',
      ForwardCustom4: 'Aanvaller aangepast 4',
      ForwardCustom5: 'Aanvaller aangepast 5',
      ForwardCustom6: 'Aanvaller aangepast 6',
      ForwardPredictive: 'Aanvaller',
      WingBack: 'Vleugelverdediger',
      WingBackCustom: 'Vleugelverdediger aangepast',
      WingBackCustom1: 'Vleugelverdediger aangepast 1',
      WingBackCustom2: 'Vleugelverdediger aangepast 2',
      WingBackCustom3: 'Vleugelverdediger aangepast 3',
      WingBackCustom4: 'Vleugelverdediger aangepast 4',
      WingBackCustom5: 'Vleugelverdediger aangepast 5',
      WingBackCustom6: 'Vleugelverdediger aangepast 6',
      WingBackMedia: 'Vleugelverdediger (SocialMedia)',
      FullBackMedia: 'Vleugelverdediger (SocialMedia)',
      MidfielderMedia: 'Middenvelder (SocialMedia)',
      WingerMedia: 'Vleugelspeler (SocialMedia)',
      ForwardMedia: 'Aanvaller (SocialMedia)',
      PhysicalWingBack: 'Fysieke vleugelverdediger',
      PhysicalForward: 'Fysieke aanvaller',
      PhysicalWinger: 'Fysieke vleugelspeler',
      PhysicalMidfielder: 'Fysieke middenvelder',
      PhysicalFullBack: 'Fysieke vleugelverdediger',
      PhysicalDefender: 'Fysieke verdediger',
      PhysicalWingBackLMO: 'Fysieke vleugelverdediger',
      PhysicalForwardLMO: 'Fysieke aanvaller',
      PhysicalWingerLMO: 'Fysieke vleugelspeler',
      PhysicalMidfielderLMO: 'Fysieke middenvelder',
      PhysicalFullBackLMO: 'Fysieke vleugelverdediger',
      PhysicalDefenderLMO: 'Fysieke verdediger'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Doelman',
      Defender: 'Verdediger',
      FullBack: 'Vleugelverdediger',
      FullBackPredictive: 'Vleugelverdediger',
      Midfielder: 'Middenvelder',
      MidfielderPredictive: 'Middenvelder',
      MidfielderDefensive: 'Defensieve middenvelder',
      MidfielderOffensive: 'Offensieve middenvelder',
      AttackingMidfielder: 'Aanvallende middenvelder',
      MidfielderWing: 'Vleugelmiddenvelder',
      Winger: 'Vleugelspeler',
      WingerOffensive: 'Offensieve vleugelspeler',
      Forward: 'Aanvaller',
      ForwardPredictive: 'Aanvaller',
      WingBack: 'Vleugelverdediger',
      WingBackMedia: 'Vleugelverdediger (SocialMedia)',
      FullBackMedia: 'Vleugelverdediger (SocialMedia)',
      MidfielderMedia: 'Middenvelder (SocialMedia)',
      WingerMedia: 'Vleugelspeler (SocialMedia)',
      ForwardMedia: 'Aanvaller (SocialMedia)',
      PhysicalWingBack: 'Fysieke vleugelverdediger',
      PhysicalForward: 'Fysieke aanvaller',
      PhysicalWinger: 'Fysieke vleugelspeler',
      PhysicalMidfielder: 'Fysieke middenvelder',
      PhysicalFullBack: 'Fysieke vleugelverdediger',
      PhysicalDefender: 'Fysieke verdediger',
      PhysicalWingBackLMO: 'Fysieke vleugelverdediger',
      PhysicalForwardLMO: 'Fysieke aanvaller',
      PhysicalWingerLMO: 'Fysieke vleugelspeler',
      PhysicalMidfielderLMO: 'Fysieke middenvelder',
      PhysicalFullBackLMO: 'Fysieke vleugelverdediger',
      PhysicalDefenderLMO: 'Fysieke verdediger'
    },
    radarDescription: {
      basicStatistics: {
        title: 'BASISSTATISTIEKEN',
        minutes: 'minuten',
        goals: 'doelpunten',
        assists: 'assists',
        redCards: 'rode kaarten',
        yellowCards: 'gele kaarten',
        games: 'wedstrijden',
        goalsReceived: 'doelpunten tegen (excl. penalty\'s)',
        xGFaced: 'xG tegen'
      },
      profiles: {
        3: {
          1: 'Doelman met goede techniek in de opbouw, zowel in korte als lange passing.',
          2: 'Vermogen om met de voeten te spelen en belangrijk te zijn bij de initiatie van het spel, met goede slagingspercentages zowel op korte als op lange termijn.',
          3: 'Goed voetenwerk dat dit profiel tot een interessante optie maakt vanwege de passerende statistieken.',
          4: 'Profiel dat opvalt door zijn passes, zowel in zijn eigen veld als in het veld van de tegenstander.',
          5: 'Grote zekerheid met de bal aan zijn voeten en hoge passvaardigheden.',
          6: 'Goed voetenwerk, zekerheid bij het lanceren van de bal en een hoog percentage korte en lange passes.',
          7: 'Hoog percentage voltooide passen, zowel kort als lang, wat kwaliteit in omloop biedt.'
        },
        5: {
          1: 'Verdediger die goed presteert in één-tegen-één-situaties en veel tackles en onderscheppingen uitvoert.',
          2: 'Zeer effectieve centrale verdediger in individuele duels, zowel boven als in de tackle, met goed leesvermogen om te anticiperen.',
          3: 'Centrale verdediging met goede prestaties in individuele defensieve duels, wat zich vertaalt in een groot volume aan herstelacties.',
          4: 'Profiel met een hoog defensief niveau, in staat om een ​​groot aantal ballen terug te winnen dankzij tackles en onderscheppingen.',
          5: 'Zeer effectieve verdediging bij de tackle en met een groot aantal onderscheppingen, die opvallen in individuele confrontaties.',
          6: 'Centrale verdediger met een hoog aantal herstelacties per wedstrijd, bedreven in het lezen van het rivaliserende spel en het snijden, met hoge precisie en frequentie in tackles.',
          7: 'Defensief profiel met een hoog herstelvolume dankzij de effectiviteit en frequentie van tackles en goed anticiperen.'
        },
        6: {
          1: 'Verdediger met goed spelinzicht die met zijn passing belangrijk bijdraagt aan het creëren van kansen.'
        },
        7: {
          1: 'Vleugelverdediger met een gebalanceerde bijdrage tussen aanvallend (grote bijdrage in xG buildup) en verdedigend werk (hoog volume balveroveringen).'
        },
        8: {
          1: 'Vleugelverdediger die solide is in één-tegen-één-situaties en veel ballen herovert via tackles en onderscheppingen.'
        },
        9: {
          1: 'Vleugelverdediger met grote aanvallende bijdrage, die regelmatig gevaarlijke acties en kansen creëert.'
        },
        10: {
          1: 'Complete middenvelder die veel ruimte kan bestrijken, zowel bij het heroveren van de bal als in een significante bijdrage aan de xG buildup van het team.'
        },
        11: {
          1: 'Middenvelder met hoge verdedigende impact en grote effectiviteit in passing, ondanks een beperkte directe invloed in de aanval.'
        },
        12: {
          1: 'Complete middenvelder met hoge bijdrage in het creëren van kansen, sterk in de lucht en met veel onderscheppingen en tackles.'
        },
        15: {
          1: 'Vleugelspeler met goede één-tegen-één-vaardigheden en een hoog niveau in voltooide voorzetten, die meer verwachte assists dan schoten genereert.'
        },
        16: {
          1: 'Speler met een groot aantal steekpasses en progressieve acties, die kansen creëert en vaker in het centrum dan als klassieke vleugelspeler betrokken is bij balbezit.'
        },
        17: {
          1: 'Aanvaller met goede dribbelvaardigheden die vaak naar binnen komt en meer schoten (xG) dan key passes (xA) genereert.'
        },
        18: {
          1: 'Aanvaller met grote impact zonder bal, die goed weet te beslissen wanneer af te ronden met een schot en wanneer af te spelen.'
        },
        22: {
          1: 'Aanvaller met hoge mobiliteit om steekpasses te ontvangen, naar de vleugel uit te wijken en veel kansen te creëren. Een groot deel van de balcontacten vindt buiten het strafschopgebied plaats ten opzichte van het totaalaantal.'
        }
      },
      description: 'BESCHRIJVING',
      conjuction: ' en ',
      conjuction2: ' en ',
      over: 'boven',
      under: 'onder',
      respectively: ', respectievelijk',
      Defending1: {
        1: 'De defensieve prestatie behoort tot de zwakste in de top 5 competities.'
      },
      Defending2: {
        1: 'De defensieve bijdrage blijft onder het gemiddelde en is onvoldoende.'
      },
      Defending3: {
        1: 'De defensieve prestatie is acceptabel, met een niveau iets boven_onder_het_gemiddelde.'
      },
      Defending4: {
        1: 'Zeer goed werk in defensieve taken, met een prestatie boven het gemiddelde.'
      },
      Defending5: {
        1: 'Uitstekend in defensieve taken, met een prestatie vergelijkbaar met de beste speler_posities in de top 5 competities.'
      },
      Saving1: {
        1: 'Doelman met een zeer lage prestatie, met grote moeite om schoten te keren.'
      },
      Saving2: {
        1: 'De prestaties als doelman liggen onder het gemiddelde en zijn niet voldoende.'
      },
      Saving3: {
        1: 'Doelman met een acceptabele prestatie, rond het gemiddelde van de top 5 competities, maar metric_name moet worden verbeterd.'
      },
      Saving4: {
        1: 'Doelman met een niveau boven het gemiddelde van de top 5 competities, die vooral in metric_name opvalt.'
      },
      Saving5: {
        1: 'Zeer complete doelman, waarvan alle statistieken binnen de top 20% vallen vergeleken met keepers in de top 5 competities in Europa.'
      },
      Passing1: {
        1: 'Aan de bal ligt het niveau bij de slechtste spelers.'
      },
      Passing2: {
        1: 'Wat passing betreft blijft de prestatie onder het gemiddelde.'
      },
      Passing3: {
        1: 'Het passniveau is acceptabel, iets boven_onder_het_gemiddelde.'
      },
      Passing4: {
        1: 'Zeer goed niveau in passing, ruim boven het gemiddelde.'
      },
      Passing5: {
        1: 'Zeer effectief in passing, met een prestatie hoger dan die van de meeste spelers.'
      },
      Aerial1: {
        1: 'Zeer zwak in het luchtspel, tot de slechtste in de positie in dit aspect.'
      },
      Aerial2: {
        1: 'Wat luchtduels betreft is de prestatie onvoldoende en onder het gemiddelde.'
      },
      Aerial3: {
        1: 'Acceptabel niveau in het luchtspel, iets boven_onder_het_gemiddelde.'
      },
      Aerial4: {
        1: 'Zeer goede prestatie in het luchtspel, met hoge effectiviteit in dit aspect.'
      },
      Aerial5: {
        1: 'De statistieken in het luchtspel plaatsen de speler bij de besten.'
      },
      Shooting1: {
        1: 'Zeer zwakke statistieken voor het doel, één van de minst effectieve profielen in dit opzicht.'
      },
      Shooting2: {
        1: 'Het schotniveau is duidelijk voor verbetering vatbaar en ligt onder het gemiddelde.'
      },
      Shooting3: {
        1: 'Acceptabele prestatie in aanvallende taken, met een niveau iets boven_onder_het_gemiddelde.'
      },
      Shooting4: {
        1: 'Zeer goede prestatie in het strafschopgebied, met betere cijfers dan 60% van de spelers.'
      },
      Shooting5: {
        1: 'Uitstekende vaardigheden in offensieve taken, met een opvallende prestatie die tot de besten in dit aspect behoort.'
      },
      Association1: {
        1: 'De bijdrage in combinatiespel met de bal is zeer laag, tot de slechtste in de top 5 competities.'
      },
      Association2: {
        1: 'Er is veel ruimte voor verbetering in het combinatiespel, aangezien de prestatie onder het gemiddelde ligt.'
      },
      Association3: {
        1: 'Associeert goed met de bal, met een niveau iets boven_onder_het_gemiddelde.'
      },
      Association4: {
        1: 'Combineert zeer goed met de bal en laat een zeer opmerkelijk niveau zien.'
      },
      Association5: {
        1: 'Buitengewone combinatieve vaardigheid aan de bal, vergelijkbaar met de beste spelers.'
      },
      BallHandling1: {
        1: 'Zeer zwakke prestatie in balbehandeling, tot de slechtste vergeleken met de top 5 competities.'
      },
      BallHandling2: {
        1: 'Wat balbehandeling betreft ligt het niveau onder het gemiddelde.'
      },
      BallHandling3: {
        1: 'Acceptabel niveau in balbehandeling, iets boven_onder_het_gemiddelde.'
      },
      BallHandling4: {
        1: 'Hoog niveau in balbehandeling, met cijfers dicht bij de besten in dit aspect.'
      },
      BallHandling5: {
        1: 'Uitzonderlijke balbehandeling, bij de besten in de top 5 competities.'
      },
      Crosses1: {
        1: 'Lage prestatie bij voorzetten in het strafschopgebied; de statistieken behoren tot de slechtste profielen.'
      },
      Crosses2: {
        1: 'Onder gemiddelde prestatie bij het creëren van gevaar met voorzetten.'
      },
      Crosses3: {
        1: 'Acceptabel niveau in voorzetten richting het strafschopgebied, iets boven_onder_het_gemiddelde.'
      },
      Crosses4: {
        1: 'Goede statistieken bij voorzetten, duidelijk boven het gemiddelde.'
      },
      Crosses5: {
        1: 'Zeer hoge prestatie bij voorzetten in het strafschopgebied, binnen de top 20% van de meest effectieve profielen in deze categorie.'
      },
      Carries1: {
        1: 'Behoort tot de 20% spelers met de zwakste cijfers wat baldragen betreft.'
      },
      Carries2: {
        1: 'De prestatie in baldragen ligt ver onder het gemiddelde voor spelers in deze positie.'
      },
      Carries3: {
        1: 'Prestatie dicht bij het gemiddelde, met een niveau iets boven_onder_het_gemiddelde in baldragen.'
      },
      Carries4: {
        1: 'Uitstekende speler met zeer goede diepte en cijfers in baldragen.'
      },
      Carries5: {
        1: 'Zeer getalenteerd in baldragen, met hoge prestatie in de statistieken van de Carries-categorie.'
      },
      Turnovers1: {
        1: 'Zeer negatieve bijdrage met een hoog volume aan balverlies dat het voor tegenstanders makkelijker maakt om gevaar te creëren. Behoort tot de slechtste in deze statistiek.'
      },
      Turnovers2: {
        1: 'Talrijke gevaarlijke balverliezen werken in het voordeel van de tegenstander; er is een duidelijke behoefte om dit te verminderen.'
      },
      Turnovers3: {
        1: 'Het niveau in balverlies ligt iets boven_onder_het_gemiddelde; er is nog ruimte om de prestatie te verbeteren.'
      },
      Turnovers4: {
        1: 'Opmerkelijke prestatie in balverlies, beter dan 60% van de spelers met minder balverlies.'
      },
      Turnovers5: {
        1: 'Het lage aantal balverliezen valt op en plaatst de speler bij de besten om balbezit voor het team te behouden.'
      },
      SequenceInvolvement1: {
        1: 'Wat balbezit betreft zijn de cijfers ongunstig en eindigen acties zelden in een schot.'
      },
      SequenceInvolvement2: {
        1: 'De afwerking van balbezit is duidelijk voor verbetering vatbaar; sequenties eindigen zelden in een schot, waardoor de prestatie ver onder het gemiddelde ligt.'
      },
      SequenceInvolvement3: {
        1: 'Acceptabel niveau in het afmaken van balbezit richting doel, met een percentiel iets boven_onder_het_gemiddelde en grote marge voor verbetering.'
      },
      SequenceInvolvement4: {
        1: 'Goede vaardigheid om het balbezit van het team af te sluiten met schoten; een deel daarvan eindigt in doelpunten, met een opvallende prestatie binnen deze categorie.'
      },
      SequenceInvolvement5: {
        1: 'Behoort tot de profielen die het balbezit van het team het best afmaken, waarbij acties vaak in gevaarlijke schoten eindigen.'
      },
      OutPlay1: {
        1: 'De speler heeft een minimale impact wanneer het gaat om het verstoren van defensieve structuren.'
      },
      OutPlay2: {
        1: 'De bijdrage aan progressie en het breken van verdedigingen ligt onder de standaarden voor de positie.'
      },
      OutPlay3: {
        1: 'In staat om af en toe voordelen te genereren, met een prestatie rond het gemiddelde voor de positie.'
      },
      OutPlay4: {
        1: 'Draagt vaak bij aan het breken van defensieve lijnen en het creëren van onevenwichtigheden.'
      },
      OutPlay5: {
        1: 'Behoort tot de profielen die in deze positie uitblinken in het uitschakelen van tegenstanders en het creëren van progressies.'
      },
      LineBreakingPasses1: {
        1: 'Er worden zelden passes geprobeerd of voltooid die defensieve lijnen breken; de bijdrage in dit soort acties is zeer beperkt.'
      },
      LineBreakingPasses2: {
        1: 'Er is moeite om consequent teamgenoten tussen de linies of achter de druk te vinden, wat onder de standaard voor de positie ligt.'
      },
      LineBreakingPasses3: {
        1: 'Er worden af en toe lijnbrekende passes geleverd, met een niveau rond het gemiddelde voor de positie.'
      },
      LineBreakingPasses4: {
        1: 'Laat vaak zien dat defensieve lijnen worden gebroken met passing, waardoor het blok van de tegenstander uit balans raakt.'
      },
      LineBreakingPasses5: {
        1: 'Behoort tot de meest effectieve passers in de competitie in het breken van lijnen en het ontgrendelen van druk; dit is een belangrijk sterk punt.'
      },
      PassUnderPressure1: {
        1: 'Het is zichtbaar moeilijk om rustig en effectief te blijven wanneer er druk van tegenstanders is.'
      },
      PassUnderPressure2: {
        1: 'Het behouden van passnauwkeurigheid onder hoge druk is ingewikkeld.'
      },
      PassUnderPressure3: {
        1: 'De prestatie bij passes onder druk ligt rond het gemiddelde; druk wordt redelijk verwerkt, al is de uitvoering niet altijd volledig zuiver.'
      },
      PassUnderPressure4: {
        1: 'Er worden vaak met succes teamgenoten gevonden ondanks druk, met een prestatie boven het gemiddelde in dit type passes.'
      },
      PassUnderPressure5: {
        1: 'Toont uitstekende rust en nauwkeurigheid in passing onder intense druk en behoort in dit aspect tot de best presterenden op de positie.'
      },
      BallReceived1: {
        1: 'Ontvangt zeer weinig passes in geavanceerde zones en opereert zelden constant tussen de linies.'
      },
      BallReceived2: {
        1: 'Verzamelt enkele ongemarkeerde ontvangsten op de helft van de tegenstander, maar zonder veel consistentie.'
      },
      BallReceived3: {
        1: 'Registreert een gemiddeld volume ongemarkeerde ontvangsten in aanvallende zones.'
      },
      BallReceived4: {
        1: 'Ontvangt vaak tussen de linies en in zones met weinig druk.'
      },
      BallReceived5: {
        1: 'Accumuleert veel ontvangsten tussen de linies, vrij van verdedigers en in potentieel beslissende zones.'
      },
      OnBallPressure1: {
        1: 'Er wordt zelden druk gezet en bijna nooit dicht bij de baldrager; de algemene intensiteit is laag.'
      },
      OnBallPressure2: {
        1: 'Neemt deel aan enkele sterke drukmomenten, maar niet vaak; de totale intensiteit blijft vrij laag.'
      },
      OnBallPressure3: {
        1: 'Registreert een gemiddeld volume drukacties dicht bij de tegenstander in balbezit.'
      },
      OnBallPressure4: {
        1: 'Gedisciplineerde drukker die regelmatig dicht bij de baldrager komt.'
      },
      OnBallPressure5: {
        1: 'Zeer intens zonder bal, gedisciplineerd en met veel arbeid om de tegenstander onder druk te zetten.'
      },
      SpatialCoverage1: {
        1: 'Er is slechts een zeer beperkte bijdrage aan ruimtebezetting en -controle, met minimale betrokkenheid bij formatie en tactische structuur. De ruimtedekking is zwak in zowel aanval als verdediging, met weinig invloed op organisatie en compactheid.'
      },
      SpatialCoverage2: {
        1: 'De ruimtedekking ligt onder het gemiddelde: er is wel deelname aan veldbezetting, maar met hiaten in positionele continuïteit en samenhang met de rest van het team. De invloed op de tactische structuur is onregelmatig en minder consistent dan bij beter gerangschikte spelers.'
      },
      SpatialCoverage3: {
        1: 'Gemiddelde ruimtedekking met een stabiele bijdrage aan ruimtebezetting en -controle. De positionering is over het algemeen correct en functioneel, met een gematigde impact in zowel aanvallende als verdedigende fases.'
      },
      SpatialCoverage4: {
        1: 'Ruimtedekking boven het gemiddelde, met grote betrokkenheid bij veldbezetting en positionele structuur. Het vermogen om vorm te behouden en zich aan transities aan te passen, helpt compactheid en controle van sleutelruimtes te versterken.'
      },
      SpatialCoverage5: {
        1: 'Uitstekende ruimtedekking, met geoptimaliseerde positionering die een beslissende invloed heeft op formatie en tactische structuur. Spelbegrip en synchronisatie met het blok zorgen voor maximale bezetting van strategische zones in zowel aanval als verdediging.'
      },
      OffBallPressure1: {
        1: 'De defensieve druk zonder bal is zeer beperkt; tegenstanders worden zelden gestoord of tot fouten gedwongen. De bijdrage aan pressing en de defensieve structuur is minimaal.'
      },
      OffBallPressure2: {
        1: 'De off-ball druk ligt onder het gemiddelde; tegenstanders worden af en toe benaderd maar met inconsistente timing of positionering. De impact op balherovering of het verstoren van de opbouw is gering.'
      },
      OffBallPressure3: {
        1: 'Toont een gemiddeld niveau in druk zonder bal en levert een stabiele bijdrage aan de defensieve inspanningen. Positionering en timing zijn overwegend effectief en beperken de opties van de tegenstander.'
      },
      OffBallPressure4: {
        1: 'Biedt off-ball druk boven het gemiddelde, verstoort vaak de acties van tegenstanders en vermindert hun tijd en ruimte. De inspanningen zijn goed gecoördineerd en helpen de defensieve structuur te behouden.'
      },
      OffBallPressure5: {
        1: 'Excelleert in defensieve druk zonder bal, jaagt tegenstanders voortdurend op, beperkt passlijnen en dwingt balverlies af. Intensiteit, positionering en anticipatie verhogen de defensieve effectiviteit van het team aanzienlijk.'
      },
      Distance1: {
        1: 'Er wordt aanzienlijk minder terrein gedekt dan gemiddeld; de beweging over het veld is zeer beperkt.'
      },
      Distance2: {
        1: 'De afgelegde afstand per wedstrijd ligt onder wat gebruikelijk is op topniveau; de activiteit is lager dan die van de gemiddelde speler.'
      },
      Distance3: {
        1: 'De speler legt een redelijke afstand af, met cijfers rond het competitiegemiddelde; de fysieke betrokkenheid is in balans.'
      },
      Distance4: {
        1: 'Er wordt consequent veel afstand afgelegd, met cijfers die sterk uithoudingsvermogen weerspiegelen en een hoge fysieke output.'
      },
      Distance5: {
        1: 'Het fysieke volume is uitstekend; qua afgelegde afstand behoort de speler tot de actiefsten in de top 5 competities.'
      },
      Sprint1: {
        1: 'Er worden aanzienlijk minder sprints aan hoge snelheid uitgevoerd dan gemiddeld; de sprintbelasting over wedstrijden is minimaal.'
      },
      Sprint2: {
        1: 'De sprintfrequentie ligt onder het gemiddelde voor de positie, met beperkte explosiviteit in acties op hoge snelheid.'
      },
      Sprint3: {
        1: 'Er wordt een gemiddeld aantal sprints per wedstrijd geleverd, met waarden rond het competitiegemiddelde.'
      },
      Sprint4: {
        1: 'Valt op door een sprintfrequentie ruim boven het gemiddelde, met een constante explosieve bijdrage op hoge snelheid.'
      },
      Sprint5: {
        1: 'Behoort tot de top 20% van spelers met het hoogste aantal sprints per 90 minuten en laat topfysieke prestaties zien in herhaalde acties op hoge snelheid.'
      },
      Acceleration1: {
        1: 'Het vermogen om van tempo te wisselen ligt duidelijk onder het gemiddelde; er worden zelden explosieve versnellingen uitgevoerd.'
      },
      Acceleration2: {
        1: 'De frequentie van korte, explosieve versnellingen blijft beperkt en ligt onder het niveau van vergelijkbare profielen.'
      },
      Acceleration3: {
        1: 'Registreert een redelijk aantal versnellingen, dicht bij het competitiegemiddelde; tempowisselingen vallen niet sterk op, maar de cijfers zijn correct.'
      },
      Acceleration4: {
        1: 'Toont een sterk vermogen om snel en herhaaldelijk te versnellen, met een versnellingspercentage duidelijk boven het gemiddelde.'
      },
      Acceleration5: {
        1: 'Behoort tot de top 20% meest explosieve spelers in herhaalde versnellingen, met cijfers die ruim boven het gemiddelde liggen in starts en tempowisselingen.'
      },
      Speed1: {
        1: 'De topsnelheid ligt laag of hoge intensiteit wordt sterk gespaard tijdens wedstrijden.'
      },
      Speed2: {
        1: 'De geregistreerde topsnelheid ligt net onder het competitieve gemiddelde.'
      },
      Speed3: {
        1: 'De topsnelheid blijft gedurende de wedstrijd rond het gemiddelde.'
      },
      Speed4: {
        1: 'Er worden regelmatig hoge snelheden bereikt, wat wijst op een combinatie van snelheid en kracht.'
      },
      Speed5: {
        1: 'Er worden zeer hoge topsnelheden geregistreerd; de speler kan in tempo een duidelijk verschil maken.'
      },
      LineBreakingCarries1: {
        1: 'Er worden zelden lijnen doorbroken met baldragen; er ontbreekt initiatief om met de bal vooruit te gaan.'
      },
      LineBreakingCarries2: {
        1: 'Er zijn enkele baldragen die lijnen doorbreken, maar zonder grote regelmaat.'
      },
      LineBreakingCarries3: {
        1: 'Er is een gematigd aantal succesvolle lijnbrekende baldragen.'
      },
      LineBreakingCarries4: {
        1: 'Draagt bij aan de opbouw door regelmatig voorbij linies te dribbelen en progressie te ondersteunen.'
      },
      LineBreakingCarries5: {
        1: 'Een echte specialist in baldragen, die voortdurend en in hoog volume lijnen doorbreekt met de bal.'
      },
      LineBreakingActions1: {
        1: 'Er worden zeer weinig lijnbrekende acties geregistreerd (passes en baldragen) en er wordt zelden risico genomen.'
      },
      LineBreakingActions2: {
        1: 'Produceert enkele progressieve acties (passes en baldragen), maar niet vaak; er is een neiging tot meer horizontaal spel.'
      },
      LineBreakingActions3: {
        1: 'Combineert passes en baldragen die regelmatig lijnen breken en zo bijdragen aan progressie.'
      },
      LineBreakingActions4: {
        1: 'Technisch en tactisch vaardig om veel acties (passes en baldragen) te produceren die defensieve lijnen doorbreken.'
      },
      LineBreakingActions5: {
        1: 'Een specialist in vooruitgang met de bal; breekt constant lijnen via passes en baldragen en heeft grote impact op het team.'
      },
      OffBallRuns1: {
        1: 'Er worden zeer weinig doelgerichte loopacties zonder bal gemaakt, met een beperkte ondersteuning van de aanval. De bewegingen dragen zelden bij aan ruimtecreatie, het breken van defensieve lijnen of betere teamcoördinatie in balbezit.'
      },
      OffBallRuns2: {
        1: 'De off-ball beweging ligt onder het gemiddelde; er is af en toe ondersteuning van de aanval, maar zonder consistente timing, richting of intentie. De impact op het openen van ruimtes of het verbeteren van de aanvallende structuur is beperkt.'
      },
      OffBallRuns3: {
        1: 'Toont een gemiddeld niveau aan doelgerichte off-ball runs, met een stabiele bijdrage aan de aanvallende fase. Bewegingen zijn meestal goed getimed en functioneel, creëren ruimte en ondersteunen het teamspel met een gematigde impact.'
      },
      OffBallRuns4: {
        1: 'Laat boven gemiddelde off-ball activiteit zien, met veel doelgerichte loopacties die defensieve structuren verstoren, passlijnen openen en aanvallende ruimtes creëren. De bewegingspatronen dragen aanzienlijk bij aan de coördinatie van het team in balbezit.'
      },
      OffBallRuns5: {
        1: 'Excelleert in doelgerichte bewegingen zonder bal, anticipeert goed op het spel en maakt intelligente loopacties die aanvallende kansen maximaliseren. Timing, positionering en ruimtelijk bewustzijn zorgen voor constante dreiging en verbeteren de vloeiendheid van het teamspel in balbezit.'
      },
      OverMaxValue: {
        1: 'Beschikt over een extreme vaardigheid in over_max_metric_name, met een prestatie boven de maximumwaarde, wat de speler in dat aspect in de top 10% van de top 5 competities plaatst.'
      },
      OverAverageSeason: {
        1: 'Wat betreft de prestatie in over_average_metric_name ligt het niveau boven het competitiegemiddelde in league_name (over_average_metric_value vs average_metric_value).',
        2: 'Bij vergelijking van de cijfers met die van de competitie league_name in over_average_metric_name, is de prestatie duidelijk hoger dan het gemiddelde (over_average_metric_value vs average_metric_value).'
      },
      UnderMinValue: {
        1: 'Wat betreft under_min_metric_name is er een duidelijke noodzaak tot verbetering, aangezien de prestatie in de laagste percent_metric_name van de top 5 competities valt.'
      },
      Over70Percent: {
        1: ', valt vooral op in over_70_metric_name met over_70_metric_value per 90 minuten, respectievelijk',
        2: ', boven 70% in over_70_metric_name met over_70_metric_value per 90 minuten, respectievelijk',
        3: ', levert een zeer opvallende bijdrage in over_70_metric_name met over_70_metric_value per 90 minuten, respectievelijk'
      },
      Under30Percent: {
        1: ', moet harder werken in under_30_metric_name omdat de prestatie met under_30_metric_value per 90 minuten, respectievelijk, laag is',
        2: ', moet duidelijk verbeteren in under_30_metric_name omdat de prestatie met under_30_metric_value per 90 minuten, respectievelijk, onder de verwachting ligt',
        3: ', wat betreft under_30_metric_name met under_30_metric_value per 90 minuten respectievelijk, is extra inspanning nodig om betere cijfers te halen'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Het is belangrijk om de prestatie te benadrukken die het competitiegemiddelde in league_name overtreft in '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value gemiddeld)'
      },
      Over70PercentIndividualPressure: {
        1: ', oefent zeer goede individuele druk uit om de bal te herwinnen',
        2: ', zet hoge druk op de tegenstander om de bal terug te veroveren'
      },
      Under30PercentIndividualPressure: {
        1: ', moet de intensiteit in de druk opvoeren om de bal terug te winnen',
        2: ', moet meer inspanning leveren in het onder druk zetten van de tegenstander'
      }
    },
    himSelf: 'zichzelf',
    ownSeason: 'Eigen seizoen',
    minMaxTooltip: 'Pas de minimum- en maximumwaarden van de radar aan',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Inloggen',
    latestBlogPosts: 'Laatste Blog Berichten',
    signIn: 'Inloggen',
    username: 'Gebruikersnaam',
    password: 'Wachtwoord',
    passwordForgotten: 'Wachtwoord Vergeten',
    signUp: 'Registreren',
    enter: 'Invoeren',
    forceTitle: 'Account in gebruik',
    forceMessage: 'Het account is al verbonden op een ander apparaat. Wil je het eruit gooien en verbinden op dit apparaat?',
    forgotMyPassword: 'Mijn wachtwoord vergeten',
    firstLogin: 'Eerste Inloggen',
    firstLoginMessage: 'Om veiligheidsredenen moet je een nieuw wachtwoord instellen bij je eerste inloggen. Daarnaast een voorkeurstaal om de app te bekijken',
    firstLoginOverview: 'Hier is een overzicht van je account, de competities en producten waar je toegang toe hebt.',
    passwordConfirmation: 'Wachtwoord Bevestiging',
    forgotPasswordMessage: 'Typ je e-mail, als er een geldig account gekoppeld is aan de e-mail ontvang je in je inbox de volgende stappen om je wachtwoord te resetten',
    resetPassword: 'Wachtwoord Resetten',
    resetPasswordLinkInvalid: 'Deze link is ongeldig of verlopen. Vraag een nieuwe wachtwoordreset aan vanaf de inlogpagina.',
    skipSettings: 'Instellingen overslaan',
    contact: 'Contact',
    cookiesText: 'Deze site gebruikt Google cookies om zijn diensten te leveren en je verkeer te analyseren om de kwaliteit van de service te waarborgen, gebruiksstatistieken te genereren en misbruik te detecteren en aan te pakken.',
    contactUs: 'Neem Contact Op',
    newsTitle: 'Nieuw: Fysieke scores!',
    newsText: 'We hebben twee nieuwe scores voor fysieke prestaties toegevoegd naast onze oorspronkelijke score op basis van event-data: <b>Uithoudingsscore</b> en <b>Snelheids- & Krachtscore</b>.<br> Uithoudingsvermogen benadrukt spelers die consequent veel terrein bestrijken en hoge werklasten volhouden, terwijl Snelheid & Kracht zich richt op topsnelheid, sprints en explosieve versnellingen.'
  },
  settings: {
    pageSubtitle: 'Stel je applicatie-ervaring in',
    language: 'Taal',
    availableLeagues: 'Beschikbare Competities',
    availableSeasons: 'Beschikbare Seizoenen',
    availableProducts: 'Beschikbare Producten',
    organization: 'Bedrijf',
    changePassword: 'Wachtwoord Wijzigen',
    seasonTemplates: 'Seizoen Sjablonen',
    seasonTemplatesSubtitle: 'Maak je eigen seizoen sjablonen die later beschikbaar zijn om te selecteren in Spelersranking en Spelerscout',
    templateName: 'Sjabloon Naam',
    selectTemplate: 'Selecteer bestaand sjabloon om te bewerken',
    radarDefault: 'Standaard Radar',
    default: 'Standaard',
    tabs: {
      options: 'Opties',
      templates: 'Sjablonen',
      availableLeagues: 'Beschikbare Competities',
      contactData: 'GBE Contactgegevens'
    },
    contactData: {
      userDetails: 'Gebruikersgegevens',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      contactDetails: 'Contactgegevens voor GBE',
      name: 'Naam',
      phone: 'Telefoon',
      mobile: 'Mobiel',
      email: 'E-mail',
      representativeDetails: 'Vertegenwoordiger Gegevens voor GBE'
    },
    currency: 'Valuta',
    fieldPreferences: 'Veld Voorkeuren',
    visualizationsPreferences: 'Visualisatie Voorkeuren',
    fieldColor: 'Veld Kleur',
    fieldColors: {
      green: 'Groen',
      blue: 'Blauw',
      white: 'Wit',
      black: 'Zwart',
      grey: 'Grijs'
    },
    defaultPlayerVisualization: 'Standaard Speler Visualisatie',
    appPreferences: 'Applicatie Voorkeuren',
    darkMode: 'Donkere Modus',
    showTour: 'Toon Geleide Tour',
    customStats: 'Aangepaste Statistieken',
    radarTemplates: 'Radar Sjablonen',
    radarTemplatesSubtitle: 'Maak je eigen metrische sjablonen die later beschikbaar zijn om te selecteren in Radars en Ranking',
    radarCategories: {
      Custom1: 'Aangepast 1',
      Custom2: 'Aangepast 2',
      Custom3: 'Aangepast 3',
      Custom4: 'Aangepast 4',
      Custom5: 'Aangepast 5',
      Custom6: 'Aangepast 6',
      Physical: 'Fysiek',
      CustomPhysical1: 'Aangepast Fysiek 1',
      CustomPhysical2: 'Aangepast Fysiek 2',
      CustomPhysical3: 'Aangepast Fysiek 3',
      CustomPhysical4: 'Aangepast Fysiek 4',
      CustomPhysical5: 'Aangepast Fysiek 5',
      CustomPhysical6: 'Aangepast Fysiek 6'
    },
    templateRemoveTitle: 'Sjabloon Verwijderen',
    templateRemoveMsg: 'Wil je dit sjabloon verwijderen?',
    templateEditTitle: 'Sjabloon Opslaan',
    templateEditMsg: 'Er is een niet-opgeslagen sjabloon, wil je het opslaan voordat je een ander sjabloon laadt?',
    category: 'Categorie',
    playerRadar: 'Speler Radar',
    teamRadar: 'Team Radar',
    statsAlert: 'Voeg ten minste één statistiek toe om op te slaan',
    recommended: 'Aanbevolen',
    warning: 'Er zijn posities die het maximum aantal toegestane radars hebben bereikt. Verwijder of bewerk een sjabloon',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spaans',
      numeric: 'Numeriek'
    },
    showMediaMode: 'Toon Media Modus',
    statTemplates: 'Statistiek Sjablonen',
    statTemplatesSubtitle: 'Maak je eigen statistiek sjabloon door te kiezen uit verschillende metrieken',
    ratingFormat: {
      ratingFormat: 'Beoordelingsformaat',
      numbers: 'Nummers',
      letters: 'Brieven A-F'
    }
  },
  playerDetail: {
    passport: 'Paspoort',
    secondPassport: 'Tweede Paspoort',
    age: 'Leeftijd',
    dateOfBirth: 'Geboortedatum',
    height: 'Lengte',
    weight: 'Gewicht',
    wage: 'Loon',
    history: 'Geschiedenis',
    positions: 'Posities',
    injuries: 'Blessures',
    transfers: 'Transfers',
    nationalTeam: 'Nationaal Team',
    addFavorite: 'Toevoegen aan favorieten',
    removeFavorite: 'Verwijderen uit favorieten',
    contractEnd: 'Contract Einde',
    yearsOld: ' jaar oud',
    playerAvailability: 'Beschikbaarheid',
    playerUsage: 'Gespeelde Minuten',
    usage: 'Gebruik',
    addToCollection: 'Toevoegen aan collectie',
    performance: 'Prestatie',
    info: 'Info',
    career: 'Carrière',
    playerStyle: 'Spelerstijl',
    radar: 'Radar',
    finishingMap: 'Afwerking Kaart',
    threatMap: 'Bedreiging Kaart',
    keyPassMap: 'Sleutelpass Kaart',
    beeswarm: 'Ranking',
    allGames: 'Alle Wedstrijden',
    eventsMap: 'Gebeurtenissen Kaart',
    lbpMap: 'Lijnbrekende passen',
    obpMap: 'Over baldruk',
    pupMap: 'Gaat onder druk door',
    obrMap: 'Balontvangsten',
    fullName: 'Volledige Naam',
    academy: 'Academie',
    name: 'Naam',
    lastName: 'Achternaam',
    playerAvailabilityLong: '% van het seizoen zonder blessures of schorsingen',
    playerUsageLong: 'Gespeelde Minuten',
    playerAvailability1: 'wedstrijden zonder blessures of schorsingen',
    playerAvailability2: 'wedstrijden dit seizoen',
    playerUsage1: 'gespeelde minuten',
    playerUsage2: 'totale team minuten',
    notMinutesThisSeason: 'Heeft geen minuten gespeeld dit seizoen',
    seasonPlaceholder: 'Er is geen actief seizoen',
    inactivePlayer: 'Inactieve Speler',
    inactivePlayerMessage: 'Als je meer informatie nodig hebt, kun je een rapport aanvragen',
    goRequest: 'Ga Naar Aanvraag',
    warningMinutes: 'Waarschuwing: Minder dan 450 minuten gespeeld, analyse is mogelijk niet representatief',
    scoreWarningMinutes: 'Spelers met minstens 450 totaal gespeelde minuten',
    pdScoreWarningMinutes: 'Spelers met minstens 450 totaal gespeelde minuten (minimaal 60 minuten per wedstrijd)',
    warningSeasonGames: 'Seizoen heeft minder dan 5 wedstrijden gespeeld, dus Min & Max zijn \'Top 5 Competities\'',
    warningStatsRemoved: 'Sommige statistieken worden niet getoond omdat ze niet beschikbaar zijn voor het geselecteerde seizoen',
    warningBeeswarm: 'Speler niet getoond omdat er geen data is voor deze statistiek in het geselecteerde seizoen',
    warningPlayersZeroValue: 'Toont {x} spelers niet met 0 ',
    onlyPlayersThatFit: 'Alleen Spelers die passen in Radar Sjabloon',
    gamesPlayedNotEnough: 'Opties uitgeschakeld vanwege onvoldoende gespeelde wedstrijden',
    gbe: 'GBE',
    analysis: 'Analyse',
    documents: 'Documenten',
    rankDefensive: 'Defensief',
    rankBallHandling: 'Balbehandeling',
    rankGoal: 'Doelpunt Bijdrage',
    rankXt: 'Bedreiging',
    rankIndex: 'Index',
    visitHistory: 'Bezoek Geschiedenis',
    placer: 'Veld',
    touchesMap: 'Aanrakingen kaart',
    heatMap: 'Warmte Kaart',
    ageProfile: 'Leeftijdsprofiel',
    strongFoot: 'Sterke voet',
    player: 'Speler',
    outOf: 'van de',
    in: 'in',
    radius: 'Radius',
    blur: 'Vervaging',
    careerTable: {
      nationalTeamCareer: 'Nationaal Team Carrière',
      nationalTeamCompetitions: 'Nationaal Team Competities'
    },
    physicalProgression: 'Fysieke Progressie',
    gpi: 'Globale Speler Index',
    warningGPI: 'Alleen beschikbaar voor spelers actief in ELO competities in de afgelopen 30 dagen',
    diffGPI: 'Variatie van laatste wedstrijd',
    rankingInTheWorld: '#{0} in de wereld',
    rankingInTheLeague: '#{0} in {1}',
    max: 'Max',
    gpiChart: 'Grafiek gebaseerd op de Globale Speler Index waarde van de laatste {0} wedstrijden',
    percentileRange: 'Percentielen {0} tot {1}',
    months: 'maanden',
    month: 'maand',
    contractExpOver4Years: 'Contract loopt af over',
    contractExpSoon: 'Contract loopt binnenkort af',
    contractFinalYear: 'Laatste jaar van het contract',
    freeAgent: 'Vrije agent',
    gpiDescription: 'De Global Player Index (GPI) is een gestandaardiseerd spelersbeoordelingssysteem dat voetballers evalueert op basis van hun teamsterkte, tegenstandersterkte, wedstrijdprestaties en beschikbaarheid. Geïnspireerd door het Elo-beoordelingssysteem, zorgt het ervoor dat spelersbeoordelingen de werkelijke competitieve omgeving weerspiegelen in plaats van willekeurige basislijnen.',
    turnoversMap: 'Omzet- en herstelkaart',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Succesvolle aanrakingen',
    unsuccessfulTouch: 'Mislukte aanrakingen',
    showLegend: 'Toon legenda'
  },
  finishingMap: {
    typesOfShot: 'Soorten Schoten',
    shotStrategy: 'Schot Strategie',
    strategiesCount: '{count} strategieën',
    areas: 'Gebieden',
    bodyPart: 'Lichaamsdeel',
    more: 'meer',
    selectAll: 'Alles Selecteren',
    minutes: 'Minuten',
    circles: 'Cirkels',
    boxes: 'Heatmap van het strafschopgebied',
    lines: 'Lijnen',
    games: 'Wedstrijden',
    perShot: 'per Schot',
    goal: 'Doelpunt',
    missedShot: 'Gemist Schot',
    savedShot: 'Gered Schot',
    shotOnPost: 'Schot op Paal',
    missedChance: 'Gemiste Kans',
    openPlay: 'Open Spel',
    regularPlay: 'Regulier Spel',
    fastBreak: 'Snelle Omschakeling',
    individualPlay: 'Individueel Spel',
    setPiece: 'Vaste Situatie',
    fromCorner: 'Van Hoekschop',
    freeKick: 'Vrije Trap',
    indirectFreeKick: 'Indirecte Vrije Trap',
    throwInSetPiece: 'Inworp Vaste Situatie',
    inBox: 'In Zestienmetergebied',
    goalArea: 'Zesmetergebied',
    boxLeft: 'Zestienmetergebied Links',
    boxCenter: 'Zestienmetergebied Midden',
    boxRight: 'Zestienmetergebied Rechts',
    outOfBox: 'Buiten Zestienmetergebied',
    outBoxDeepLeft: 'Buiten Zestienmetergebied Diep Links',
    outBoxDeepRight: 'Buiten Zestienmetergebied Diep Rechts',
    outBoxLeft: 'Buiten Zestienmetergebied Links',
    outBoxCentreLeft: 'Buiten Zestienmetergebied Midden Links',
    outBoxCentre: 'Buiten Zestienmetergebied Midden',
    outBoxCentreRight: 'Buiten Zestienmetergebied Midden Rechts',
    outBoxRight: 'Buiten Zestienmetergebied Rechts',
    left35: '+35 Links',
    centreLeft35: '+35 Midden Links',
    centre35: '+35 Midden',
    centreRight35: '+35 Midden Rechts',
    right35: '+35 Rechts',
    head: 'Hoofd',
    rightFooted: 'Rechtsvoetig',
    leftFooted: 'Linksvoetig',
    otherBodyPart: 'Ander Lichaamsdeel',
    chart: {
      shots: 'Schoten',
      xGPerShot: 'xG per Schot',
      exceptionTextPenaltyGoals: '* Penaltyschoten = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Penaltyschoten = 0.765 xGOT',
      exceptionTextOwnGoals: '* Eigen Doelpunten niet meegerekend',
      og: 'ED',
      penaltiesExcluded: 'Penalty Doelpunten Uitgesloten',
      ownGoalsExcluded: 'Eigen Doelpunten Uitgesloten',
      sumOfxG: 'Som van xG',
      exceptionShotsOutOfRange: '* Toont geen schoten buiten bereik'
    },
    inGoal: 'In Doel',
    outOfGoal: 'Buiten Doel',
    highLeft: 'Hoog Links',
    highCenter: 'Hoog Midden',
    highRight: 'Hoog Rechts',
    lowLeft: 'Laag Links',
    lowCenter: 'Laag Midden',
    lowRight: 'Laag Rechts',
    outHighLeft: 'Buiten Hoog Links',
    high: 'Buiten Hoog Midden',
    outHighRight: 'Buiten Hoog Rechts',
    closeHighLeft: 'Dichtbij Hoog Links',
    closeHigh: 'Dichtbij Hoog Midden',
    closeHighRight: 'Dichtbij Hoog Rechts',
    closeLeft: 'Dichtbij Laag Links',
    closeRight: 'Dichtbij Laag Rechts',
    finishingTable: 'Afwerking Tabel',
    onGoal: 'Op Doel',
    distributionFilters: 'Verdeling Filters',
    penalty: 'Penalty',
    penaltyShootout: 'Penalty Serie',
    onlyPercentage: 'Toon Percentage',
    showAll: 'Toon Alles',
    chanceMissed: 'Kans gemist'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Sleutelpasses',
      xAPerPass: 'xA per Pass',
      xAOpenPlay: 'xA Open Spel',
      xASetPiece: 'xA Vaste Situatie'
    }
  },
  beeswarm: {
    template: 'Sjabloon',
    templates: {
      Goalkeeper: 'Doelman',
      Defender: 'Verdediger',
      'Full-Back': 'Vleugelverdediger',
      FullBack: 'Vleugelverdediger',
      'Wing-Back': 'Vleugelverdediger',
      WingBack: 'Vleugelverdediger',
      Midfielder: 'Middenvelder',
      AttackingMidfielder: 'Aanvallende-Middenvelder',
      Winger: 'Vleugelspeler',
      Forward: 'Aanvaller',
      Physical: 'Fysiek'
    },
    compareWith: 'Vergelijk met',
    highlightPlayersOf: 'Markeer Spelers van',
    highlightPlayers: 'Markeer Spelers',
    per90: 'Gegevens per 90 minuten',
    highlightTeams: 'Markeer Teams',
    filterTeams: 'Filter Teams',
    warningZeros: 'Alleen voor niet-omgekeerde statistieken'
  },
  collections: {
    newCollection: 'Nieuwe collectie',
    editCollection: 'Collectie bewerken',
    name: 'Naam',
    visibility: 'Zichtbaarheid',
    privacity: {
      publicTitle: 'Openbaar',
      publicDescription: 'Zichtbaar voor jou en je club',
      privateTitle: 'Privé',
      privateDescription: 'Alleen zichtbaar voor jou',
      supervisedTitle: 'Begeleid',
      supervisedDescription: 'Alleen zichtbaar voor jou en je supervisor'
    },
    addSuccess: 'Succesvol toegevoegd',
    createAddSuccess: 'Aangemaakt en succesvol toegevoegd',
    editSuccess: 'Succesvol bijgewerkt',
    deleteSuccess: 'Succesvol verwijderd',
    title: 'Collecties van spelers',
    publics: 'Openbaar',
    privates: 'Privé',
    supervised: 'Begeleid',
    totalMarketValue: 'Totale marktwaarde',
    avgMarketValue: 'Gemiddelde marktwaarde',
    avgAge: 'Gemiddelde leeftijd',
    searchBarPlaceholder: 'Om toe te voegen aan de collectie, zoek en kies spelers',
    deleteCollection: 'Collectie verwijderen',
    deleteCollectionMessage: 'Collectie wordt verwijderd, weet je het zeker?',
    removePlayer: 'Speler verwijderen',
    removePlayerMessage: 'Speler wordt verwijderd uit collectie, weet je het zeker?',
    subtitle: 'Organiseer je scouting',
    notExitingTemplate: 'Er zijn nog geen sjablonen'
  },
  searchbar: {
    placeholder: 'Typ om te zoeken (bijv. `david arsenal´)',
    players: 'Spelers',
    teams: 'Teams',
    games: 'Wedstrijden',
    leagues: 'Competities',
    explore: 'Verken meer resultaten',
    placeholderNoResults: 'Geen resultaten voor sjabloon',
    teamPlaceholder: 'Om een team te vergelijken, zoek en selecteer het'
  },
  favorites: {
    showOnly: 'Toon alleen',
    selfFavorites: 'Mijn favorieten',
    clubFavorites: 'Club favorieten',
    contractExpiration: 'Contract afloop',
    groupBy: 'Groepeer op',
    noGrouped: 'Geen',
    maxSelection: 'Kan alleen selecteren',
    selectAtleastOne: 'Selecteer ten minste één',
    comparePlayers: 'Vergelijk spelers',
    selectedPlayers: 'spelers geselecteerd',
    subtitle: 'Beheer je favorieten',
    generateXlsx: 'Genereer XLSX',
    generating: 'Genereren...',
    subscribed: 'Geabonneerd',
    subscribedTooltip: 'Abonneer om een e-mail te ontvangen wanneer een wedstrijd is gespeeld',
    deleteSelected: 'Geselecteerde verwijderen'
  },
  expiration: {
    summer: 'Zomer',
    winter: 'Winter'
  },
  positions: {
    noposition: 'Geen Positie',
    goalkeeper: 'Doelman',
    goalkeepers: 'Doelmannen',
    defender: 'Verdediger',
    defenders: 'Verdedigers',
    defenses: 'Verdedigers',
    fullback: 'Vleugelverdediger',
    fullbacks: 'Vleugelverdedigers',
    midfielder: 'Middenvelder',
    midfielders: 'Middenvelders',
    winger: 'Vleugelspeler',
    wingers: 'Vleugelspelers',
    forward: 'Aanvaller',
    forwards: 'Aanvallers',
    wingback: 'Vleugelverdediger',
    wingbacks: 'Vleugelverdedigers'
  },
  dPos: {
    1: {
      name: 'Doelman',
      alias: ''
    },
    2: {
      name: 'Rechts Vleugelverdediger',
      alias: 'RV'
    },
    3: {
      name: 'Rechts Centraal Verdediger',
      alias: 'RCV'
    },
    4: {
      name: 'Links Centraal Verdediger',
      alias: 'LCV'
    },
    5: {
      name: 'Links Vleugelverdediger',
      alias: 'LV'
    },
    6: {
      name: 'Defensieve Middenvelder',
      alias: 'DM'
    },
    7: {
      name: 'Rechts Vleugelspeler',
      alias: 'RV'
    },
    8: {
      name: 'Centraal Middenvelder',
      alias: 'CM'
    },
    9: {
      name: 'Spits',
      alias: 'ST'
    },
    10: {
      name: 'Aanvallende Middenvelder',
      alias: 'AM'
    },
    11: {
      name: 'Links Vleugelspeler',
      alias: 'LV'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Vergelijk met',
    lastSeasonSelectText: 'Laatste Seizoen',
    lastAndCurrentSeasonSelectText: 'Laatste + Huidige Seizoen',
    currentSeasonSelectText: 'Huidige Seizoen',
    lastNgamesSelectText: 'Laatste {x} wedstrijden',
    npgVsXGTitle: 'Niet-Penalty Doelpunten VS xG',
    totalXGLabel: 'Totaal xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Totaal Niet-Penalty Doelpunten',
    xGAgainstvsNPGAgainstTitle: 'xG Tegen VS Niet-Penalty Doelpunten Tegen',
    totalXGAgainstLabel: 'Totaal xG Tegen',
    xGAgainstLabel: 'xG Tegen',
    totalNPGAgainstLabel: 'Totaal Niet-Penalty Doelpunten Tegen',
    xGvsxGAgainstTitle: 'xG VS xG Tegen',
    pointsVsXPointsTitle: 'Punten VS Verwachte Punten',
    xTTitle: 'Spelverloop',
    totalXPoints: 'Totaal xPunten',
    totalPoints: 'Totaal Punten',
    requestedReports: 'Aangevraagde Rapporten',
    playersScouted: 'Spelers Gescout',
    performanceVSAverageChart: 'Prestatie VS Gemiddelde',
    perPositions: 'Per Posities',
    perLeagues: 'Per Competities',
    perMonths: 'Per Maanden',
    perClients: 'Per Klanten',
    ofPreposition: 'van',
    idJChartTitle: 'Spel Initiatief',
    idJChartLabel: 'Index SI',
    vJOChartTitle: 'Offensief Spel Volume',
    vJOChartLabel: 'Index OSV',
    preJOChartTitle: 'Offensief Spel Precisie',
    preJOChartLabel: 'Index OSP',
    proJOChartTitle: 'Offensief Spel Progressie',
    proJOChartLabel: 'Index OSP',
    chart: 'Grafiek',
    table: 'Tabel',
    showLeaguesWithAtLeast: 'Toon competities met ten minste',
    playersScoutedSuffix: 'spelers gescout'
  },
  table: {
    history: {
      season: 'Seizoen',
      team: 'Team',
      position: 'Positie',
      side: 'Kant',
      games: 'Wedstrijden',
      minutes: 'Min',
      goals: 'NPD (D)',
      assists: 'A',
      yellowCards: 'GK',
      redCards: 'RK',
      gameLost: 'GW',
      gamesMissed: 'Wedstrijden Gemist',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Seizoen',
      team: 'Team',
      injury: 'Blessure',
      dateFrom: 'Start Datum',
      dateTo: 'Eind Datum',
      daysLost: 'Dagen Verloren',
      gamesLost: 'Wedstrijden Verloren',
      allInjuries: 'Alle Blessures'
    },
    transfers: {
      season: 'Seizoen',
      date: 'Datum',
      teamFrom: 'Team Van',
      teamTo: 'Team Naar',
      marketValue: 'Marktwaarde',
      fee: 'Bedrag',
      type: 'Type'
    },
    caps: {
      team: 'Team',
      debut: 'Debuut',
      games: 'Wedstrijden',
      goals: 'Doelpunten',
      coachDuringDebut: 'Coach Tijdens Debuut',
      debutAge: 'Debuut Leeftijd'
    },
    roster: {
      country: 'Land',
      player: 'Speler',
      positions: 'Posities',
      minutes: 'Minuten',
      games: 'Wedstrijden',
      goals: 'Doelpunten',
      assists: 'Assists',
      cards: 'Kaarten',
      gamesExplicit: 'Wedstrijden Gespeeld'
    },
    league: {
      title: 'Competitie Overzicht',
      subtitle: 'Ga dieper in op de ranking en statistieken van de competitie',
      team: 'Team',
      games: 'WP',
      gamesExplicit: 'Wedstrijden Gespeeld',
      gamesRanking: 'WP',
      gamesRankingExplicit: 'Wedstrijden Gespeeld',
      points: 'Ptn',
      pointsExplicit: 'Punten',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Verwachte Punten',
      goalsScored: 'NPD',
      goalsScoredExplicit: 'Niet-Penalty Doelpunten',
      xG: 'xG',
      xGExplicit: 'Verwachte Doelpunten',
      goalsAgainst: 'NPDT',
      goalsAgainstExplicit: 'Niet-Penalty Doelpunten Tegen',
      xGAgainst: 'xGT',
      xGAgainstExplicit: 'Verwachte Doelpunten Tegen',
      xGAgainstDiff: 'xGT Diff',
      xGAgainstDiffExplicit: 'Verwachte Doelpunten Tegen Verschil',
      form: 'Form',
      sos: 'SoS',
      sosExplicit: 'Sterkte van Schema',
      sosHfa: 'SoS THV',
      sosHfaExplicit: 'Thuisvoordeel',
      difficultyAboveAvg: 'Moeilijkheid boven gemiddelde',
      differentGames: '* Verschillend Aantal Gespeelde Wedstrijden',
      berth: 'Plek'
    },
    usersOfClient: {
      userName: 'Naam',
      userRole: 'Gebruiker',
      devRole: 'Dev',
      adminRole: 'Admin',
      servicesRole: 'Services',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Elftallen',
      similarityRole: 'Gelijkwaardigheid',
      gameAnalysisRole: 'Wedstrijdanalyse',
      clientStatsRole: 'Klant Statistieken',
      created: 'Aangemaakt',
      type: 'Type',
      logins: 'Inloggen',
      lastLogin: 'Laatste Inloggen',
      trialDate: 'Proef Datum'
    },
    clientLeagues: {
      league: 'Competitie',
      area: 'Gebied',
      tier: 'Niveau',
      seasons: 'Seizoenen',
      currentMatchDay: 'Speeldag',
      regular: 'Regulier',
      youthLeague: 'Jeugd',
      clientActive: 'Actief',
      visibleLeagues: 'Zichtbare Competities',
      male: 'Heren competitie',
      female: 'Damescompetitie'
    },
    connections: {
      title: 'Veelvoorkomende Combinaties',
      playerFrom: 'Van Speler',
      playerTo: 'Naar Speler',
      passes: 'Passes',
      passesTooltip: 'Totaal Aantal Succesvolle Passes',
      passesFinalThird: 'PF ⅓',
      passesFinalThirdTooltip: 'Passes Laatste Derde'
    },
    playerPassMapData: {
      title: 'Pass Statistieken',
      player: 'Speler',
      passes: 'Passes',
      passesPct: '% Passes',
      xA: 'xA',
      xG: 'xG',
      xT: 'xBedreiging',
      playerTooltip: 'Naam van Speler',
      passesTooltip: 'Totaal Aantal Passes',
      passesPctTooltip: '% Succesvolle Passes',
      xATooltip: 'Verwachte Assists',
      xGTooltip: 'Verwachte Doelpunten',
      xTTooltip: 'Verwachte Bedreiging'
    },
    playerAllGames: {
      gameDate: 'Datum',
      game: 'Wedstrijd',
      team: 'Team',
      positionsPlayed: 'Posities',
      minsPlayed: 'Minuten',
      gameActions: 'Acties',
      gameDateTooltip: 'Wedstrijd Datum',
      gameTooltip: 'Wedstrijd',
      positionsPlayedTooltip: 'Gespeelde Posities',
      minsPlayedTooltip: 'Gespeelde Minuten',
      gameActionsTooltip: 'Doelpunten, Assists, Kaarten',
      from: 'Start',
      to: 'Einde',
      goalText: 'Doelpunt op',
      assistText: 'Assist op',
      penaltyText: 'Penalty op',
      ownGoalText: 'Eigen Doelpunt op',
      yellowCardText: 'Gele Kaart op',
      secondYellowCardText: 'Tweede Gele Kaart op',
      redCardText: 'Rode kaart op',
      substitutionIN: 'In op',
      substitutionOUT: 'Uit op',
      suspendedText: 'Schorsing',
      Team: 'Apparatuur'
    },
    gameFlow: {
      phase: 'Fase ',
      mins: 'Minuten',
      team: 'Team',
      period: 'Periode',
      possession: '%Balbezit',
      possessionTooltip: '% Balbezit',
      xT: 'xBedreiging',
      xTTooltip: 'Verwachte Bedreiging',
      pft: 'PF ⅓',
      pftTooltip: 'Passes Laatste Derde',
      xG: 'xG',
      xGTooltip: 'Verwachte Doelpunten'
    }
  },
  game: {
    title: 'Wedstrijd Overzicht',
    subtitle: 'Ga dieper in op de kenmerken en statistieken van de wedstrijd',
    header: {
      gameDetails: 'Details',
      gameStats: 'Statistieken',
      gameFinishingMap: 'Afwerking Kaart',
      gameKeyPassMap: 'Sleutelpass Kaart',
      gamePassMap: 'Pass Kaart',
      gameThreat: 'Wedstrijd Bedreiging',
      gameFlow: 'Spelverloop',
      gameAnalysis: 'Wedstrijdanalyse',
      gamePhysicalStats: 'Fysieke Statistieken',
      possessions: 'Balbezit',
      bench: 'Bank',
      video: 'Video hoogtepunten',
      preGame: 'Voorwedstrijd',
      postGame: 'Na de wedstrijd',
      areaCoverage: 'Gebiedsdekking'
    },
    passMap: {
      typeOfPlay: 'Speltype:',
      passes: 'Passes:',
      team: 'Team',
      minutes: 'Minuten:',
      select: 'Selecteer',
      all: 'Alles',
      attacking: 'Aanvallend',
      defending: 'Defensief',
      forwards: 'Voorwaarts',
      backwards: 'Achterwaarts',
      sideways: 'Zijwaarts',
      longBall: 'Lange Bal',
      successfullPasses: 'Succesvolle Passes',
      homeTeam: 'Thuis',
      awayTeam: 'Uit',
      passingMatrix: 'Pass Matrix',
      passer: 'Passer',
      receiver: 'Ontvanger',
      passOutcome: 'Pass Resultaat',
      passDirection: 'Pass Richting',
      half: 'Helft',
      offensive: 'Aanvallend',
      defensive: 'Verdedigend',
      passingConnections: 'Pasverbindingen',
      pitchView: 'Veld',
      passSingular: 'Pass',
      passPlural: 'Passes',
      playerLocation: 'Speler Locatie',
      passLegend: 'Gemiddelde aanraakpositie',
      minuteRange: 'Minuut bereik'
    },
    stats: {
      summary: 'Samenvatting',
      attacking: 'Aanvallend',
      defending: 'Defensief',
      contribution: 'Bijdrage',
      possession: 'Balbezit',
      expectedPoints: 'Verwachte Punten',
      directness: 'Directheid',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG Vaste Situatie',
      xA: 'xA',
      xASetPiece: 'xA Vaste Situatie',
      xT: 'xT',
      xTSetPiece: 'xT Vaste Situatie',
      touchesInOppBox: 'Aanrakingen in Tegenstander Zestienmetergebied',
      passesFinalThird: 'Passes Laatste Derde',
      interceptions: 'Onderscheppingen',
      recoveries: 'Herwinnen',
      recoveriesOppHalf: 'Herwinnen Tegenstander Helft',
      tackles: 'Tackles',
      tacklesWasDribbled: 'Gewonnen defensieve 1-tegen-1-duels',
      fouls: 'Overtredingen',
      yellowCards: 'Gele Kaarten',
      redCards: 'Rode Kaarten',
      passes: 'Passes',
      passing: 'Passen %',
      crosses: 'Voorzetten',
      crossing: 'Voorzetten %',
      shots: 'Schoten',
      shotsOnTarget: 'Schoten op Doel',
      ppdaExplicit: 'Toegestane Passes per Defensieve Actie',
      xgExplicit: 'Verwachte Doelpunten',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Competitie Gem.',
      winChanceTooltip: 'Winst kans gebaseerd op gegenereerde en toegestane xG',
      drawChance: 'Gelijk',
      xgAgainst: 'xG Tegen',
      averagePossession: 'Balbezit',
      averageShots: 'Schoten',
      averagexG: 'Verwachte Doelpunten',
      fieldTilt: 'Veld Kanteling',
      fieldTiltExplicit: 'Veld Kanteling',
      recoveriesRate: 'Herstelpercentage',
      turnoversRate: 'Omzetpercentage'
    },
    detail: {
      halfTime: 'Rust',
      overTime: 'Verlenging',
      showStats: 'Toon Statistieken',
      hideStats: 'Verberg Statistieken',
      bench: 'Bank',
      showShotOptions: 'Toon Schot Opties',
      hideShotOptions: 'Verberg Schot Opties',
      showPassOptions: 'Toon Pass Opties',
      hidePassOptions: 'Verberg Pass Opties',
      endGame: 'Eindtijd',
      penalties: 'Penalty\'s'
    },
    timeline: {
      events: {
        goal: 'Doelpunt',
        goal_ownGoal: 'Eigen Doelpunt',
        goal_penalty: 'Penalty Doelpunt',
        card: 'Kaart',
        card_yellowCard: 'Gele Kaart',
        card_secondYellowCard: 'Tweede Gele Kaart',
        card_redCard: 'Rode Kaart',
        formationChange: 'Formatie Wijziging',
        substitution: 'Wissel',
        saveShot: 'Gered Schot',
        saveShot_penalty: 'Gerede Penalty',
        missedShot: 'Gemist Schot',
        missedShot_penalty: 'Gemiste Penalty',
        shotOnPost: 'Schot op Paal',
        shotOnPost_penalty: 'Penalty Schot op Paal',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Doelpunt van ',
      redCardTo: 'Rode Kaart voor ',
      missedPenalty: 'Gemiste penalty'
    },
    gameThreat: {
      typeOfPlay: 'Type Actie',
      regularPlay: 'Regulier Spel',
      setPiece: 'Vaste Situatie',
      setPiecePlay: 'Vaste Situatie',
      throwInSetPiecePlay: 'Inworp Spel',
      throwInPlay: 'Inworp Spel',
      gkThrow: 'Doelman Inworp',
      gkKick: 'Doelman Trap',
      kickOff: 'Aftrap',
      actionEnding: 'Actie Einde',
      pass: 'Pass',
      shot: 'Schot',
      foul: 'Overtreding',
      other: 'Anders',
      threat: 'Bedreiging',
      legendSumOfXT: 'Som van xT',
      legendPass: 'Pass',
      legendShot: 'Schot',
      legendCarryAndAction: 'Balvoering en Actie',
      legendCarryAndPass: 'Balvoering en Pass',
      legendOnlyShowing: 'Toont alleen individuele acties met xT > ',
      legendOnlyShowingPart1: 'Toont alleen individuele',
      legendOnlyShowingPart2: 'acties met xT > ',
      legendOnlyShowingSetPiece: 'Toont alleen Vaste Situatie acties met xT > ',
      legendOnlyShowingOpenPlay: 'Toont alleen Open Spel acties met xT > ',
      legendPlays: 'Acties',
      legendPerPlay: 'per Actie',
      legendCarry: 'Balvoering',
      penaltyPlay: 'Penalty',
      freeKickTakenPlay: 'Vrije Trap Spel',
      cornerTakenPlay: 'Hoekschop Spel',
      fromCornerPlay: 'Hoekschop Spel',
      keeperThrowPlay: 'Keeper Inworp Spel',
      fastBreakPlay: 'Snelle Omschakeling Spel',
      indirectPlay: 'Indirect Spel',
      minutes: 'Minuten',
      games: 'Wedstrijden',
      xT: 'xT',
      xTPer90: 'xT per 90\''
    },
    gameAnalysis: {
      next: 'Volgende',
      previous: 'Vorige',
      phaseLabel: 'Fase',
      phasesLabel: 'Fases',
      dot: '. ',
      comma: ', ',
      from: 'Van',
      to: 'Naar',
      and: ' en ',
      steps: {
        finishingMapFullGame: 'Afwerking Kaart',
        keyPassMapFullGame: 'Sleutelpass Kaart',
        gameFlow: 'Spelverloop',
        finishingMapPerPhases: 'Afwerking Kaart per Fases',
        keyPassMapPerPhases: 'Sleutelpass Kaart per Fases',
        passMapPerPhases: 'Pass Kaart per Fases'
      },
      step1: {
        table: {
          draw: 'Gelijk',
          win: 'Winst',
          lose: 'Verlies',
          possession: 'Balbezit',
          xP: 'Verwachte Punten',
          directness: 'Directheid',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Open Spel',
          xGSetPiece: 'xG Vaste Situatie',
          xA: 'xA',
          xAOpenPlay: 'xA Open Spel'
        },
        text: {
          firstParagraph: {
            1: 'De kaart rechts toont de verwachte doelpunten gegenereerd door home_team_name en away_team_name. De gevulde cirkels zijn de schoten die eindigden in een doelpunt. De grootte van de cirkels hangt af van de xG waarde van elk schot. '
          },
          lastParagraph: {
            1: 'Het waarschijnlijkheidspercentage van een resultaat en het aantal verwachte punten wordt berekend door schot simulatie (100.000 simulaties van de schoten worden uitgevoerd en de mogelijkheid van resultaten en van het krijgen van punten wordt op een voorspellende manier geëvalueerd). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, evenals rival_team_name, slaagde erin een hoog volume van verwachte doelpunten te creëren'
          },
          targetHighTeamOpenPlayXG: {
            1: 'In deze wedstrijd kwamen de meeste kansen van target_team_name uit open spel'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'In deze wedstrijd werden de meeste kansen van target_team_name gegenereerd door open spel (anders dan rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'In deze wedstrijd kwamen de meeste kansen van target_team_name uit vaste situaties'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'In deze wedstrijd werden de meeste kansen van target_team_name gegenereerd door vaste situaties (anders dan rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'In deze wedstrijd kwamen de meeste kansen van target_team_name uit hoekschoppen'
          },
          targetLowTeamGoalConversion: {
            1: ' maar de doelpuntconversie was laag'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name creëerde een hoog volume van verwachte doelpunten in zowel open spel als vaste situaties'
          },
          targetHighTeamGoalConversion: {
            1: ' en had ook een hoge doelpuntconversie ratio. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', niet in staat om een van de gecreëerde kansen te scoren'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' maar creëerde gevaar om meer doelpunten te scoren'
          },
          targetHighTeamXGvsGameRival: {
            1: 'In deze wedstrijd genereerde target_team_name meer gevaar dan rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' en had meer doelpunten kunnen scoren. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' maar was niet in staat om doelpunten te scoren uit de gecreëerde kansen. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' wat overeenkomt met een winstkans van team_winning_chance volgens onze na-wedstrijd simulatie. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' De meeste kansen van target_team_name kwamen uit open spel. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' De meeste kansen van target_team_name werden gegenereerd door vaste situaties. '
          },
          startTargetHighTeamCornerXG: {
            1: ' De meeste kansen kwamen uit hoekschoppen. '
          },
          targetSimilarTeamXG: {
            1: 'In deze wedstrijd genereerden beide teams een vergelijkbare hoeveelheid gevaar voor de tegenstander in termen van xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'maar target_team_name presteerde beter in het afmaken van kansen. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Ondanks het resultaat genereerde target_team_name niet veel gevaar voor de tegenstander in termen van Verwachte Doelpunten. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name genereerde niet genoeg gevaar voor de tegenstander in termen van Verwachte Doelpunten om de wedstrijd te winnen'
          },
          rivalHighTeamXG: {
            1: 'en liet rival_team_name toe om te veel gevaar te genereren. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Met deze creatie is dit een wedstrijd die target_team_name slechts team_winning_chance van de keren zou winnen volgens onze na-wedstrijd simulatie. '
          },
          targetHighTeamGoalConversion2: {
            1: ' met een hoge doelpuntconversie ratio'
          },
          winningChance: {
            1: 'Gezien het aantal schoten en xG van beide teams had target_team_name deze wedstrijd team_winning_chance van de keren moeten winnen. '
          },
          highPlayerXGManyShots: {
            1: 'Het is interessant om op te merken dat player_name xg_value xG genereerde in shots_value schoten'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' en xg_value xG nodig had om een doelpunt te scoren. '
          },
          highPlayerXGOneGoal: {
            1: ' om het doelpunt te scoren. '
          },
          highPlayerXGAnyGoal: {
            1: ', hoewel hij niet in staat was om een doelpunt te scoren. '
          },
          highPlayerXGNotManyShots: {
            1: 'Het is de moeite waard om te vermelden dat player_name xg_value xG genereerde in een paar schoten'
          },
          highManyPlayerXG: {
            1: 'Het is interessant om op te merken dat player_name en player_name2 respectievelijk xg_value en xg_value2 <b>xG</b> genereerden. '
          },
          highTeamXGPerShot: {
            1: 'Wat betreft de selectie van schoten genomen door target_team_name, waren ze zeer goed in termen van waarschijnlijkheid om een doelpunt te worden, met een gemiddelde xG per schot van xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'De selectie van schoten van target_team_name was veel beter dan rival_team_name, met een gemiddelde van xg_per_shot_value xG per schot. '
          },
          xGTimesNotAfter70xG: {
            1: 'Ondanks de hoge xG gegenereerd, had target_team_name problemen om gevaar te creëren aan het einde van de wedstrijd. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name creëerde veel gevaar vooral aan het begin van beide helften. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name creëerde veel gevaar vooral aan het einde van beide helften. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name creëerde het meeste gevaar aan het begin van de eerste helft. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name creëerde het meeste gevaar aan het einde van de eerste helft. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name creëerde het meeste gevaar aan het begin van de tweede helft. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name creëerde het meeste gevaar aan het einde van de tweede helft. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name startte de wedstrijd zeer solide met kansen die xg_value verwachte doelpunten genereerden. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name eindigde de eerste helft van de wedstrijd met kansen die xg_value verwachte doelpunten genereerden. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name kwam uit de rust met kansen die xg_value verwachte doelpunten genereerden. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name eindigde de tweede helft met kansen die xg_value verwachte doelpunten genereerden. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name creëerde veel gevaar aan het einde van de tweede helft. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name creëerde veel gevaar aan het begin van de tweede helft. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name creëerde veel gevaar aan het einde van de eerste helft. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name creëerde veel gevaar aan het begin van de eerste helft. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name genereerde het meeste van zijn gevaar in de eerste helft terwijl rival_team_name hetzelfde deed in de tweede helft. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name genereerde het meeste van zijn gevaar in de tweede helft terwijl rival_team_name hetzelfde deed in de eerste helft. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Het is een wedstrijd waarin het meeste gevaar in termen van Verwachte Doelpunten werd gegenereerd tijdens de eerste helft. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Het is een wedstrijd waarin het meeste gevaar in termen van Verwachte Doelpunten werd gegenereerd tijdens de tweede helft. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name slaagde erin het meeste gevaar te creëren in de eerste helft. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name slaagde erin het meeste gevaar te creëren tijdens de tweede helft. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name liet het meeste gevaar toe in termen van Verwachte Doelpunten in de eerste helft. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name liet het meeste gevaar toe in termen van Verwachte Doelpunten tijdens de tweede helft. '
          },
          highInBoxXG: {
            1: 'De schot kaart toont hoe het meeste gevaar kwam van schoten binnen het zestienmetergebied. '
          },
          highOutOfBoxXG: {
            1: 'Het kan worden waargenomen in de schot kaart dat, in deze wedstrijd, target_team_name veel gevaar genereerde van buiten het zestienmetergebied. '
          },
          highInBoxXGRival: {
            1: 'We willen erop wijzen dat het meeste gevaar toegestaan door target_team_name kwam van schoten binnen het zestienmetergebied. '
          },
          highInBoxXGRival2: {
            1: ' Het is ook interessant om te benadrukken dat het meeste gevaar toegestaan door target_team_name kwam van schoten binnen het zestienmetergebied. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name presteerde goed door gevaar binnen het zestienmetergebied te vermijden. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Het gebrek aan druk van target_team_name, waardoor ppda_value Passes per Defensieve Actie werden toegestaan, was een van de sleutels voor rival_team_name om een hoog aantal kansen te creëren. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name liet slechts ppda_value Passes per Defensieve Actie toe, wat een van de sleutels tot overwinning was. '
          },
          lowPPDA: {
            1: 'target_team_name deed uitstekend werk door de acties van rival_team_name te onderbreken en slechts een gemiddelde van ppda_value Passes per Defensieve Actie toe te staan. '
          },
          highPossession: {
            1: 'target_team_name had de controle over de bal met een possession_value van balbezit'
          },
          highPPDARival: {
            1: ' evenals een vloeiende verdeling van de bal'
          },
          chancesCreated: {
            1: ', wat hen in staat stelde om een hoog aantal open spel kansen te hebben (chances_value). '
          },
          chancesCreatedRival: {
            1: ', hoewel rival_team_name in staat was om een hoog aantal open spel kansen te creëren (chances_value). '
          },
          xGPerShotRival: {
            1: ', hoewel rival_team_name in staat was om gevaarlijkere kansen te creëren met een xg_per_shot_value xG per Schot. '
          },
          winGame: {
            1: ' wat een van de sleutels tot het winnen van de wedstrijd was. '
          },
          notEnoughWinGame: {
            1: ' wat niet genoeg was om de wedstrijd te winnen. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Het eerste doelpunt kwam voort uit een fout van player_error_name die werd benut door player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Het eerste en enige doelpunt kwam voort uit een fout van player_error_name die werd benut door player_name'
          },
          lastPhaseOfGame: {
            1: ' in de laatste fase van de wedstrijd. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Het laatste doelpunt om de wedstrijd te winnen kwam voort uit een fout van player_error_name die leidde tot het doelpunt van player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Het laatste doelpunt om de wedstrijd gelijk te maken kwam voort uit een fout van player_error_name die leidde tot het doelpunt van player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Een fout van player_error_name leidde tot een kans om de wedstrijd gelijk te maken voor target_team_name. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name nam de leiding door gebruik te maken van een fout van player_error_name'
          },
          xGChance: {
            1: ' met een kans van xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Het laatste doelpunt van rival_team_name om de wedstrijd te winnen kwam voort uit een fout van player_error_name die leidde tot het doelpunt van player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Een fout van player_error_name leidde tot een kans om de wedstrijd gelijk te maken voor rival_team_name. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name nam de leiding door gebruik te maken van een fout van player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name slaagde erin het enige grote kans te scoren dat tijdens de wedstrijd werd gecreëerd, dat is het doelpunt van player_name dat we zien in de xG kaart met een xG van xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name slaagde erin alle grote kansen te scoren die tijdens de wedstrijd werden gecreëerd'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name had de enige grote kans van target_team_name om te scoren met een xG van xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name was niet in staat om een van de chances_value kansen boven 40% waarschijnlijkheid om een doelpunt te worden te scoren. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name had een grote kans van xg_value xG om voor te komen in de stand. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value kansen met xG boven 40% om voor te komen in de stand. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name had chances_value kansen met hoge xG om voor te komen in de stand. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name had een kans om voor te komen in de stand van xg_value xG die de paal raakte. '
          },
          beforeEndOfGame: {
            1: 'Voor het einde van de wedstrijd, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name had een kans van xg_value xG om de wedstrijd te winnen. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value kansen met een xG boven 40% om de wedstrijd te winnen. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name had chances_value kansen met hoge xG om de wedstrijd te winnen. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name had een grote kans van xg_value xG om voor te komen in de stand. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value kansen met xG boven 40% om voor te komen in de stand. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name had chances_value kansen met hoge xG om voor te komen in de stand. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name had een kans om voor te komen in de stand van xg_value xG die de paal raakte. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name had een kans van xg_value xG om de wedstrijd gelijk te maken zonder geluk. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name had chances_value kansen om de wedstrijd gelijk te maken met een waarschijnlijkheid om te scoren hoger dan 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name had een kans van xg_value xG om de wedstrijd gelijk te maken die eindigde door de paal te raken. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Gelijk',
          win: 'Winst',
          possession: 'Balbezit',
          xP: 'Verwachte Punten',
          directness: 'Directheid',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Open Spel',
          xASetPiece: 'xA Vaste Situatie',
          chancesCreated: 'Kansen Gecreëerd',
          shotsOnTarget: 'Schoten op Doel'
        },
        text: {
          firstParagraph: {
            1: 'Deze afbeelding toont de verwachte assists van <b style=\'color:home_color\'>home_team_name</b> en <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA per Sleutelpass. '
          },
          keyPassesGeneratedFrom: {
            1: ', vooral sleutelpasses gegenereerd uit '
          },
          highTeamXAvsXG: {
            1: 'Zoals de xA kaart toont, komt het meeste gevaar gecreëerd door target_team_name van combinatiespelen in plaats van individuele acties'
          },
          openPlay: {
            1: 'open spel'
          },
          setPiece: {
            1: 'vaste situaties'
          },
          cornerKicks: {
            1: 'hoekschoppen'
          },
          combinationPlays: {
            1: 'combinatiespelen'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'In deze wedstrijd genereerde target_team_name gevaar uit zowel combinatiespelen'
          },
          individualActions: {
            1: ' als individuele acties. '
          },
          dangerFromIndividualActions: {
            1: 'In deze wedstrijd kwam het meeste gevaar gegenereerd door target_team_name van individuele acties.'
          },
          highTeamXAvsXGRival: {
            1: ' De kansen die target_team_name toestond tijdens de wedstrijd kwamen van combinatiespelen zoals de xA kaart toont.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name was sterk in sleutelpasses komend uit '
          },
          manyPlayerKeyPasses: {
            1: 'Het is interessant om op te merken dat player_name xa_value xA creëerde in key_passes sleutelpasses'
          },
          playerAssists: {
            1: ' met xa_per_assist xA per assist nodig.'
          },
          giveAssist: {
            1: ' om de assist te geven.'
          },
          noAssists: {
            1: ', hoewel geen van zijn passes eindigde in een assist.'
          },
          highXANotManyShots: {
            1: 'Het is interessant om op te merken dat player_name xa_value xA creëerde in een paar passes'
          },
          manyPlayersHighXA: {
            1: 'Het is interessant om op te merken dat player_name en player_name2 respectievelijk xa_value en xa_value2 xA genereerden.'
          },
          xATimes: {
            1: 'target_team_name genereerde het meeste van zijn gevaar in de eerste helft terwijl rival_team_name hetzelfde deed in de '
          },
          firstHalf: {
            1: ' eerste helft. '
          },
          secondHalf: {
            1: ' tweede helft. '
          },
          left: {
            1: 'linkerkant '
          },
          center: {
            1: 'midden '
          },
          right: {
            1: 'rechterkant '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Het is een wedstrijd waarin het meeste gevaar in termen van Verwachte Doelpunten werd gegenereerd tijdens de '
          },
          xAFirstHalf: {
            1: 'target_team_name slaagde erin het meeste gevaar te creëren in de '
          },
          xATimesXARival: {
            1: 'target_team_name liet te veel gevaar toe in termen van Verwachte Doelpunten in de '
          },
          xASides: {
            1: ' Het meeste gevaar van target_team_name werd geproduceerd vanaf de side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'terwijl rival_team_name het merendeel ervan genereerde vanaf de side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'De creatie van gevaar van rival_team_name kwam, vooral, vanaf de side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name was vooral effectief in '
          },
          xAPerChanceCreated: {
            1: ' met een gemiddelde van xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name was vooral effectief in '
          }
        }
      },
      step3: {
        text: {
          chance: ' kans',
          chances: ' kansen',
          goal: ' doelpunt',
          goals: ' doelpunten',
          home: 'thuis',
          away: 'uit',
          last: 'laatste',
          first: 'eerste',
          goalScorer: 'doelpuntenmaker',
          goalScorers: 'doelpuntenmakers',
          lastPhase: 'Laatste fase van de wedstrijd, ',
          phase: {
            1: 'In deze phase_position fase van de wedstrijd, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> genereerde meer Verwachte Bedreiging (<b style=\'color:more_color\'>more_xt_team_value xT</b>) dan <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'en deed dit voor meer minuten in deze periode (<b style=\'color:more_color\'>more_time_xt_minutes min.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min.</b> van de tegenstander)'
          },
          rivalTeamMoreMinutes: {
            1: 'echter was het zijn tegenstander die langer gevaar genereerde (<b style=\'color:more_color\'>more_time_xt_minutes min.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min.</b> van de tegenstander) in deze periode van de wedstrijd'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> was het team dat het meeste gevaar creëerde (<b style=\'color:max_color\'>max_xt_team_value xT</b>) op <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', terwijl <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> hun meeste gevaar genereerde (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) op <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Beide teams zijn erin geslaagd de tegenstander doelman te verslaan in <b>number_of_goals_each_team</b> elk. Het thuisteam via <b style=\'color:#3366FF\'>home_player_name_goals</b> en het uitteam via <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'Wat betreft doelpunten overtrof <b style=\'color:replace_color\'>goal_scored_team_name</b> de tegenstander met <b style=\'color:replace_color\'>difference_number_of_goals</b> verschil omdat ze hun doelman versloegen met <b style=\'color:replace_color\'>home_player_name_goals</b> als goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Team',
          period: 'Periode',
          possession: 'Balbezit',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OS',
          tooltip: {
            team: 'Team',
            period: 'Periode',
            possession: 'Balbezit',
            ppda: 'Toegestane Passes per Defensieve Actie',
            xGOpenPlay: 'xG Open Spel'
          }
        },
        text: {
          clearly: 'duidelijk',
          very: 'zeer ',
          haveGotText1: 'kreeg slechts',
          haveGotText2: 'had meer moeten krijgen dan',
          gaveUpPoss: 'gaf het balbezit op',
          lostPoss: 'verloor het balbezit',
          too: 'te ',
          possession: {
            1: 'Tijdens deze fase van de wedstrijd controleerde <b style=\'color:team_color\'>team_name</b> clearly_text het balbezit'
          },
          equalPossession: {
            1: 'In deze fase van de wedstrijd domineerde niemand de ander omdat het balbehandeling vrij gebalanceerd was, hoewel kijkend naar de cijfers, <b style=\'color:team_color\'>team_name</b> hun tegenstanders licht overtrof met een <b style=\'color:team_color\'>possession_value%</b> balbezit'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> met slechte baldruk liet <b style=\'color:rival_team_color\'>rival_team_name</b> toe om <b style=\'color:target_team_color\'>ppda_value Passes per Defensieve Actie</b> te geven'
          },
          lowPossessionLowPPDA: {
            1: ', maar <b style=\'color:target_team_color\'>target_team_name</b> deed het goed in het drukken op de bal wanneer rival_team_name het balbezit had, met een <b>PPDA</b> van <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' en was in staat om te spelen vanwege een very_textlage drukintensiteit van rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' hoewel de drukintensiteit van rival_team_name very_texthoog was'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> greep een hoog balbezit en gaf <b>pft_value</b> <b>Passes in de Laatste Derde</b> van het veld. '
          },
          highPossessionMidLowPFT: {
            1: 'Ondanks het hoge balbezit, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Passes in de Laatste Derde</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Hoewel <b style=\'color:target_team_color\'>target_team_name</b> possession_text tijdens deze fase, was het in staat om <b>pft_value</b> <b>Passes in de Laatste Derde</b> te geven. '
          },
          midPossessionHighPFT: {
            1: 'Een vrij gelijk balbezit tijdens deze fase stopte <b style=\'color:target_team_color\'>target_team_name</b> niet om <b>pft_value</b> <b>Passes in de Laatste Derde</b> te geven. '
          },
          highPFTHighTouchesIOB: {
            1: ' Afgezien van het controleren van de wedstrijd in de laatste derde, had <b style=\'color:target_team_color\'>target_team_name</b> ook veel aanwezigheid in het tegenstander zestienmetergebied. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> controleerde wel de bal in de laatste derde, maar kon niet veel ballen in het tegenstander zestienmetergebied krijgen'
          },
          highPFTMidTouchesIOB: {
            1: 'Gezien het aantal <b>Passes in de Laatste Derde</b>, had <b style=\'color:target_team_color\'>target_team_name</b> meer gevaar moeten creëren in het tegenstander zestienmetergebied'
          },
          lowPFTHighTouchesIOB: {
            1: 'Hoewel <b style=\'color:target_team_color\'>target_team_name</b> niet veel passes voltooide in de laatste derde, was het in staat om het tegenstander zestienmetergebied vaak te bereiken. '
          },
          midPFTHighTouchesIOB: {
            1: 'Gezien het aantal voltooide passes in de laatste derde, slaagde <b style=\'color:target_team_color\'>target_team_name</b> erin het tegenstander zestienmetergebied vaak te bereiken. '
          },
          maxDirectness: {
            1: 'Het is de moeite waard om erop te wijzen dat dit de fase van de wedstrijd is waarin <b style=\'color:max_dir_color\'>target_team_name</b> offensiever speelde met een <b>Directheid</b> van <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> was in staat om meer xG te genereren dan in andere fasen van de wedstrijd '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> slaagde erin een hoog volume van Verwachte Doelpunten te genereren'
          },
          highXG: {
            1: 'genereerde een goed volume van Verwachte Doelpunten'
          },
          highXGLowPossession: {
            1: ' ondanks het niet hebben van de controle over de bal'
          },
          highXGLowShots: {
            1: ' slechts in een paar schoten, met een <b>xG per Schot</b> van <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' hoewel de xG per Schot too_textlaag was. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> was niet in staat om enig gevaar voor de tegenstander te genereren'
          },
          lowXGMinXG: {
            1: 'Wat betreft de generatie van Verwachte Doelpunten was dit een slechte fase voor <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> genereerde een zeer laag volume van Verwachte Doelpunten'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> was niet in staat om een goed volume van Verwachte Doelpunten te genereren'
          },
          lowXGHighPossession: {
            1: ' ondanks dat ze de controle over de bal hadden. '
          },
          lowXGHighShots: {
            1: ' ondanks veel schoten'
          },
          lowXGHighPFT: {
            1: ' ondanks het voltooien van <b>pft_value</b> <b>Passes in de Laatste Derde</b> van het veld. '
          },
          midXGQuintileMinXG: {
            1: 'Hoewel de generatie van xG niet slecht was, was dit de zwakste fase van de wedstrijd voor <b style=\'color:target_team_color\'>target_team_name</b> in dat opzicht'
          },
          midXGQuintileMaxXG: {
            1: 'Dit was de fase waarin <b style=\'color:target_team_color\'>target_team_name</b> in staat was om de hoogste <b>xG (xg_value)</b> te genereren'
          }
        }
      },
      step5: {
        table: {
          team: 'Team',
          period: 'Periode',
          possession: 'Balbezit',
          directness: 'Dir.',
          passesFinalThird: 'PF ⅓',
          tooltip: {
            team: 'Team',
            period: 'Periode',
            possession: 'Balbezit',
            directness: 'Directheid',
            passesFinalThird: 'Passes Laatste Derde'
          }
        },
        text: {
          last: 'laatste',
          goal: 'doelpunt',
          goals: 'doelpunten',
          chance: 'kans',
          chances: 'kansen',
          first: 'eerste',
          homeTeam: 'thuisteam',
          awayTeam: 'uitteam',
          home: 'thuis',
          away: 'uit',
          clearly: 'duidelijk',
          slightly: 'licht',
          firstOrLastPhase: {
            1: 'In deze phase_position fase van de wedstrijd, ',
            2: 'In de phase_position periode van de wedstrijd, '
          },
          phase: {
            1: 'Tijdens deze periode van de wedstrijd, '
          },
          bothZeroGoalsScored: {
            1: 'zonder dat een van beide teams in staat was de score te veranderen.'
          },
          equalGoalsScored: {
            1: 'er in slaagde om <b>number_goals</b> te scoren'
          },
          differentGoalsScored: {
            1: 'er in slaagde om <b>number_goals</b> te scoren'
          },
          equalPossesion: {
            1: 'hadden beide teams de bal precies <b>poss_value%</b> van de tijd'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> had de bal voor meer minuten (<b style=\'color:more_color\'>more_poss_team_value%</b> van de tijd) dan zijn tegenstander <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> van de tijd)'
          },
          equalDirectness: {
            1: 'speelden beide teams de wedstrijd met dezelfde directheid (<b>directness_value</b> elk)'
          },
          moreDirectnessSameTeam: {
            1: 'waren ze ook verticaler dan hun tegenstanders, de wedstrijd spelend met een directheid van <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'echter was het het home_away team dat speelde met meer directheid (<b style=\'color:more_color\'>more_dir_team_value</b>) dan zijn tegenstander (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Beide teams creëerden hetzelfde aantal kansen, precies <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> creëerde slechts <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> en werd adverb_text overtroffen door de tegenstander (<b style=\'color:more_color\'>more_cc_team_value more_chance_text gecreëerd</b>). '
          },
          equalXA: {
            1: 'Beide teams hadden gelijke kansen, zoals weerspiegeld in de <b>xa_value van Verwachte Assists</b>, '
          },
          moreXA: {
            1: 'Het home_away team genereerde <b>diff_xa_team_value Verwachte Assists</b> (<b style=\'color:more_color\'>more_xa_team_value</b> versus <b style=\'color:less_color\'>less_xa_team_value</b>) meer dan de tegenstander, '
          },
          xAOpenPlay: {
            1: 'respectievelijk creërend, <b style=\'color:more_color\'>more_xa_op_value</b> en <b style=\'color:less_color\'>less_xa_op_value xA Open Spel</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' elk ',
          respectively: ', respectievelijk',
          with: ' (met <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'speler was',
          playerWere: 'spelers waren',
          firstPhase: {
            1: 'In dit eerste deel van de wedstrijd was de belangrijkste player_text ',
            2: 'Wat betreft het eerste deel van de wedstrijd, wie opviel was '
          },
          otherPhase: {
            1: 'Tussen <b style=\'color:replace_color\'>min_from\'</b> en <b style=\'color:replace_color\'>min_to\'</b> moet worden genoemd '
          },
          lastPhase: {
            1: 'In het laatste deel van de wedstrijd, vermelding aan ',
            2: 'Wat betreft de laatste fase van de wedstrijd, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> omdat hij het hoogste aantal succesvolle passes van zijn team uitvoerde, precies <b style=\'color:replace_color\'>successfull_passes_value passes</b> '
          },
          playerMaxTotalPasses: {
            1: 'wat nog waardevoller wordt wanneer de cijfers tonen dat hij ook was'
          },
          playerMaxTotalPasses2: {
            1: 'with_text de speler met de meeste geprobeerde passes (<b style=\'color:replace_color\'>total_passes_value passes</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'hoewel hij niet de meeste passes probeerde (<b style=\'color:replace_color\'>player_name</b> met <b style=\'color:replace_color\'>total_passes_value passes</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'proberend tijdens deze periode <b style=\'color:replace_color\'>total_passes_value passes</b> elk. '
          },
          playerMaxPctPasses: {
            1: 'Wat betreft <b style=\'color:replace_color\'>% Passes Voltooid</b>, heeft <b style=\'color:replace_color\'>player_name</b> een hoge <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'Wat betreft pass succespercentage, is het de moeite waard om <b style=\'color:replace_color\'>player_name</b> te vermelden met een <b style=\'color:replace_color\'>max_pct_passes_value%</b> pass succespercentage</b>. '
          },
          playerSumTotalXG: {
            1: 'In dit tijdsvenster genereerde het team een totaal van <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Tijdens deze periode creëerde <b style=\'color:replace_color\'>team_name</b> een <b style=\'color:replace_color\'>xG</b> van <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Ondanks het maken van een totaal van <b style=\'color:replace_color\'>all_team_total_passes</b> tussen het hele team, was het tevergeefs omdat ze er niet in slaagden een enkele kans te creëren. ',
            2: 'De <b style=\'color:replace_color\'>all_team_total_passes</b> gemaakt in deze periode genereerden geen enkele scoringskans. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'met <b style=\'color:replace_color\'>player_xg_name</b> met <b style=\'color:replace_color\'>xg_value xG</b> en <b style=\'color:replace_color\'>player_xa_name</b> met <b style=\'color:replace_color\'>xa_value xA</b> als de gevaarlijkste spelers wat betreft het creëren van kansen. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'waarbij <b style=\'color:replace_color\'>player_name</b> met <b style=\'color:replace_color\'>xg_value xG</b> en <b style=\'color:replace_color\'>xa_value xA</b> de oorsprong was van de meeste kansen van zijn team. '
          },
          playersMaxXGMaxXA: {
            1: 'dankzij onder anderen <b style=\'color:replace_color\'>players_name</b> die <b style=\'color:replace_color\'>xa_value xA</b> elk activeerden met hun sleutelpasses. '
          },
          playerMaxXGZeroXA: {
            1: 'waarbij <b style=\'color:replace_color\'>player_xg_name</b> met <b style=\'color:replace_color\'>xg_value xG</b> het volledige gewicht van de kansen had, ze zelf moest creëren omdat hij geen sleutelpasses ontving. '
          },
          playersMaxXGZeroXA: {
            1: 'waarbij <b style=\'color:replace_color\'>player_xg_name</b> met <b style=\'color:replace_color\'>xg_value xG</b> de kansen had, ze zelf moest creëren omdat ze geen sleutelpasses ontvingen. '
          },
          oneMaxConnections: {
            1: 'Het paar dat de meeste passes tussen elkaar maakte tijdens dit deel van de wedstrijd was <b style=\'color:replace_color\'>couple_name</b>, met een totaal van <b style=\'color:replace_color\'>connections_value passes</b>. ',
            2: 'Het duo gevormd door <b style=\'color:replace_color\'>couple_name</b> wisselde <b style=\'color:replace_color\'>connections_value</b> keer de bal uit. ',
            3: 'Het <b style=\'color:replace_color\'>couple_name</b> duo waren degenen die de bal het meest passeerden in dit deel van de wedstrijd, dit zelfs op <b style=\'color:replace_color\'>connections_value</b> kansen. '
          },
          twoMaxConnections: {
            1: 'De twee paren gevormd door <b style=\'color:replace_color\'>couple_name</b> en <b style=\'color:replace_color\'>couple_name2</b> waren de meest herhaalde verbindingen voor deze periode, de bal naar elkaar passend <b style=\'color:replace_color\'>connections_value</b> keer. '
          },
          moreThanTwoMaxConnections: {
            1: 'De paren spelers, zoals <b style=\'color:replace_color\'>couple_name</b>, maakten <b style=\'color:replace_color\'>connections_value passes</b> naar elkaar. '
          },
          oneMinConnections: {
            1: 'Aan de andere kant was het <b style=\'color:replace_color\'>couple_name</b> die de bal het minst naar elkaar passeerden, slechts <b style=\'color:replace_color\'>connections_value passes</b>. ',
            2: 'Aan het andere uiterste verbond het tandem bestaande uit <b style=\'color:replace_color\'>couple_name</b> slechts <b style=\'color:replace_color\'>connections_value</b> keer. '
          },
          twoMinConnections: {
            1: 'Aan de andere kant wisselden <b style=\'color:replace_color\'>couple_name</b> en <b style=\'color:replace_color\'>couple_name2</b> nauwelijks passes tussen elkaar uit (<b style=\'color:replace_color\'>connections_value passes</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Verschillende combinaties verbonden niet genoeg, zoals het <b style=\'color:replace_color\'>couple_name</b> duo, dat met <b style=\'color:replace_color\'>connections_value passes</b> behoort tot de minst voorkomende combinaties. '
          }
        }
      },
      step7: {
        ballPossession: 'Balbezit',
        gamePossessionDist: 'Verdeling van balbezit'
      }
    },
    gamePossessionMap: {
      of: 'van',
      to: 'naar',
      and: 'en',
      endsWith: 'Eindigt met',
      time: 'Tijd',
      touches: 'Aanrakingen',
      passes: 'Passes',
      threat: 'Bedreiging',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuten',
      duration: 'Duur',
      endsGoal: 'Eindigt Doelpunt',
      endsInBox: 'Eindigt in Zestienmetergebied',
      withShot: 'Met Schot',
      withCross: 'Met Voorzet',
      possession: 'Balbezit',
      events: 'Gebeurtenissen',
      filters: 'Filters',
      filtersWarning: 'Bedreiging geldt alleen voor balbezit zonder schoten',
      sumWarning: 'De filter geldt voor de som van xG van alle schoten in de sequentie, daarom kan het groter zijn dan 1',
      show: 'Toon',
      sequenceNumbers: 'Sequentie Nummer',
      jerseyNumbers: 'Rugnummer',
      pass: 'Pass',
      carryAndPass: 'Balvoering & Pass',
      carryAndAction: 'Balvoering & Actie',
      carryAndShot: 'Balvoering & Schot',
      shotFailed: 'Gemist Schot',
      goal: 'Doelpunt',
      savedShot: 'Gered Schot',
      missedShot: 'Gemist Schot',
      shotOnPost: 'Schot op Paal',
      headerGoal: 'Kopbal Doelpunt',
      headerFailed: 'Kopbal Gemist',
      failed: 'gemist',
      with: 'met'
    },
    report: {
      title: 'Wedstrijd Rapport',
      maps: 'Kaarten',
      xGRace: 'xG Race',
      lineups: 'Opstellingen',
      button: 'Genereer een volledig PDF rapport van de wedstrijd',
      mobileButton: 'PDF rapport',
      most: 'Meest',
      topXPlayers: 'Top {x} Spelers',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Fysieke gegevensrapport van het spel'
    },
    avgScoreTooltip: 'Gemiddelde score per minuut',
    status: {
      scheduled: 'Gepland',
      postponed: 'Uitgesteld',
      cancelled: 'Geannuleerd',
      inPlay: 'Live',
      finished: 'Afgerond',
      awarded: 'Toegekend',
      dataAvailable: 'Gegevens zullen in de komende uren beschikbaar zijn'
    },
    preGameAnalysis: {
      showExpectations: 'Toon verwachtingen',
      hideExpectations: 'Verberg verwachtingen',
      goalsPeriods: 'Doelperioden',
      synergyIndex: 'Synergie-index',
      synergyIndexSubtitle: 'Algemene sterkte van de passer-finisher-verbinding'
    }
  },
  general: {
    1: 'Een',
    2: 'Twee',
    3: 'Drie',
    4: 'Vier',
    5: 'Vijf',
    8: 'Links',
    9: 'Beide',
    10: 'Rechts',
    create: 'Aanmaken',
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    reset: 'Opnieuw instellen',
    go: 'Ga',
    formErrors: {
      required: 'Veld is verplicht',
      passwordMatch: 'Wachtwoord komt niet overeen',
      minLength: 'Minimum lengte',
      maxLength: 'Maximum lengte',
      emailValid: 'E-mail moet geldig zijn',
      youthAge: 'Leeftijd moet tussen 10 en 23 zijn',
      seasonYear: 'Jaar moet tussen 2016 en 2050 zijn',
      integer: 'Decimale getallen zijn niet toegestaan'
    },
    confirmationTitle: 'Weet je het zeker?',
    confirmationMessage: 'Bevestig of je de actie wilt uitvoeren',
    yes: 'Ja',
    no: 'Nee',
    search: 'Zoeken',
    clearFilters: 'Filters wissen',
    minimum: 'Minimum',
    maximum: 'Maximum',
    minimumPercent: '(%)Minimum Percentage',
    period: 'Periode',
    exclude: 'Uitsluiten',
    team: 'Team',
    clear: 'Wissen',
    all: 'Alles',
    ground1: 'Alles',
    ground2: 'Thuis',
    ground3: 'Uit',
    filter: 'Filter',
    noData: 'Geen resultaten gevonden',
    noDataGivenFilters: 'Geen resultaten gevonden met gegeven filters',
    similarityMinutesWarning: 'Geen data vanwege minder dan 450 minuten gespeeld',
    templateOnlyEditable: 'Sjabloon alleen bewerkbaar door ',
    close: 'Sluiten',
    load: 'Laden',
    filters: 'Filters',
    players: 'spelers',
    teams: 'teams',
    compare: 'Vergelijken',
    seeMore: 'Meer zien',
    seeLess: 'Minder zien',
    request: 'Aanvraag',
    notes: 'Notities',
    closeSession: 'Afsluiten',
    settings: 'Instellingen',
    player: 'Speler',
    state: 'Staat',
    updated: 'Bijgewerkt',
    file: 'Bestand',
    uploadFile: 'Bestand uploaden',
    reports: 'Rapporten',
    download: 'Downloaden',
    new: 'Nieuw',
    comparison: 'Vergelijking',
    scout: 'Scout',
    favorites: 'Favorieten',
    moreOptions: 'Meer opties',
    lessOptions: 'Minder opties',
    today: 'Vandaag',
    home: 'Thuis',
    away: 'Uit',
    until: 'tot',
    firstHalf: 'Eerste Helft',
    secondHalf: 'Tweede Helft',
    firstPeriodOT: 'Eerste H. OT',
    secondPeriodOT: 'Tweede H. OT',
    postponed: 'Uitgesteld',
    stats: 'Statistieken',
    yesterday: 'Gisteren',
    last: 'Laatste',
    startDate: 'Start Datum',
    active: 'Actief',
    playerLimit: 'Spelers Limiet',
    type: 'Type',
    successMessage: 'De operatie is succesvol geweest',
    failMessage: 'De operatie is mislukt',
    by: 'Door',
    checkYourInbox: 'Controleer je inbox',
    faq: 'Woordenlijst',
    globalSearch: 'Globaal Zoeken',
    gamesLost: 'Wedstrijden Verloren',
    outOf: 'van de',
    avgSeason: 'Seizoen Gem.',
    leftDays: 'resterende dagen',
    notifyError: 'Fout Melden',
    notify: 'Melden',
    comments: 'Opmerkingen',
    searches: 'Zoekopdrachten',
    now: 'Nu',
    twoHoursAgo: 'Twee uur geleden',
    incomings: 'Aankomsten',
    departures: 'Vertrekken',
    transferLoans: 'Verhuur',
    transfers: 'Transfers',
    movements: 'Bewegingen',
    incomes: 'Inkomsten',
    expenditures: 'Uitgaven',
    action: 'Actie',
    target: 'Doel',
    uses: 'Gebruikt',
    users: 'Gebruikers',
    since: 'sinds',
    mediaMode: 'Media Modus',
    white: 'Wit',
    enabled: 'Ingeschakeld',
    disabled: 'Uitgeschakeld',
    left: 'Links',
    right: 'Rechts',
    both: 'Beide',
    'left-both': 'Links Beide',
    'right-both': 'Rechts Beide',
    'left foot': 'Links',
    'right foot': 'Rechts',
    files: 'Bestanden',
    confirm: 'Bevestigen',
    currentStep: 'Huidige Stap',
    phases: 'Fases',
    entries: 'Invoeren',
    none: 'Geen',
    times: 'keer',
    darkMode: 'Donkere Modus',
    client: 'Klant',
    visits: 'Bezoeken',
    lastVisit: 'Laatste Bezoek',
    strong: 'Sterk',
    medium: 'Gemiddeld',
    weak: 'Zwak',
    goal: 'Doelpunt',
    list: 'Lijst',
    map: 'Kaart',
    copiedToClipboard: 'Gekopieerd naar klembord',
    division: 'Divisie',
    many: 'Veel',
    few: 'Weinig',
    median: 'Mediaan',
    topRight: 'Boven Rechts',
    topLeft: 'Boven Links',
    bottomRight: 'Onder Rechts',
    bottomLeft: 'Onder Links',
    library: 'Bibliotheek',
    mediaLibrary: 'Media Bibliotheek',
    for: 'Voor',
    stat: 'Statistiek',
    position: 'Positie',
    order: 'Volgorde',
    add: 'Toevoegen',
    visualization: 'Visualisatie',
    basic: 'Basis',
    selectAll: 'Alles Selecteren',
    unselectAll: 'Alles Deselecteren',
    distribution: 'Verdeling',
    end: 'Einde',
    accuracy: 'nauwkeurigheid',
    opponent: 'Tegenstander',
    ownTeam: 'Eigen Team',
    center: 'Midden',
    line: 'Lijn',
    live: 'Live',
    unavailable: 'niet beschikbaar',
    calendar: 'Kalender',
    activeLeague: 'Competitie in Voortgang',
    similarity: 'Gelijkwaardigheid',
    emptyForSelectAll: 'Leeg selecteer alles',
    size: 'Grootte',
    selectPlayersRestriction: 'Selecteer tussen 1 en {x} spelers',
    group: 'Groep',
    alerts: 'Meldingen',
    shortcuts: 'Sneltoetsen',
    share: 'Delen',
    dataAvailable: 'Data zal binnenkort beschikbaar zijn',
    someStatsAvailableSoon: 'Sommige statistieken zullen binnenkort beschikbaar zijn',
    monthGamesWarning: 'Wedstrijden van geselecteerde maand zullen binnenkort beschikbaar zijn',
    metrics: 'Metrieken',
    competition: 'Competitie',
    code: 'Code',
    alias: 'Alias',
    never: 'Nooit',
    unlimited: 'Onbeperkt',
    user: 'Gebruiker',
    warning: 'Waarschuwing',
    requests: 'Aanvragen',
    contactSales: 'Contact Verkoop',
    comingSoon: 'Binnenkort Beschikbaar!',
    firstPost: '1e Post',
    secondPost: '2e Post',
    dZone: 'D Zone',
    penaltySpot: 'Penalty Stip',
    secondPlay: '2e Spel',
    otherZone: 'Andere Zone',
    baseline: 'Basislijn',
    youth: 'Jeugd',
    male: 'Mannelijk',
    direct: 'Direct',
    indirect: 'Indirect',
    processing: 'Verwerken',
    addNew: 'Nieuw Toevoegen',
    createdBy: 'Aangemaakt door',
    downloading: 'Downloaden',
    displayType: 'Weergave Type',
    alreadyExists: 'bestaat al',
    aggregation: 'Aggregatie',
    unavailableLeagues: 'Je hebt geen toegang tot een van de competities waarin de speler heeft gespeeld',
    meters: 'Meters',
    quantity: 'Hoeveelheid',
    allTime: 'Alle Tijden',
    games: 'Wedstrijden',
    unit: 'Eenheid',
    categories: 'Categorieën',
    maintenanceWarning: 'Onderhoud in uitvoering',
    maintenanceMessage: 'We maken enkele updates. Wijzigingen die je nu maakt worden niet opgeslagen. Bedankt voor je geduld!',
    seeAll: 'Alles bekijken',
    from: 'Van',
    to: 'naar',
    showFilters: 'Filters weergeven',
    hideFilters: 'Filters verbergen',
    horizontal: 'Horizontaal',
    vertical: 'Verticaal',
    drop: 'Druppel',
    orientation: 'Oriëntatie',
    goalProbability: 'Doelwaarschijnlijkheid',
    assistProbability: 'Ondersteuning van waarschijnlijkheid',
    attackingDirection: 'Aanvallende richting',
    currentTeam: 'Huidig ​​team',
    expectations: 'Verwachtingen',
    sideBySide: 'Naast elkaar',
    teamValue: 'Teamwaarde',
    fieldLayout: 'Veldindeling',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Kammen',
    pcts: 'PCT\'s'
  },
  playerScout: {
    dlabDatabase: 'Driblab Database',
    league: 'Competitie',
    top5: 'Top 5',
    topCountries: 'Landen',
    tier: 'Niveau',
    division1: 'Eerste Divisie',
    division2: 'Tweede Divisie',
    division3: 'Derde Divisie',
    division4: 'Vierde Divisie',
    division5: 'Vijfde Divisie',
    division6: 'Zesde Divisie',
    summary: 'Samenvatting',
    offensive: 'Aanvallend',
    defensive: 'Defensief',
    gk: 'GK',
    all: 'Alles',
    physical: 'Fysiek',
    arrigo: 'Arrigo',
    yearTooltip: 'Alleen één jaar toegestaan',
    expectedThreat: 'xBedreiging',
    expectedThreatTooltip: 'Bedreiging toegevoegd aan alle balbezit',
    expectedThreatOP: 'xBedreiging OS',
    expectedThreatOPTooltip: 'Bedreiging toegevoegd aan Open Spel balbezit',
    expectedThreatInTeam: 'xBedreiging in Team %',
    expectedThreatInTeamTooltip: '% van Bedreiging toegevoegd door speler aan het team',
    ballProgression: 'Balvoortgang',
    ballProgressionTooltip: 'Voortgangen van +10 meter',
    deepProgression: 'Diepe Voortgangen',
    deepProgressionTooltip: 'Balvoortgangen naar Laatste Vijfde',
    ballRetention: '% Balbehoud',
    ballRetentionTooltip: 'Percentage van Acties waarbij de Bal succesvol werd behouden',
    ballRetentionOppHalf: '% Balbehoud TH',
    ballRetentionOppHalfExplicit: 'Percentage van de tijd dat je balbezit hebt en het niet verliest in de tegenstander helft',
    finishing: 'Afwerking',
    finishingTooltip: '% van Schoten die eindigen in een Doelpunt',
    scoringContribution: 'Scoring Bijdrage',
    scoringContributionTooltip: 'Assists + Doelpunten',
    xgPerShot: 'xG per Schot',
    xgPerGoal: 'xG per Doelpunt',
    headerPerCross: 'Kopbal per Voorzet',
    completedCrosses: 'Voltooide Voorzetten',
    crossingPct: '% Voorzetten',
    crossingEfficiency: 'Voorzet Efficiëntie',
    crossingEfficiencyTooltip: 'Voorzet Efficiëntie (Meet Kwaliteit en Kwantiteit)',
    longBalls: 'Lange Ballen',
    longPassing: '% Lange Bal',
    dribblingPct: '% Dribbelen',
    throughBalls: 'Steekpasses',
    oppBoxTouches: 'Tegenstander Zestienmetergebied Aanrakingen',
    oppBoxTouchesTooltip: 'Aanrakingen in Tegenstander Zestienmetergebied',
    openPlayKeyPasses: 'OS Sleutelpasses',
    openPlayKeyPassesTooltip: 'Open Spel Passes die eindigen in Schot',
    xGBuildup: 'xG Opbouw',
    xGBuildupTooltip: 'xG van sequenties die eindigen in schot waarbij de speler betrokken was (exclusief xG van schot en sleutelpass)',
    Assists: 'Assists',
    passPercentage: '% Passen',
    passPerLongBall: 'Pass per LB',
    passPerLongBallExplicit: 'Pass per Lange Bal',
    nonPenaltyGoals: 'Niet-Penalty Doelpunten',
    xG: 'xG',
    xGExplicit: 'Verwachte Doelpunten',
    shots: 'Schoten',
    xGShot: 'xG per Schot',
    xGChain: 'xG Ketting',
    xGChainTooltip: 'xG van sequenties die eindigen in schot waarbij de speler betrokken was',
    chancesCreated: 'Passes gevolgd door een Schot',
    chances: 'Kansen',
    dribbles: 'Dribbels',
    dribblesSuccessfull: 'Succesvolle Dribbels',
    touches: 'Aanrakingen in Tegenstander Zestienmetergebied',
    xA: 'xA',
    xAExplicit: 'Verwachte Assists',
    xAOpenPlay: 'xA OS',
    xAOpenPlayExplicit: 'Verwachte Assists Open Spel',
    passesOpponentBox: 'Passes in Tegenstander Zestienmetergebied',
    passesOB: 'Passes in Zestienmetergebied',
    passesFinalThirdTooltip: 'Passes Laatste Derde',
    passesSuccessful: 'Passes Succ.',
    passesSuccessfulTooltip: 'Succesvolle Passes',
    ballProgressionPassing: 'BV door Passen',
    ballProgressionPassingTooltip: 'Balvoortgang door Passen',
    ballProgressionDribbling: 'BV door Balvoering',
    ballProgressionDribblingTooltip: 'Balvoortgang door Balvoering',
    passesTotal: 'Passes',
    passesTotalTooltip: 'Totaal van Geprobeerde Passes',
    shortPassesSuccessful: 'Succ. KP',
    shortPassesSuccessfulTooltip: 'Aantal Voltooide Korte Passes',
    shortPassesTotal: 'Totaal KP',
    shortPassesTotalTooltip: 'Aantal Geprobeerde Korte Passes',
    tackles: 'Tackles *',
    adjustedTackles: 'Tackles aangepast aan Balbezit',
    interceptions: 'Onderscheppingen *',
    adjustedInterceptions: 'Onderscheppingen aangepast aan Balbezit',
    aerials: 'Luchtduels',
    aerialsPercent: '% Luchtduels',
    aerialEfficiency: 'Luchtduel Eff.',
    aerialEfficiencyTooltip: 'Luchtduel Efficiëntie (Meet Kwaliteit en Kwantiteit)',
    twd: 'TwD',
    tacklesWasDribbled: 'Gewonnen defensieve 1-tegen-1-duels',
    fouls: 'Overtredingen',
    indPressure: 'Individuele Druk',
    pressure: 'Druk',
    dispossessed: 'Balverlies',
    recoveries: 'Herwinnen',
    primary: 'Primair',
    secondary: 'Secundair',
    position: 'Positie',
    nationality: 'Nationaliteit',
    height: 'Lengte (cm)',
    minHeight: 'Min. Lengte',
    maxHeight: 'Max. Lengte',
    age: 'Leeftijd',
    minAge: 'Min. Leeftijd',
    maxAge: 'Max. Leeftijd',
    games: 'Wedstrijden',
    minGames: 'Min. Wedstrijden',
    maxGames: 'Max. Wedstrijden',
    minutes: 'Minuten',
    minMinutes: 'Min. Minuten',
    maxMinutes: 'Max. Minuten',
    minPercentMinutes: 'Min. Percentage Minuten',
    dates: 'Data',
    marketValue: '(€) Marktwaarde',
    teams: 'Teams',
    contractEnd: 'Contract Einde',
    minValue: 'Min. Waarde',
    maxValue: 'Max. Waarde',
    excludeTeams: 'Teams Uitsluiten',
    recentSearches: 'Recente zoekopdrachten',
    saveSearch: 'Zoekopdracht opslaan',
    loadSearch: 'Zoekopdracht laden',
    loadCollection: 'Collectie Laden',
    collection: 'Collectie',
    search: 'Zoeken',
    searchesList: 'Zoeklijsten',
    mySearches: 'Mijn zoekopdrachten',
    mySearchesDescription: 'Degene die je eerder hebt opgeslagen',
    recentSearchesDescription: 'Laatste 10 zoekopdrachten die je deed',
    searchToLoad: 'Zoekopdracht om te laden',
    recentSearch: 'Recente zoekopdracht',
    saveSearchSuccess: 'Zoekopdracht succesvol opgeslagen',
    removeSearch: 'Zoekopdracht verwijderen',
    removeSearchMessage: 'Weet je zeker dat je de zoekopdracht wilt verwijderen?',
    updateSearch: 'Zoekopdracht bijwerken',
    updateSearchMessage: 'Weet u zeker dat u de zoekopdracht wilt bijwerken?',
    deleteSearchSuccess: 'Zoekopdracht is verwijderd',
    playersFound: 'spelers gevonden',
    addToCollection: 'Toevoegen aan collectie',
    npg: 'NPD',
    goals: 'Doelpunten',
    value: 'Waarde',
    nationalTeams: 'Nationale Teams',
    gbeScore: 'GBE',
    dlIndex: 'Score',
    minGbe: 'Min. GBE',
    goalsConceded: 'Doelpunten Toegestaan',
    npgConceded: 'NPD Toegestaan',
    npgConcededTooltip: 'Niet-Penalty Doelpunten Toegestaan',
    xGOTConceded: 'xG Op Doel Toegestaan',
    xGOTConcededTooltip: 'xG van Schoten Ontvangen op Doel',
    goalsPrevented: 'Doelpunten Voorkomen',
    xGFacedPerShotOnTarget: 'xGOT per Schot',
    xGFacedPerShotOnTargetTooltip: 'xG op Doel per Schot toegestaan',
    xGSavedPerxGFacedOnTarget: 'xG Redding',
    xGSavedPerxGFacedOnTargetTooltip: 'Percentage van Redding rekening houdend met xG',
    savesPct: '% Reddingen',
    savesOutOfBoxPct: '% Reddingen Buiten Zestienmetergebied',
    savesInBoxPct: '% Reddingen In Zestienmetergebied',
    xGFacedPerGoal: 'xG Geconfronteerd per Doelpunt',
    xGFacedPerGoalTooltip: 'xG Nodig om een Doelpunt te Scoren',
    catchingPct: '% Vangen',
    catchingTooltip: '% van Reddingen Gevangen',
    passingOwnHalfPct: '% Passen Eigen Helft',
    passingOwnHalfPctTooltip: 'Percentage van Succesvolle Passes in Eigen Helft',
    passingOppHalfPct: '% Passen Tegenstander Helft',
    passingOppHalfPctTooltip: 'Percentage van Succesvolle Passes in Tegenstander Helft',
    passingContribution: '% Pass Bijdrage',
    passingContributionTooltip: 'Bijdrage van Bedreiging door de Bal te Passen - Boven Gemiddelde',
    shotsPerGoal: 'Schoten per Doelpunt',
    passesFinalThird: 'Passes Laatste ⅓',
    passingFinalThird: '% Passen Laatste ⅓',
    claimAccuracy: 'Claim Nauwkeurigheid',
    claimAccuracyTooltip: 'Ballen Geclaimd boven Gemiddelde',
    highTurnovers: 'Hoge Balverlies',
    highTurnoversTooltip: 'Balverlies dichter dan 40 meter bij het doel',
    shotEndingHighTurnovers: 'Schot Eindigend HT',
    shotEndingHighTurnoversTooltip: 'Schot Eindigend Hoge Balverlies',
    goalEndingHighTurnovers: 'Doelpunt Eindigend HT',
    goalEndingHighTurnoversTooltip: 'Doelpunt Eindigend Hoge Balverlies',
    avgCarriesProgress: 'Gemiddelde Voortgang',
    avgCarriesProgressTooltip: 'Gemiddelde afstand bal verticaal verplaatsen (meters)',
    carriesChance: 'Kans Eindigend',
    carriesChanceTooltip: 'Balvoering gevolgd door een Sleutelpass',
    carriesAssist: 'Assist Eindigend',
    carriesAssistTooltip: 'Balvoering gevolgd door een Assist',
    carriesShot: 'Schot Eindigend',
    carriesShotTooltip: 'Balvoering gevolgd door een Schot',
    carriesGoal: 'Doelpunt Eindigend',
    carriesGoalTooltip: 'Balvoering gevolgd door een Doelpunt',
    shotEndingSequence: 'Schot Eindigend',
    shotEndingSequenceTooltip: 'Aantal Sequenties eindigend in een Schot waarbij de speler betrokken was',
    goalEndingSequence: 'Doelpunt Eindigend',
    goalEndingSequenceTooltip: 'Aantal Sequenties eindigend in een Doelpunt waarbij de speler betrokken was',
    gbeScoreTooltip: 'FA Voetbal\'s Bestuursorgaan Endorsement',
    goalsPreventedTooltip: 'Niet-Penalty Doelpunten gered door Doelman (xG Geconfronteerd - NPD Toegestaan)',
    freePlayers: 'Vrije Spelers',
    index: 'Index',
    playerName: 'Naam',
    teamName: 'Team',
    secondPos: 'Tweede Pos.',
    side: 'Kant',
    onlyOnLoan: 'Alleen op huur',
    dob: 'Geboorte',
    countryName: 'Land',
    secondCountryName: 'Tweede Land',
    seasonYear: 'Seizoen',
    assists: 'Assists',
    placeholder: 'Je kunt beginnen met het toevoegen van enkele competitie filters',
    placeholder2: 'Klik op zoekknop om resultaten te tonen',
    passesPct: '% Passes',
    passingPct: '% Passes',
    oppBoxPasses: 'Passes in Tegenstander Zestienmetergebied',
    adjustedClearances: 'Aangepaste Vrijschoppen',
    aerialsPct: '% Luchtduels',
    leagueCountryCode: 'Competitie Land Code',
    shooting: '% Schoten op Doel',
    xtPassing: 'xT Passen',
    xtPassingTooltip: 'Bedreiging toegevoegd door passen',
    xtDribbling: 'xT Balvoering',
    xtDribblingTooltip: 'Bedreiging toegevoegd door balvoering',
    foot: 'Sterke Voet',
    aggressiveActions: 'Agressieve Acties',
    aggressiveActionsTooltip: 'Aantal tackles geprobeerd in de volgende twee seconden na het verliezen van het balbezit',
    tacklesAttempted: 'Totaal Tackles Geprobeerd',
    highDefensiveActionPct: '% HD Acties',
    highDefensiveActionPctTooltip: 'Percentage van Defensieve Acties gemaakt 40 meter dicht bij het tegenstander doel',
    individualPressureOppHalf: 'Druk Tegenstander Helft',
    individualPressureOppHalfTooltip: 'Metriek die het aantal succesvolle inspanningen (balbezit herwonnen) meet die een speler maakt bij het drukken van de tegenstander in de tegenstander helft',
    xGBuildUp5Pass: 'xG Opbouw 5p',
    xGBuildUp5PassTooltip: 'Kwantiteit van xG waar een speler aan heeft deelgenomen, alleen laatste 5 passes (exclusief schoten en passes die leiden tot een schot)',
    chancesCreatedOpenPlay: 'Kansen Gecreëerd OS',
    chancesCreatedOpenPlayTooltip: 'Aantal passes die leiden tot een schot tijdens open spel',
    fmf: {
      Defender: 'Verdediger',
      aerial: 'Luchtduel',
      goodDefender: 'Goede Verdediger',
      goodPresence: 'Goede Aanwezigheid',
      playmaking: 'Spelmaker',
      Fullback: 'Vleugelverdediger',
      defensiveness: 'Defensiviteit',
      offensiveness: 'Offensiviteit',
      fast: 'Snel',
      Forward: 'Aanvaller',
      goalChances: 'Doelkansen',
      goodDecissions: 'Goede Beslissingen',
      individualTechnique: 'Individuele Techniek',
      Goalkeeper: 'Doelman',
      footWork: 'Voetwerk',
      leadership: 'Leiderschap',
      Midfielder: 'Defensieve Middenvelder',
      balance: 'Balans',
      ballRetention: '% Balbehoud',
      offensivePasses: 'Aanvallende Passes',
      recoveries: 'Herwinnen',
      shotToGoal: 'Schot naar Doel',
      'Attacking-Midfielder': 'Aanvallende Middenvelder',
      defensiveGame: 'Defensief Spel',
      offensiveGame: 'Aanvallend Spel',
      Winger: 'Vleugelspeler',
      crossing: 'Voorzetten',
      deepProgressions: 'Diepe Voortgangen',
      defendingEffort: 'Verdedigende Inspanning',
      facing: 'Geconfronteerd'
    },
    yellowCards: 'Gele Kaarten',
    redCards: 'Rode Kaarten',
    alert: 'Melding',
    yearOfBirth: 'Geboortejaar',
    minYearOfBirth: 'Min. Geboortejaar',
    maxYearOfBirth: 'Max. Geboortejaar',
    women: 'Vrouwen',
    continental: 'Continentaal',
    countryCup: 'Land Beker',
    statsName: 'Statistiek naam',
    abbreviation: 'Afkorting',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Toont alleen het laatste reguliere seizoen dat is gespeeld',
    gamesWith60PlusMinsTooltip: 'Minimum aantal gespeelde games met meer dan 60 minuten',
    starts: 'Begint',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Vergelijk tot 5 spelers',
    requestReport: 'Rapport aanvragen',
    searchBarPlaceholder: 'Zoek speler of team',
    allStats: 'Alle Statistieken',
    placeholder: 'Je kunt beginnen met het toevoegen van enkele spelers'
  },
  reports: {
    detailedInsights: 'Krijg Gedetailleerde Inzichten',
    features: 'Functies van het rapport',
    performance: 'Prestatie',
    evolution: 'Evolutie',
    compareWithMyTeam: 'Vergelijk met mijn team',
    similarPlayers: 'Vergelijkbare Spelers',
    potentialTeams: 'Potentiële Teams',
    requestSuccess: 'Aanvraag succesvol verzonden',
    requestAt: 'Aangevraagd',
    reportConversation: 'Rapport Gesprek',
    writeYourMessage: 'Schrijf je bericht...',
    you: 'Jij'
  },
  state: {
    requested: 'Aangevraagd',
    inProgress: 'In uitvoering',
    delivered: 'Geleverd'
  },
  langs: {
    es: 'Spaans',
    en: 'Engels',
    fr: 'Frans',
    de: 'Duits',
    it: 'Italiaans',
    pt: 'Portugees',
    tr: 'Turks',
    jp: 'Japans',
    cn: 'Chinees',
    sa: 'Arabisch',
    nl: 'Nederlands',
    pl: 'Pools',
    sv: 'Zweeds',
    cs: 'Tsjechisch',
    ko: 'Koreaans',
    hu: 'Hongaars',
    ru: 'Russisch'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Azië',
    arabic: 'Arabisch'
  },
  inbox: {
    subtitle: 'Blijf op de hoogte',
    new_injury_alert: 'Nieuwe Blessure Melding',
    new_contract_alert: 'Nieuwe Contract Melding',
    new_team_alert: 'Nieuwe Transfer Melding',
    new_marketValue_alert: 'Nieuwe Marktwaarde Melding',
    new_game_alert: 'Nieuwe Wedstrijd Gespeeld Melding',
    receive_mail: 'E-mail Ontvangen',
    receive_mail_subtitle: 'Ontvang Dagelijkse E-mail met spelers die aan filters voldoen',
    receive_notifications: 'Meldingen',
    receive_notifications_subtitle: 'Ontvang Meldingen in de app met spelers die aan filters voldoen',
    changedTo: 'Gewijzigd naar',
    alerts: 'Meldingen',
    includedIn: 'Opgenomen in',
    noContract: 'Geen Contract',
    newMessages: 'Nieuwe Berichten',
    reply: {
      reply: 'Antwoorden',
      replyTitle: 'Geef feedback aan de klant:',
      replyPlaceholder: 'De gebruiker ontvangt het antwoord samen met de status update'
    }
  },
  gameAnalysis: {
    subtitle: 'Krijg inzichten van de laatste wedstrijden',
    subtitle2: 'Toont Wedstrijden in de komende zeven dagen',
    subtitle3: 'Krijg inzichten van de laatste wedstrijden en verken de volgende',
    seeDetail: 'Zie details'
  },
  statsNaming: {
    Possession: 'Balbezit',
    TimePossession: 'Tijd Balbezit',
    PassesPerShots: 'Passes per Schot',
    PPDA: 'PPDA',
    ExpectedPoints: 'Verwachte Punten',
    Points: 'Punten',
    Directness: 'Directheid',
    PassesPerLongBall: 'Passes per Lange Bal',
    CrossingPerXG: 'Voorzetten per xG',
    PenaltySavedPenaltyFaced: 'Penalty Gered/Penalty Geconfronteerd',
    Goals: 'Doelpunten',
    PenaltyShots: 'Penalty Schoten',
    PenaltyGoals: 'Penalty Doelpunten',
    NonPenaltyGoals: 'Niet-Penalty Doelpunten',
    NPGOpenPlay: 'NPD Open Spel',
    NPGSetPiece: 'NPD Vaste Situatie',
    Shooting: 'Schieten',
    Finishing: 'Afwerking',
    xGEfficiency: 'xG Efficiëntie',
    HeaderPerShot: 'Kopbal per Schot',
    HeaderPerCross: 'Kopbal per Voorzet',
    HeadedGoals: 'Kopdoelen',
    GoalsConceded: 'Doelpunten toegekend',
    SavesInBox: 'Opgeslagen in doos',
    SavesOutBox: 'Bespaart uit de doos',
    Assists: 'Assists',
    ThroughBalls: 'Steekpasses',
    CrossEfficiency: 'Voorzet Efficiëntie',
    ScoringContribution: 'Scoring Bijdrage',
    xAssistsOpenPlay: 'xAssists Open Spel',
    xAssistsSetPiece: 'xAssists Vaste Situatie',
    xAssistsOpenPlayInTeam: 'xAssists Open Spel in Team',
    xAssistsSetPieceInTeam: 'xAssists Vaste Situatie in Team',
    xGBuildupFinalThird: 'xG Opbouw Laatste ⅓',
    xGChainFinalThird: 'xG Ketting Laatste ⅓',
    BallProgressionPassing: 'Bal Voortgang door Passen',
    BallProgressionDribbling: 'Bal Voortgang door Balvoering',
    TacklesWasDribbled: 'Gewonnen defensieve 1-tegen-1-duels',
    TacklesSuccessful: 'Succesvolle Tackles',
    Interceptions: 'Onderscheppingen',
    Clearances: 'Vrijschoppen',
    Fouls: 'Overtredingen',
    Recoveries: 'Herwinnen',
    Shots: 'Schoten',
    ShotsPerGoal: 'Schoten per Doelpunt',
    ShortPassesSuccessful: 'Succesvolle Korte Passes',
    PassingSuccessForwardPct: '% Pass Succes Voorwaarts',
    PassingSuccessBackwardPct: '% Pass Succes Achterwaarts',
    PassingForwardBackwardPct: '% Pass Voorwaarts per Achterwaarts',
    LongBallPerPassesPct: '% Lange Bal per Passes',
    LongBallReceived: 'Lange Ballen Ontvangen',
    LongBallReceivedOppHalf: 'Lange Ballen ontvangen Tegenstander Helft',
    OffensiveActions: 'Aanvallende Acties',
    DribblesAttempted: 'Dribbels Geprobeerd',
    SuccessfulDribblesPct: '% Succesvolle Dribbels',
    OffensiveTouchesOutBoxPct: '% Aanvallende Aanrakingen Buiten Zestienmetergebied',
    BallRetention: '% Balbehoud',
    PassingPct: '% Passen',
    PassingOwnHalfPct: '% Passen Eigen Helft',
    PassingOppHalfPct: '% Passen Tegenstander Helft',
    PassingFinalThird: 'Passes naar Laatste ⅓',
    PassesFinalThirdTotal: 'Totaal aantal passen Finale ⅓',
    PassingFinalThirdPct: '% Passen naar Laatste ⅓',
    LongBallSuccessful: 'Voltooide Lange Ballen',
    LongBallPct: '% Lange Ballen',
    LongBallTotal: 'Totaal lange ballen',
    SavesPct: '% Reddingen',
    SavesInBoxPct: '% Reddingen in Zestienmetergebied',
    SavesOutOfBoxPct: '% Reddingen Buiten Zestienmetergebied',
    xGSavedPerXGFacedOnTarget: 'xG Gered/xG Geconfronteerd op Doel',
    xGFacedOnTargetPerGoalReceived: 'xG Geconfronteerd per Doelpunt',
    xGFacedOnTargetEfficiency: 'Doelpunten Voorkomen',
    xGFacedOnTarget: 'xG Geconfronteerd op Doel',
    IndividualPressure: 'Individuele Druk',
    AerialEfficiency: 'Luchtduel Efficiëntie',
    AerialWins: 'Luchtduel Overwinningen',
    AerialWinsPct: '% Luchtduel Overwinningen',
    xG: 'Verwachte Doelpunten',
    xGDiff: 'xG Verschil',
    xGOpenPlay: 'xG Open Spel',
    xGSetPiece: 'xG Vaste Situatie',
    xGPerShot: 'xG per Schot',
    ChancesCreated: 'Kansen Gecreëerd',
    CompletedCrosses: 'Voltooide Voorzetten',
    Crossing: '% Voorzetten',
    OpenPlayKeyPasses: 'Open Spel Sleutelpasses',
    OpenPlayKeyPassesInTeam: '% Open Spel Sleutelpasses in Team',
    OpenPlayPassesIntoOpponentBox: 'Totaal OS Passes naar Zestienmetergebied',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'OS Passes naar Zestienmetergebied',
    xAssists: 'Verwachte Assists',
    xGChain: 'xG Ketting',
    xGBuildup: 'xG Opbouw',
    xGBuildupInTeam: 'xG Opbouw in Team',
    BallProgression: 'Balvoortgang',
    SuccessfulDribbles: 'Succesvolle Dribbels',
    Dispossessed: 'Balverlies',
    TouchesInOpponentBox: 'Aanrakingen in Tegenstander Zestienmetergebied',
    xGSavedPerShot: 'xG Gered per Schot',
    BallRetentionOppHalf: '% Balbehoud in Tegenstander Helft',
    DeepProgression: 'Diepe Voortgang',
    DeepProgressionFinalThird: 'Diepe Voortgang naar Laatste ⅓',
    FoulsTaken: 'Overtredingen Ontvangen',
    PenaltiesTaken: 'Penalties Genomen',
    BlockedCrosses: 'Geblokkeerde Voorzetten',
    BlockedShots: 'Geblokkeerde Schoten',
    Blocks: 'Blokkades',
    NonPenaltyGoalsAgainst: 'Niet-Penalty Doelpunten Toegestaan',
    Headers: 'Kopballen',
    AveragePassDistance: 'Gemiddelde Pass Afstand',
    ProgressiveRuns: 'Progressieve Balvoering',
    xT: 'Verwachte Bedreiging (xT)',
    xTOpenPlay: 'xT Open Spel',
    xTSetPiece: 'xT Vaste Situatie',
    xGOT: 'Verwachte Doelpunten Op Doel',
    BadActions: 'Slechte Acties',
    BadActionsOwnHalf: 'Slechte Acties Eigen Helft',
    AerialsWonOwnBox: 'Luchtduel Overwinningen Eigen Zestienmetergebied',
    AerialsWonOppBox: 'Luchtduel Overwinningen Tegenstander Zestienmetergebied',
    AerialsTotalOppBox: 'Luchtduels Totaal Tegenstander Zestienmetergebied',
    AerialsTotalOwnBox: 'Luchtduels Totaal Eigen Zestienmetergebied',
    FoulsOwnHalfPct: '% Overtredingen Eigen Helft',
    RecoveriesOppHalf: 'Herwinnen Tegenstander Helft',
    DuelsPct: '% Succesvolle Duels',
    TacklesUnsuccessful: 'Onsuccesvolle Tackles',
    TacklesWasDribbledFirstThird: 'Gewonnen defensieve 1-tegen-1-duels ⅓',
    TacklesWasDribbledSecondThird: 'Gewonnen defensieve 1-tegen-1-duels  ⅔',
    TacklesWasDribbledFinalThird: 'Gewonnen defensieve 1-tegen-1-duels Laatste ⅓',
    BallProgressionFinalThird: 'Balvoortgang Laatste ⅓',
    DuelsTotal: 'Duels',
    QuickRecoveries: 'Snelle Herwinnen',
    ShotsPerNPG: 'Schoten per NPD',
    ShotsOutBox: 'Schoten buiten Zestienmetergebied',
    GoalsOutBox: 'Doelpunten buiten Zestienmetergebied',
    ShootingOutBox: '% Schieten buiten Zestienmetergebied',
    HandPassing: '% Hand Passen',
    Catching: '% Vangen',
    Caught: 'Gevangen reddingen',
    ClaimAccuracy: 'Claim Nauwkeurigheid',
    HighTurnovers: 'Hoge Balverlies',
    ShotEndingHighTurnovers: 'Schot Eindigend Hoge Balverlies',
    GoalEndingHighTurnovers: 'Doelpunt Eindigend Hoge Balverlies',
    AverageCarriesProgress: 'Gemiddelde Balvoering Voortgang',
    ChanceEndingCarries: 'Kans Eindigend Balvoering',
    AssistEndingCarries: 'Assist Eindigend Balvoering',
    ShotEndingCarries: 'Schot Eindigend Balvoering',
    GoalEndingCarries: 'Doelpunt Eindigend Balvoering',
    ShotEndingSequence: 'Schot Eindigend Sequentie',
    GoalEndingSequence: 'Doelpunt Eindigend Sequentie',
    xGPerNPG: 'xG per NPD',
    AerialWonOffensive: 'Luchtduel Overwinningen Aanvallend',
    AerialWonDefensive: 'Luchtduel Overwinningen Defensief',
    xGAgainst: 'xG Toegestaan',
    xGDiffAgainst: 'xG Verschil Toegestaan',
    xGPerNPGAgainst: 'xG per NPD Toegestaan',
    xGSetPieceAgainst: 'xG Vaste Situatie Toegestaan',
    xGOpenPlayAgainst: 'xG Open Spel Toegestaan',
    xGPerShotAgainst: 'xG per Schot Toegestaan',
    ShotsAgainst: 'Schoten Toegestaan',
    ShotsOnTargetAgainst: 'Schoten op Doel Toegestaan',
    ShotsOnTargetInBoxAgainst: 'Schoten op doel in het strafschopgebied worden afgekeurd',
    ShotsOnTargetOutBoxAgainst: 'Schoten op doel uit het strafschopgebied toegekend',
    RivalPossession: 'Tegenstander Balbezit',
    AerialDefensivePct: '% Luchtduel Defensief',
    HighRecoveries: 'Hoge Herwinnen',
    HighDefensiveActions: 'Hoge Defensieve Acties',
    HighDefensiveActionPct: '% Hoge Defensieve Acties',
    HighDefensiveDistance: 'Hoge Defensieve Afstand',
    PassesPerPossession: 'Passes per Balbezit',
    LengthPerPossession: 'Afstand per Balbezit',
    xTNet: 'Netto xT',
    AvgCarriesDistance: 'Gem. Balvoering Afstand',
    PassesForwardPct: '% Passes Gaan Voorwaarts',
    PassesForwardSuccessful: 'Succesvolle voorwaartse passen',
    PassesForwardTotal: 'Totaal aantal voorwaartse passen',
    TacklesAttempted: 'Tackles Geprobeerd',
    DuelsLost: 'Duels Verloren',
    Carries: 'Balvoering',
    CarriesPct: '% Balvoering',
    Aerials: 'Luchtduels',
    ProgressivePassesReceivedIntoBox: 'Progressieve Passes Ontvangen naar Zestienmetergebied',
    PassesOppHalf: 'Passes Tegenstander Helft',
    ShotsOnTarget: 'Schoten op Doel',
    AggressiveActions: 'Agressieve Acties',
    Crosses: 'Voorzetten',
    xGBuildup5pass: 'xG Opbouw 5 passes',
    SpeedSequence: 'Sequentie Snelheid',
    Touches: 'Aanrakingen',
    AerialsTotalOppHalf: 'Luchtduels Totaal Tegenstander Helft',
    AerialsWonOppHalf: 'Antennes gewonnen opp. Half',
    AerialsWonOppHalfPct: '% Luchtduel Overwinningen Tegenstander Helft',
    AerialsPctOppBox: '% Luchtduel Overwinningen Tegenstander Zestienmetergebied',
    AerialsPctOwnBox: '% Luchtduel Overwinningen Eigen Zestienmetergebied',
    AerialDefensive: 'Luchtduels Defensief',
    AerialOffensive: 'Luchtduels Aanvallend',
    AerialOffensivePct: '% Luchtduels Aanvallend',
    IndividualPressureOppHalf: 'Individuele Druk Tegenstander Helft',
    ChancesCreatedOP: 'Kansen Gecreëerd Open Spel',
    TouchesPerShot: 'Aanrakingen per Schot',
    PassesFinalThirdTotalPct: '% Passes Laatste ⅓',
    xACrosses: 'xA van Voorzetten',
    Passes: 'Passes',
    PassesSuccessful: 'Passes Succesvol',
    TacklesWasDribbledFouls: '% Grond Duels',
    OffsidesCaught: 'Buitenspel Gevangen',
    ProgressivePassesReceivedFinalThird: 'Progressieve Passes Ontvangen Laatste ⅓',
    ProgressivePassesReceived: 'Progressieve Passes Ontvangen',
    Breadth: 'Breedte',
    DuelsDefTotal: 'Defensieve Duels',
    DefensiveActions: 'Defensieve Acties',
    ProgressivePassesReceivedOppHalf: 'Prog. Passes Ontvangen Tegenstander Helft',
    CompletedCrossesOP: 'Voltooide Voorzetten Open Spel',
    CrossingOP: '% Voorzetten Open Spel',
    CrossesOP: 'Totaal aantal kruisen open spel',
    PassingContribution: '% Pass Bijdrage',
    BallProgressionOppHalfInTeam: '% Balvoortgang Tegenstander Helft in Team',
    PassesOPIntoBoxInTeam: '% Passes Open Spel naar Zestienmetergebied in Team',
    TouchesOppBoxInTeam: '% Aanrakingen Tegenstander Zestienmetergebied in Team',
    xGOPInTeam: '% xG Open Spel in Team',
    DeepPasses: 'Diepe Passes',
    DeepPassesTotal: 'Diepe passen',
    DefensiveDuelsPct: '% Defensieve Duels',
    DefensiveDistance: 'Defensieve Afstand',
    QuickRecoveriesPct: '% Snelle Herwinnen',
    DiffDefensiveDistanceTeam: 'Verschil Defensieve Afstand Team',
    xTPassing: 'xT Passen',
    xTPassing100Passes: 'xT Passen 100 Passes',
    ProgressivePassesAccurate: 'Progressieve Passes',
    PassAbility: 'Pass Vermogen',
    OPPassesIntoOppBoxPct: '% Open Spel Passes naar Tegenstander Zestienmetergebied',
    EntriesOppBox: 'Toegangen Tegenstander Zestienmetergebied',
    Crosses6yardBox: 'Voorzetten Zes-Yard Gebied',
    Cutbacks: 'Cutbacks',
    xTDribbling: 'xT Dribbelen',
    AvgShotDistance: 'Gem. Schot Afstand',
    xGOnTarget: 'xG op Doel',
    FinishingxGOT: 'Afwerking xGOT',
    DribblesWonOwnHalf: 'Dribbels Voltooid Eigen Helft',
    DribblesOwnHalf: 'Dribbels Eigen Helft',
    DribblesOwnHalfPct: '% Dribbels Eigen Helft',
    DribblesWonOppHalf: 'Dribbels Voltooid Tegenstander Helft',
    DribblesOppHalf: 'Dribbels Tegenstander Helft',
    DribblesOppHalfPct: '% Dribbels Tegenstander Helft',
    DribblesWonFinalThird: 'Dribbels Voltooid Laatste ⅓',
    DribblesFinalThird: 'Dribbels Laatste ⅓',
    DribblesFinalThirdPct: '% Dribbels Laatste ⅓',
    ShotEndingHighRecoveries: 'Schot Eindigend Hoge Herwinnen',
    PassingFinalThirdAgainst: 'Passes Laatste ⅓ Toegestaan',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Totaal OS Passes naar Zestienmetergebied Toegestaan',
    EntriesOppBoxAgainst: 'Toegangen Tegenstander Zestienmetergebied Toegestaan',
    DeepProgressionAgainst: 'Diepe Voortgang Toegestaan',
    TouchesInOpponentBoxAgainst: 'Aanrakingen in Tegenstander Zestienmetergebied Toegestaan',
    Score: 'Score',
    PDScore: 'Fysieke Score',
    OrlegiScore: 'Score Orlegi',
    SirScore: 'Sirius Score',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT OS in Team',
    YellowCards: 'Gele Kaarten',
    RedCards: 'Rode Kaarten',
    xTOpenPlayAgainst: 'xT Open Spel Toegestaan',
    xTSetPieceAgainst: 'xT Vaste Situatie Toegestaan',
    NPGOpenPlayAgainst: 'NPD Open Spel Toegestaan',
    NPGSetPieceAgainst: 'NPD Vaste Situatie Toegestaan',
    PassesOppHalfPerPossession: 'Passes Tegenstander Helft per Balbezit',
    AverageTimeRecovery: 'Gem. Tijd Herstel',
    ExpectedPassing: '% Verwachte Passen',
    NumPossession10Passes: 'Balbezit 10 Passes',
    PassesReceived: 'Passes Ontvangen',
    PassesReceivedFinalThird: 'Passes Ontvangen Laatste ⅓',
    ProgressivePassesTotalPct: '% Progressieve Passes',
    ShortPassesPct: '% Korte Passes',
    TouchesOppBoxOppTeam: 'Aanrakingen Tegenstander Zestienmetergebied Tegenstander Team',
    ShotsOnTargetOppTeam: 'Schoten Op Doel Tegenstander Team',
    NPGOppTeam: 'NPD Tegenstander Team',
    ShotsOpenPlay: 'Schoten Open Spel',
    xGSetPiecePerxG: 'xG Vaste Situatie per xG',
    ShotsOpenPlayAgainst: 'Schoten Open Spel Tegen',
    ShotsFromDribble: 'Schoten na Dribbel',
    GoalsFromDribble: 'Doelpunten na Dribbel',
    PassesIntoFinalThird: 'Passes naar het Aanvallende Derde',
    PassesIntoFinalThirdTotal: 'Totaal gaat door naar de finale derde',
    PassesInsideFinalThird: 'Passes binnen het Aanvallende Derde',
    PassesInsideFinalThirdTotal: 'Totaal aantal passen binnen Finale ⅓',
    PassesFinalThirdNoArea: 'Passeert laatste derde (Z/O Box)',
    PassesIntoOppBox: 'Passes naar de Tegenstanders 16',
    CarriesFinalThird: 'Dribbels naar het Aanvallende Derde',
    CarriesInsideFinalThird: 'Dribbels binnen het Aanvallende Derde',
    CarriesFinalThirdNoBox: 'Draagt ​​laatste derde (Z/O Box)',
    CarriesIntoOppBox: 'Dribbels naar de Tegenstanders 16',
    TimePossessionAgainst: 'Balbezit van Tegenstander',
    TimePossessionTotal: 'Totaal Balbezit',
    PassesInBox: 'Passes in Eigen 16',
    LongThrowInSuccessful: 'Succesvolle Lange Ingooi',
    LongThrowInTotal: 'Totaal Lange Ingooien',
    LongThrowInPct: '% Succesvolle Lange Ingooien',
    Games: 'Gespeelde spellen',
    PointsPerGame: 'Punten per spel',
    ExpectedPointsDiff: 'Verwacht puntenverschil',
    PassesTotalOwnHalf: 'Totaal passeert eigen helft',
    PassesOwnHalf: 'Passeert eigen helft',
    PassesTotalOppHalf: 'Voldoet aan de totale helft van de tegenstander',
    ProgressivePassesTotal: 'Totaal progressieve passen',
    DuelsWon: 'Duels gewonnen',
    NonPenaltySaves: 'Niet-penalty reddingen',
    BadActionsOppHalf: 'Slechte acties tegenstanderhelft',
    CarriesSuccessful: 'Draagt ​​succesvol',
    ShotsOnTargetOutBox: 'Schoten op doel uit de doos',
    TotalDistance: 'Totale Afstand',
    DistanceIP: 'Afstand TIP',
    DistanceOOP: 'Afstand OTIP',
    SprintsNumber: 'Sprint Kwantiteit',
    SprintsDistance: 'Sprint Afstand',
    WalkingDistance: 'Wandel Afstand',
    JoggingDistance: 'Jog Afstand',
    RunningDistance: 'Rennende Afstand',
    ExtremeAccelerations: 'Extreme Versnellingen',
    NumberOfRuns: 'Runs Kwantiteit',
    HsrNumber: 'HSR Kwantiteit',
    HsrDistance: 'HSR Afstand',
    SprintNumberDeclinePct: '% Sprint Kwantiteit Afname',
    SprintDistanceDeclinePct: '% Sprint Afstand Afname',
    SprintNumberDecline: 'Sprint Kwantiteit Afname',
    SprintDistanceDecline: 'Sprint Afstand Afname',
    HsrDistancePct: '% HSR Afstand',
    SprintDistancePct: '% Sprint Afstand',
    Accelerations: 'Versnellingen',
    ExplosiveDistance: 'Explosieve Afstand',
    MaxSpeed: 'Max. Snelheid',
    AvgMaxSpeed: 'Gem. Max. Snelheid',
    MaxAccelerations: 'Max. Versnellingen',
    BypassedPlayersByPasses: 'Omzeilde Spelers door Passes',
    BypassedDefendersByPasses: 'Omzeilde Verdedigers door Passes',
    PassesBypassingPlayers: 'Passes Omzeilen Spelers',
    PassesBypassingDefenders: 'Passes Omzeilen Verdedigers',
    BypassedPlayersPerPass: 'Omzeilde Spelers per Pass',
    BypassedDefendersPerPass: 'Omzeilde Verdedigers per Pass',
    LineBreakingPasses: 'Lijn Doorbrekende Passes',
    LineBreakingPassesMD: 'Lijn Doorbrekende Passes MD',
    LineBreakingPassesM: 'Lijn Doorbrekende Passes M',
    LineBreakingThroughBalls: 'Lijn Doorbrekende Steekpasses',
    LineBreakingPassesPerPass: '% Lijn Doorbrekende Passes per Pass',
    TotalPassesUnderStrongPressure: 'Totaal Passes Onder Sterke Druk',
    TotalPassesUnderLightPressure: 'Totaal Passes Onder Druk',
    SuccessfulPassesUnderStrongPressure: 'Succesvolle Passes Onder Sterke Druk',
    SuccessfulPassesUnderLightPressure: 'Succesvolle Passes Onder Druk',
    PassingUnderStrongPressure: '% Passen Onder Sterke Druk',
    PassingUnderLightPressure: '% Passen Onder Druk',
    PassReceiptsInSpaceCompleted: 'Pass Ontvangsten in Ruimte Voltooid',
    PassReceiptsInSpace: 'Pass Ontvangsten in Ruimte',
    PassReceiptsInSpaceCompletedFirstThird: 'Ruimteontvangsten Voltooid Eerste Derde',
    PassReceiptsInSpaceCompletedSecondThird: 'Ruimteontvangsten Voltooid Tweede Derde',
    PassReceiptsInSpaceCompletedFinalThird: 'Ruimteontvangsten Voltooid Aanvallend Derde',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Ruimteontvangsten Voltooid Rechterhelft Tegenstander',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Ruimteontvangsten Voltooid Middenhelft Tegenstander',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Ruimteontvangsten Voltooid Linkerhelft Tegenstander',
    PassReceiptsInSpaceFirstThird: 'Ruimteontvangsten Eerste Derde',
    PassReceiptsInSpaceSecondThird: 'Ruimteontvangsten Tweede Derde',
    PassReceiptsInSpaceFinalThird: 'Ruimteontvangsten Aanvallend Derde',
    PassReceiptsInSpaceOppHalfRight: 'Ruimteontvangsten Rechterhelft Tegenstander',
    PassReceiptsInSpaceOppHalfCenter: 'Ruimteontvangsten Middenhelft Tegenstander',
    PassReceiptsInSpaceOppHalfLeft: 'Ruimteontvangsten Linkerhelft Tegenstander',
    TotalStrongOnBallPressures: 'Totaal Sterke Op Bal Druk',
    TotalLightOnBallPressures: 'Totaal Op Bal Druk',
    SuccessfulStrongOnBallPressures: 'Succesvolle Sterke Op Bal Druk',
    SuccessfulLightOnBallPressures: 'Succesvolle Op Bal Druk',
    StrongOnBallPressuresPct: '% Sterke Op Bal Druk',
    LightOnBallPressuresPct: '% Op Bal Druk',
    TimesBypassedByPasses: 'Keer Omzeild door Passes',
    TimesBypassedByCarries: 'Keer Omzeild door Balvoering',
    TimesBypassedByActions: 'Keer Omzeild door Acties',
    BypassedPlayersByCarries: 'Omzeilde Spelers door Balvoering',
    BypassedDefendersByCarries: 'Omzeilde Verdedigers door Balvoering',
    BypassedPlayersByActions: 'Omzeilde Spelers door Acties',
    BypassedDefendersByActions: 'Omzeilde Verdedigers door Acties',
    CarriesBypassingPlayers: 'Balvoering Omzeilen Spelers',
    CarriesBypassingDefenders: 'Balvoering Omzeilen Verdedigers',
    BypassedPlayersPerCarry: 'Omzeilde Spelers per Balvoering',
    BypassedDefendersPerCarry: 'Omzeilde Verdedigers per Balvoering',
    LineBreakingCarries: 'Lijn Doorbrekende Balvoering',
    LineBreakingCarriesMD: 'Lijn Doorbrekende Balvoering MD',
    LineBreakingCarriesM: 'Lijn Doorbrekende Balvoering M',
    LineBreakingCarriesD: 'Lijn Doorbrekende Balvoering D',
    LineBreakingCarriesPerCarry: '% Lijn Doorbrekende Balvoering per Balvoering',
    LineBreakingActions: 'Lijn Doorbrekende Acties',
    LineBreakingActionsMD: 'Lijn Doorbrekende Acties MD',
    LineBreakingActionsM: 'Lijn Doorbrekende Acties M',
    LineBreakingActionsD: 'Lijn Doorbrekende Acties D',
    PassesPerLineBreakingPass: 'Passes per Lijn Doorbrekende Pass',
    CarriesPerLineBreakingCarry: 'Balvoering per Lijn Doorbrekende Balvoering',
    LinesBrokenByPasses: 'Lijnen Gebroken door Passes',
    LinesBrokenByCarries: 'Lijnen Gebroken door Balvoering',
    LinesBrokenByActions: 'Lijnen Gebroken door Acties',
    LinesBrokenPerPass: 'Lijnen Gebroken per Pass',
    LinesBrokenPerCarry: 'Lijnen Gebroken per Balvoering',
    AvgLastDefenderDistanceIP: 'Laatste Verdediger Afstand IP',
    AvgLastDefenderDistanceOOP: 'Laatste Verdediger Afstand OOP',
    AvgDefensiveLineDistanceIP: 'Defensieve Lijn Afstand IP',
    AvgDefensiveLineDistanceOOP: 'Defensieve Lijn Afstand OOP',
    AvgRBDistanceIP: 'Rechtsback Afstand IP',
    AvgRBDistanceOOP: 'Rechtsback Afstand OOP',
    AvgLBDistanceIP: 'Linksback Afstand IP',
    AvgLBDistanceOOP: 'Linksback Afstand OOP',
    AvgBlockDistanceIP: 'Blok Afstand IP',
    AvgBlockDistanceOOP: 'Blok Afstand OOP',
    AvgBlockAreaIP: 'Blok Gebied IP',
    AvgBlockAreaOOP: 'Blok Gebied OOP',
    AvgDefensiveLineWidthOOP: 'Def. Lijn Breedte OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Aanvallende Lijn Laatste Derde Breedte IP',
    AvgLByIP: 'Linksback Positie IP',
    AvgRByIP: 'Rechtsback Positie IP',
    AvgOffensiveLineDistanceIP: 'Aanvallende Lijn Afstand IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Aanvallende Lijn Laatste Derde Afstand IP',
    AvgOffensiveLineWidthIP: 'Aanvallende Lijn Breedte IP',
    OffBallRuns: 'Totaal Off-Bal Runs',
    OffBallRunsOverlap: 'Off-Bal Runs Overlap',
    OffBallRunsUnderlap: 'Off-Bal Runs Underlap',
    OffBallRunsRunAhead: 'Off-Bal Runs Vooruit',
    OffBallRunsRunBehind: 'Off-Bal Runs Achter',
    OffBallRunsCrossReceiver: 'Off-Bal Runs Voorzet Ontvanger',
    OffBallRunsSupport: 'Off-Bal Runs Ondersteuning',
    OffBallRunsComingShort: 'Off-Bal Runs Kort Komend',
    description: {
      Possession: 'Percentage van balbezit van het team',
      TimePossession: 'Tijd van balbezit van het team',
      PassesPerShots: 'Gemiddeld aantal passes gegeven per schot',
      PPDA: 'Toegestane Passes per Defensieve Actie. PPDA meet de druk die het team uitoefent op de tegenstander spelers wanneer zij balbezit hebben. De waarde correspondeert met het gemiddelde aantal passes op rij dat de tegenstander kon voltooien voordat hij werd onderbroken. Hoe hoger de waarde, hoe meer passes de tegenstander mocht voltooien',
      Directness: 'Meet hoe direct een team is. Een hoge waarde van directheid is gerelateerd aan een hogere kwantiteit van voorwaartse passes ten opzichte van zijwaartse passes',
      ExpectedPoints: 'Aantal punten verwacht door een team, berekend op basis van de Verwachte Doelpunten gegenereerd en toegestaan. Deze metriek stelt ons in staat om de prestaties van een team tijdens een wedstrijd (of een reeks wedstrijden) beter te beoordelen in vergelijking met het aantal punten dat daadwerkelijk werd behaald',
      PassesPerLongBall: 'Percentage van succesvolle lange passes uit het totale aantal voltooide passes',
      CrossingPerXG: 'Percentage van Verwachte Doelpunten afkomstig van voorzetten',
      PenaltySavedPenaltyFaced: 'Percentage van Penalty Schoten Gered uit alle Penalty Schoten Geconfronteerd',
      Goals: 'Aantal doelpunten gescoord',
      PenaltyShots: 'Totaal aantal schoten genomen vanaf penalty kicks',
      PenaltyGoals: 'Totaal aantal doelpunten genomen vanaf penalty kicks',
      NonPenaltyGoals: 'Aantal doelpunten gescoord exclusief penalty doelpunten',
      NPGOpenPlay: 'Aantal doelpunten gescoord door open spel acties exclusief penalty doelpunten',
      NPGSetPiece: 'Aantal doelpunten gescoord door vaste situatie acties exclusief penalty doelpunten',
      Shooting: 'Percentage van schoten op doel',
      Finishing: 'Percentage van schoten die eindigen in een doelpunt',
      xGEfficiency: 'Kwantiteit van verwachte doelpunten nodig voor een speler om een doelpunt te scoren',
      HeaderPerShot: 'Aantal kopballen gemaakt',
      HeaderPerCross: 'Percentage van voorzetten gekopt door de speler uit het totale aantal voorzetten voltooid door het team',
      Assists: 'Aantal assists',
      ThroughBalls: 'Aantal ballen gespeeld door voor speler die een aanvallende run maakt om een kans op doel te creëren',
      CrossEfficiency: 'Metriek die percentage van succesvolle voorzetten combineert met het volume van succesvolle voorzetten gemaakt',
      ScoringContribution: 'Aantal assists en doelpunten',
      xAssistsOpenPlay: 'Aantal verwachte assists gegenereerd door open spel',
      xAssistsSetPiece: 'Aantal verwachte assists gegenereerd door vaste situatie',
      xAssistsOpenPlayInTeam: 'Aantal verwachte assists gegenereerd door open spel in team',
      xAssistsSetPieceInTeam: 'Aantal verwachte assists gegenereerd door vaste situatie in team',
      xGChainFinalThird: 'Kwantiteit van xG waar een speler aan heeft deelgenomen in de laatste derde',
      xGBuildupFinalThird: 'Kwantiteit van xG waar een speler aan heeft deelgenomen in de laatste derde (exclusief schoten en passes die leiden tot een schot)',
      BallProgressionPassing: 'Aantal keren dat de speler de bal 10 meter of meer voortbrengt door de bal te passen',
      BallProgressionDribbling: 'Aantal keren dat de speler de bal 10 meter of meer voortbrengt door de bal te dragen',
      TacklesWasDribbled: 'Metriek die rekening houdt met het percentage keren dat de speler de bal herwint via tackelen versus de keren dat het werd gepasseerd/gerend. Hoe hoger de indicator, hoe beter',
      TacklesSuccessful: 'Aantal succesvolle tackles gemaakt door de speler',
      Interceptions: 'Aantal keren dat de speler een pass onderschept om te voorkomen dat de bal zijn doel bereikt',
      Clearances: 'Aantal keren dat de speler de bal vrij slaat uit de defensieve zone',
      Fouls: 'Aantal overtredingen begaan door de speler',
      Recoveries: 'Aantal ballen herwonnen door een speler',
      Shots: 'Aantal totale schoten gemaakt',
      ShotsPerGoal: 'Schoten op doel nodig om een niet-penalty doelpunt te scoren tegen de Doelman',
      ShortPassesSuccessful: 'Korte passes (onder 12 meter) voltooid',
      PassingSuccessForwardPct: 'Percentage van succesvolle passes in de voorwaartse richting',
      PassingSuccessBackwardPct: 'Percentage van succesvolle passes achterwaarts',
      PassingForwardBackwardPct: 'Verhouding van passes in de voorwaartse richting tegen passes achterwaarts',
      LongBallPerPassesPct: 'Percentage van lange passes voltooid (>32 meter) uit alle passes voltooid door de speler.',
      LongBallReceived: 'Lange passes (>32 meter) ontvangen door de speler',
      LongBallReceivedOppHalf: 'Lange passes (>32 meter) ontvangen door de speler op de tegenstander helft',
      OffensiveActions: 'Aanvallende Acties',
      DribblesAttempted: 'Dribbels geprobeerd',
      SuccessfulDribblesPct: 'Succesvolle dribbels/totaal van dribbel pogingen',
      OffensiveTouchesOutBoxPct: '% Aanvallende Aanrakingen Buiten Zestienmetergebied',
      BallRetention: 'Percentage van de tijd dat je balbezit hebt en het niet verliest',
      PassingPct: 'Percentage van passes voltooid uit alle passes gegeven door de speler',
      PassingOwnHalfPct: 'Percentage van passes voltooid uit alle passes gegeven door de speler (alleen passes op de eigen helft)',
      PassingOppHalfPct: 'Percentage van passes voltooid uit alle passes gegeven door de speler (alleen passes naar tegenstander helft)',
      PassingFinalThird: 'Succesvolle passes naar de laatste derde',
      PassesFinalThirdTotal: 'Het totale aantal pogingen tot passes, exclusief voorzetten, spelhervattingen, corners en inworpen, die eindigen in het laatste derde deel',
      PassingFinalThirdPct: 'Percentage van passes voltooid uit alle passes gegeven door de speler (alleen passes naar laatste derde)',
      LongBallSuccessful: 'Voltooide passes over 32 meter',
      LongBallPct: 'Voltooide passes over 32 meter/ Totaal passes over 32 geprobeerd.',
      LongBallTotal: 'Totaal aantal passen over 32 meter',
      SavesPct: 'Percentage van reddingen uit het totale aantal schoten toegestaan',
      SavesInBoxPct: 'Percentage van geredde schoten die binnen het zestienmetergebied komen',
      SavesOutOfBoxPct: 'Percentage van geredde schoten die buiten het zestienmetergebied komen',
      xGSavedPerXGFacedOnTarget: 'Coëfficiënt dat het percentage van de verwachte xG aangeeft dat worden gered door de Doelman. Een waarde van 1 in deze metriek zou betekenen dat de doelman alle verwachte doelpunten van de schoten toegestaan door het team redt, terwijl een waarde van 0 zou betekenen dat alle verwachte doelpunten gegenereerd door de tegenstander eindigen in een doelpunt',
      xGFacedOnTargetPerGoalReceived: 'Metriek die aangeeft hoeveel Verwachte Doelpunten nodig zijn om een doelpunt te scoren tegen een bepaalde Doelman. Een hoge score in deze metriek betekent dat om een doelpunt te converteren tegen deze Doelman het nodig is om een hoog aantal xG te creëren',
      xGFacedOnTargetEfficiency: 'Aantal Niet-Penalty Doelpunten voorkomen door de Doelman. Dit is het aantal Verwachte Doelpunten Op Doel ontvangen door de Doelman minus het aantal (niet-penalty) doelpunten toegestaan. Geeft het aantal doelpunten aan dat niet werden gescoord door de tegenstander dankzij de doelman',
      xGFacedOnTarget: 'Totale xG (gered en gescoord) geconfronteerd door de doelman',
      IndividualPressure: 'Metriek die het aantal succesvolle inspanningen (balbezit herwonnen) meet die een speler maakt bij het drukken van de tegenstander',
      AerialEfficiency: 'Metriek die percentage van succesvolle luchtduels combineert met het volume van luchtduel overwinningen',
      AerialWins: 'Aantal luchtduels dat de speler wint',
      AerialWinsPct: 'Aantal luchtduels dat de speler wint uit het totale aantal luchtduels waarbij de speler betrokken was',
      xG: 'Verwachte Doelpunten gegenereerd. Deze metriek meet de waarschijnlijkheid van een schot om te eindigen in een doelpunt gebaseerd op verschillende variabelen (afstand, hoek, type spel, lichaamsdeel, ...) van zo\'n actie.',
      xGDiff: 'Verschil tussen xG en Doelpunten',
      xGOpenPlay: 'Verwachte Doelpunten gegenereerd door Open Spel',
      xGSetPiece: 'Verwachte Doelpunten gegenereerd door Vaste Situatie',
      xGPerShot: 'Gemiddelde xG van de schoten gemaakt door een speler. Deze metriek meet de gemiddelde gevaarlijkheid van de genomen schoten. Hoe hoger, hoe waarschijnlijker het is dat je schoten eindigen in een doelpunt. Een hoge xG per schot betekent dat de speler zijn schoten goed kiest.',
      ChancesCreated: 'Aantal passes die leiden tot een schot',
      CompletedCrosses: 'Aantal Voorzetten Voltooid',
      Crossing: 'Percentage van voorzetten die zijn voltooid uit voorzetten geprobeerd',
      OpenPlayKeyPasses: 'Aantal passes voltooid tijdens open spel',
      OpenPlayKeyPassesInTeam: 'Percentage van passes voltooid tijdens open spel in team',
      OpenPlayPassesIntoOpponentBox: 'Totaal aantal passes geprobeerd naar het tegenstander zestienmetergebied tijdens open spel',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Aantal passes voltooid naar het tegenstander zestienmetergebied tijdens open spel',
      xAssists: 'Metriek die de kwaliteit van de gecreëerde kansen analyseert die plaatsvinden in een wedstrijd. Elke schot assist heeft een waarde gebaseerd op de waarschijnlijkheid dat het schot eindigt in een doelpunt. Deze waarde wordt toegewezen volgens de plaats van de pass, het type (voorzet steekpass vaste situatie...), staat van het spel etc. In tegenstelling tot xG, is xA een metriek die ideaal een speler hoger zou hebben dan zijn assist nummers omdat een creator alleen zijn kwaliteit passes kan controleren (xA), terwijl zijn assist nummers afhangen van de finisher',
      xGChain: 'Kwantiteit van xG waar een speler aan heeft deelgenomen',
      xGBuildup: 'Vergelijkbaar met xG Chain maar niet rekening houdend met de laatste 2 spelers van de sequentie (exclusief schoten en passes die leiden tot een schot)',
      xGBuildupInTeam: 'Vergelijkbaar met xG Chain maar niet rekening houdend met de laatste 2 spelers van de sequentie (exclusief schoten en passes die leiden tot een schot) in team',
      BallProgression: 'Aantal keren dat de speler 10 of meer meter vooruitgaat door te passen, door de bal te dragen of een combinatie van beide',
      SuccessfulDribbles: 'Dribbels succesvol voltooid',
      Dispossessed: 'Aantal keren dat een speler wordt getackeld en het balbezit verliest',
      TouchesInOpponentBox: 'Aantal keren dat het balbezit in het tegenstander zestienmetergebied is',
      xGSavedPerShot: 'Gemiddelde waarschijnlijkheid van doelpunt van toegestane schoten op doel',
      BallRetentionOppHalf: 'Percentage van de tijd dat je balbezit hebt en het niet verliest in de tegenstander helft',
      DeepProgression: 'Aantal keren dat de laatste vijfde van het veld wordt bereikt door de bal te dragen, plus het aantal keren dat het balbezit in de laatste vijfde is',
      DeepProgressionFinalThird: 'Aantal keren dat de laatste derde van het veld wordt bereikt door de bal te dragen, plus het aantal keren dat het balbezit in de laatste derde is',
      FoulsTaken: 'Aantal keren dat de speler werd gefouled',
      PenaltiesTaken: 'Aantal keren dat de speler werd gefouled in het tegenstander zestienmetergebied',
      BlockedCrosses: 'Voorzetten geblokkeerd',
      BlockedShots: 'Schoten geblokkeerd',
      NonPenaltyGoalsAgainst: 'Aantal niet-penalty doelpunten toegestaan',
      GoalsConceded: 'Aantal tegendoelpunten',
      Headers: 'Aantal Schoten gemaakt met het Hoofd',
      HeadedGoals: 'Aantal doelpunten gescoord met het hoofd',
      Points: 'Aantal punten behaald door het team',
      SavesInBox: 'Aantal reddingen uit schoten in het strafschopgebied',
      SavesOutBox: 'Aantal reddingen uit schoten buiten het strafschopgebied',
      ShotsOnTargetInBoxAgainst: 'Aantal toegekende schoten op doel vanuit het strafschopgebied',
      ShotsOnTargetOutBoxAgainst: 'Aantal toegekende schoten op doel van buiten het strafschopgebied',
      AveragePassDistance: 'Gemiddelde Afstand van Passes in meters',
      ProgressiveRuns: 'Succesvolle balvoering die het balbezit 20% dichter bij het tegenstander doel brengt',
      xT: 'Verwachte Bedreiging (xT) is een metriek die de bedreiging meet die een speler creëert voor de tegenstander door de bal te dragen of te passen naar gebieden waar de waarschijnlijkheid van het balbezit om te eindigen in een doelpunt hoger is.',
      xTOpenPlay: 'Verwachte Bedreiging gegenereerd tijdens open spel',
      xTSetPiece: 'Verwachte Bedreiging gegenereerd door vaste situatie',
      xGOT: 'Verwachte Doelpunten Op Doel. Aantal Verwachte Doelpunten geconfronteerd door de Doelman. Deze metriek houdt alleen rekening met schoten op doel (Gemiste schoten en schoten op paal zijn uitgesloten)',
      BadActions: 'Som van alle slechte acties begaan (pass onsuccesvol, take on onsuccesvol, balverlies, buitenspel pass, bal aanraking onsuccesvol)',
      BadActionsOwnHalf: 'Som van alle slechte acties begaan (pass onsuccesvol, take on onsuccesvol, balverlies, buitenspel pass, bal aanraking onsuccesvol) in de eigen helft',
      AerialsWonOwnBox: 'Luchtduel Overwinningen Eigen Zestienmetergebied',
      AerialsWonOppBox: 'Luchtduels Overwinningen Tegenstander Zestienmetergebied',
      AerialsTotalOppBox: 'Luchtduels Totaal Tegenstander Zestienmetergebied',
      AerialsTotalOwnBox: 'Luchtduels Totaal Eigen Zestienmetergebied',
      FoulsOwnHalfPct: 'Percentage van Overtredingen begaan in de eigen helft',
      RecoveriesOppHalf: 'Aantal ballen herwonnen door een speler in de tegenstander helft',
      DuelsPct: 'Percentage van Succesvolle Duels',
      TacklesUnsuccessful: 'Aantal keren dat een speler faalt om de bal te winnen terwijl een tegenstander succesvol langs hem dribbelt',
      TacklesWasDribbledFirstThird: 'Percentage van keren dat de speler de bal herwint wanneer geconfronteerd in de laatste derde',
      TacklesWasDribbledSecondThird: 'Gewonnen defensieve 1-tegen-1-duels  ⅔',
      TacklesWasDribbledFinalThird: 'Gewonnen defensieve 1-tegen-1-duels  Laatste ⅓',
      BallProgressionFinalThird: 'Balvoortgang Laatste Derde',
      DuelsTotal: 'Totaal aantal Tackles, Luchtduels, Bal Aanrakingen, Dribbels en Overtredingen begaan',
      QuickRecoveries: 'Herwinnen 40 meter of meer van het eigen doel gemaakt 8 seconden na het verliezen van het balbezit',
      ShotsPerNPG: 'Gemiddeld aantal schoten om een Niet-Penalty Doelpunt te scoren',
      ShotsOutBox: 'Aantal Schoten van buiten het zestienmetergebied',
      GoalsOutBox: 'Aantal Doelpunten van buiten het zestienmetergebied',
      ShootingOutBox: 'Percentage van schoten op doel van buiten het Zestienmetergebied',
      HandPassing: 'Pass Nauwkeurigheid met Handen',
      Catching: 'Percentage van Reddingen waarin de Doelman de bal vangt',
      Caught: 'Bewaart waar de doelverdediger de bal vangt en vasthoudt, waardoor een tweede spel wordt voorkomen',
      ClaimAccuracy: 'Meet hoe goed een Doelman is in het vangen/blokkeren van luchtballen. Een nummer boven 1 geeft aan dat de Doelman meer luchtballen vangt dan verwacht',
      HighTurnovers: 'Balverlies dichter dan 40 meter van het eigen doel',
      ShotEndingHighTurnovers: 'Hoge balverlies (balverlies dichter dan 40 meter van het eigen doel) eindigend in een schot van het tegenstander team',
      GoalEndingHighTurnovers: 'Hoge balverlies (balverlies dichter dan 40 meter van het eigen doel) eindigend in een doelpunt van het tegenstander team',
      AverageCarriesProgress: 'Gemiddelde afstand dat een speler de bal verticaal verplaatst per balvoering (meters)',
      ChanceEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een pass die wordt gevolgd door een schot',
      AssistEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een pass die wordt gevolgd door een doelpunt',
      ShotEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een schot',
      GoalEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een doelpunt',
      ShotEndingSequence: 'Aantal Sequenties eindigend in een Schot waarbij de speler betrokken was',
      GoalEndingSequence: 'Aantal Sequenties eindigend in een Doelpunt waarbij de speler betrokken was',
      xGPerNPG: 'Verwachte Doelpunten nodig om een niet-penalty doelpunt te scoren',
      AerialWonOffensive: 'Aanvallende Luchtduel Overwinningen',
      AerialWonDefensive: 'Defensieve Luchtduel Overwinningen',
      xGAgainst: 'Verwachte Doelpunten Toegestaan',
      xGDiffAgainst: 'Verschil tussen Verwachte Doelpunten Toegestaan en Doelpunten Toegestaan',
      xGPerNPGAgainst: 'Verwachte Doelpunten ontvangen per Niet-Penalty Doelpunt Toegestaan',
      xGSetPieceAgainst: 'Verwachte Doelpunten gegenereerd door Vaste Situatie Toegestaan',
      xGOpenPlayAgainst: 'Verwachte Doelpunten gegenereerd door Open Spel Toegestaan',
      xGPerShotAgainst: 'Verwachte Doelpunten Ontvangen per Schot Toegestaan',
      ShotsAgainst: 'Aantal Schoten Toegestaan',
      ShotsOnTargetAgainst: 'Aantal Schoten op Doel Toegestaan',
      RivalPossession: 'Balbezit van de tegenstander',
      AerialDefensivePct: 'Percentage van Luchtduel overwinningen zonder balbezit',
      HighRecoveries: 'Herwinnen gemaakt 40 meter of dichter bij het tegenstander doel',
      HighDefensiveActions: 'Defensieve Acties (Tackles, Onderscheppingen, Blokkades, Overtredingen en 1vs1) gemaakt 40 meter over de eigen basislijn',
      HighDefensiveActionPct: 'Percentage van Defensieve Acties (Tackles, Onderscheppingen, Blokkades, Overtredingen en 1vs1) gemaakt 40 meter over de eigen basislijn',
      HighDefensiveDistance: 'Gemiddelde afstand van eigen doel van alle Defensieve Acties',
      PassesPerPossession: 'Aantal Passes per Balbezit',
      LengthPerPossession: 'Afstand per Balbezit',
      xTNet: 'Netto xT',
      AvgCarriesDistance: 'Gemiddelde Balvoering Afstand',
      PassesForwardPct: '% Passes Gaan Voorwaarts',
      PassesForwardSuccessful: 'Succesvolle voorwaartse passen',
      PassesForwardTotal: 'Totaal aantal voorwaartse passen',
      TacklesAttempted: 'Tackles Geprobeerd',
      DuelsLost: 'Duels Verloren',
      Carries: 'Balvoering',
      CarriesPct: '% Balvoering',
      Aerials: 'Totaal aantal Luchtduels',
      ProgressivePassesReceivedIntoBox: 'Progressieve Passes Ontvangen naar Zestienmetergebied',
      PassesOppHalf: 'Succesvolle passes eindigend naar de tegenstander helft',
      ShotsOnTarget: 'Schoten gemaakt op Doel',
      AggressiveActions: 'Aantal Tackles geprobeerd in de volgende twee seconden na het verliezen van het balbezit',
      Crosses: 'Totaal Aantal Voorzetten',
      xGBuildup5pass: 'Kwantiteit van xG waar een speler aan heeft deelgenomen, alleen laatste 5 passes (exclusief schoten en passes die leiden tot een schot)',
      DefensiveDistance: 'Gemiddelde afstand tot eigen doel van defensieve duels uitgevoerd',
      SpeedSequence: 'Gemiddelde Snelheid (meters afgelegd door tijd besteed) van alle balbezit van een team',
      Touches: 'Aantal keren dat een speler balbezit heeft',
      AerialsTotalOppHalf: 'Luchtduels totaal naar tegenstander helft',
      AerialsWonOppHalf: 'Luchtduels succesvol in de helft van de tegenstander',
      AerialsWonOppHalfPct: 'Percentage van luchtduel overwinningen naar tegenstander helft',
      AerialsPctOppBox: 'Percentage van luchtduel overwinningen naar tegenstander zestienmetergebied',
      AerialsPctOwnBox: 'Percentage van luchtduel overwinningen naar eigen zestienmetergebied',
      AerialDefensive: 'Totaal aantal Luchtduels wanneer tegenstander team balbezit heeft',
      AerialOffensive: 'Totaal aantal Luchtduels wanneer eigen team balbezit heeft',
      AerialOffensivePct: 'Percentage van Luchtduel overwinningen wanneer eigen team balbezit heeft',
      IndividualPressureOppHalf: 'Metriek die het aantal succesvolle inspanningen (balbezit herwonnen) meet die een speler maakt bij het drukken van de tegenstander in de tegenstander helft',
      ChancesCreatedOP: 'Aantal passes die leiden tot een schot tijdens open spel',
      TouchesPerShot: 'Aantal keren dat spelers de bal aanraken per schot',
      PassesFinalThirdTotalPct: 'Percentage van passes (succesvol en onsuccesvol) naar laatste derde',
      xACrosses: 'Verwachte assists gegenereerd van voorzetten',
      Passes: 'Totaal aantal passes',
      PassesSuccessful: 'Aantal Voltooide Passes',
      TacklesWasDribbledFouls: 'Percentage van tackles gewonnen ten opzichte van totale tackles en overtredingen begaan',
      OffsidesCaught: 'Buitenspel Gevangen',
      ProgressivePassesReceivedFinalThird: 'Progressieve Passes Ontvangen Laatste ⅓',
      ProgressivePassesReceived: 'Progressieve Passes Ontvangen',
      Breadth: 'Som van Tackles, Uitdagingen, Onderscheppingen en Overtredingen Bepleegd, aan de zijkanten van het veld',
      DuelsDefTotal: 'Som van totaal Tackles, Defensieve Luchtduels en Overtredingen begaan',
      DefensiveActions: 'Defensieve Acties wanneer een tegenstander probeert te dribbelen (Tackles, Uitdagingen en Overtredingen)',
      ProgressivePassesReceivedOppHalf: 'Progressieve Passes Ontvangen Tegenstander Helft',
      CompletedCrossesOP: 'Voltooide Voorzetten Open Spel',
      CrossingOP: 'Percentage van voorzetten voltooid uit alle voorzetten geprobeerd open spel',
      CrossesOP: 'Totaal aantal voorzetten tijdens open spel',
      PassingContribution: 'Percentage dat de bedreiging van passes meet rekening houdend met de positie van de ontvanger',
      BallProgressionOppHalfInTeam: '% Balvoortgang Tegenstander Helft in Team',
      PassesOPIntoBoxInTeam: '% Passes Open Spel naar Zestienmetergebied in Team',
      TouchesOppBoxInTeam: '% Aanrakingen Tegenstander Zestienmetergebied in Team',
      xGOPInTeam: '% xG Open Spel in Team',
      DeepPasses: 'Passes van buiten een 20-meter radius van het tegenstander doel die eindigen binnen dat gebied',
      DeepPassesTotal: 'Totaal aantal pogingen van buiten een straal van 20 meter rond het doel van de tegenstander die binnen dat gebied eindigen',
      DefensiveDuelsPct: 'Percentage van defensieve duels gewonnen uit totaal defensieve duels',
      QuickRecoveriesPct: 'Percentage van snelle herwinnen tot onderscheppingen en geprobeerde tackles',
      DiffDefensiveDistanceTeam: 'Verschil tussen de defensieve afstand van de speler en de defensieve afstand van zijn team',
      xTPassing: 'Verwachte bedreiging gegenereerd alleen van passes',
      xTPassing100Passes: 'Verwachte bedreiging gegenereerd alleen van passes en per 100 passes',
      ProgressivePassesAccurate: 'Voltooide passes van 10 meter of meer in de X-as',
      PassAbility: 'Verhouding van voltooide passes tot verwachte passes (xP)',
      OPPassesIntoOppBoxPct: 'Percentage van open spel voltooide passes naar het tegenstander zestienmetergebied en open spel geprobeerde passes naar het tegenstander zestienmetergebied',
      EntriesOppBox: 'Aantal passes en balvoering naar het tegenstander zestienmetergebied',
      Crosses6yardBox: 'Totaal aantal voorzetten eindigend in het zes-yard gebied',
      Cutbacks: 'Passen van basislijn naar achter en binnen het tegenstander zestienmetergebied',
      xTDribbling: 'Verwachte bedreiging gegenereerd alleen van dribbels',
      AvgShotDistance: 'Gemiddelde afstand van het totale aantal schoten genomen',
      xGOnTarget: 'Verwachte doelpunten van schoten gemaakt op doel. Meet de waarschijnlijkheid van een schot om te eindigen in een doelpunt met behulp van de eindlocatie van het schot',
      FinishingxGOT: 'Percentage van schoten op doel eindigend in een doelpunt boven gemiddelde. Deze metriek meet hoeveel waarde de aanvaller toevoegt met de kwaliteit van zijn schoten',
      DribblesWonOwnHalf: 'Succesvolle dribbels gemaakt in eigen helft',
      DribblesOwnHalf: 'Aantal geprobeerde dribbels gemaakt in eigen helft',
      DribblesOwnHalfPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in eigen helft',
      DribblesWonOppHalf: 'Succesvolle dribbels gemaakt in tegenstander helft',
      DribblesOppHalf: 'Aantal geprobeerde dribbels gemaakt in tegenstander helft',
      DribblesOppHalfPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in tegenstander helft',
      DribblesWonFinalThird: 'Succesvolle dribbels gemaakt in de laatste derde',
      DribblesFinalThird: 'Aantal geprobeerde dribbels gemaakt in de laatste derde',
      DribblesFinalThirdPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in de laatste derde',
      ShotEndingHighRecoveries: 'Hoge herwinnen (herwinnen gemaakt 40 meter of dichter bij het tegenstander doel) eindigend in een schot',
      PassingFinalThirdAgainst: 'Succesvolle passes van de tegenstander naar de laatste derde',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Totaal aantal passes geprobeerd van de tegenstander naar het eigen zestienmetergebied tijdens open spel',
      EntriesOppBoxAgainst: 'Aantal passes en balvoering van de tegenstander naar het eigen zestienmetergebied',
      DeepProgressionAgainst: 'Aantal keren dat de tegenstander de laatste vijfde van het veld bereikt door de bal te dragen, plus het aantal keren dat het balbezit in de eerste vijfde is',
      TouchesInOpponentBoxAgainst: 'Aantal keren dat de tegenstander balbezit heeft in ons zestienmetergebied',
      Score: 'Speler prestaties gebaseerd op verschillende metrieken',
      PDScore: 'Speler fysieke prestaties gebaseerd op verschillende fysieke metrieken',
      OrlegiScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      SirScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      ExcScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      xTOPInTeam: 'Verwachte bedreiging gegenereerd tijdens open spel in team',
      YellowCards: 'Gele kaarten ontvangen',
      RedCards: 'Rode kaarten ontvangen',
      xTOpenPlayAgainst: 'Verwachte Bedreiging toegestaan tijdens open spel',
      xTSetPieceAgainst: 'Verwachte Bedreiging toegestaan door vaste situatie',
      NPGOpenPlayAgainst: 'Aantal doelpunten toegestaan door open spel acties exclusief penalty doelpunten',
      NPGSetPieceAgainst: 'Aantal doelpunten toegestaan door vaste situatie acties exclusief penalty doelpunten',
      PassesOppHalfPerPossession: 'Passes Tegenstander Helft per Balbezit',
      AverageTimeRecovery: 'Gem. Tijd Herstel',
      ExpectedPassing: 'Percentage van Passes die hadden moeten worden voltooid',
      NumPossession10Passes: 'Balbezit gegenereerd door 10 of meer passes',
      PassesReceived: 'Passes Ontvangen',
      PassesReceivedFinalThird: 'Passes Ontvangen Laatste ⅓',
      ProgressivePassesTotalPct: 'Percentage van Progressieve Passes',
      ShortPassesPct: 'Percentage van Korte Passes',
      TouchesOppBoxOppTeam: 'Aantal tegenstander acties toegestaan binnen eigen zestienmetergebied terwijl de speler op het veld is',
      ShotsOnTargetOppTeam: 'Schoten op doel toegestaan terwijl de speler op het veld is',
      NPGOppTeam: 'Niet-penalty doelpunten toegestaan terwijl de speler op het veld is',
      xGSetPiecePerxG: 'Verwachte Doelpunten gegenereerd door vaste situatie nodig om één verwacht doelpunt te genereren',
      ShotsOpenPlay: 'Aantal schoten gegenereerd door open spel',
      ShotsOpenPlayAgainst: 'Aantal schoten ontvangen door open spel',
      ShotsFromDribble: 'Schoten die worden afgevuurd nadat een tegenstander is uitgekapt',
      GoalsFromDribble: 'Doelpunten die worden gescoord nadat een tegenstander is uitgekapt',
      PassesIntoFinalThird: 'Geslaagde passes vanuit het aanvallende derde',
      PassesIntoFinalThirdTotal: 'Totaal aantal pogingen geprobeerd die buiten beginnen en eindigen in het laatste derde deel',
      PassesInsideFinalThird: 'Geslaagde passes binnen het aanvallende derde (begin en eind in dat gebied)',
      PassesInsideFinalThirdTotal: 'Totaal aantal pogingen tot passen in het laatste derde deel (start en einde in het laatste derde deel)',
      PassesFinalThirdNoArea: 'Passeert laatste derde (Z/O Box)',
      PassesIntoOppBox: 'Geslaagde passes die eindigen in het strafschopgebied van de tegenstander',
      CarriesFinalThird: 'Dribbels van minstens 7 meter die eindigen in het aanvallende derde',
      CarriesInsideFinalThird: 'Dribbels van minstens 7 meter binnen het aanvallende derde (begin en eind in dat gebied)',
      CarriesFinalThirdNoBox: 'Draagt ​​laatste derde (Z/O Box)',
      CarriesIntoOppBox: 'Dribbels van minstens 7 meter die eindigen in het strafschopgebied van de tegenstander',
      TimePossessionAgainst: 'Balbezit van de tegenstander',
      TimePossessionTotal: 'Totaal balbezit van beide teams',
      PassesInBox: 'Geslaagde passes binnen het eigen strafschopgebied',
      LongThrowInSuccessful: 'Succesvolle lange inworp vanaf de zijlijn, gericht op meer dan 20 meter',
      LongThrowInTotal: 'Totaal aantal lange inworpen vanaf de zijlijn, gericht op meer dan 20 meter',
      LongThrowInPct: 'Percentage van succesvolle lange inworpen (20+ meter)',
      Games: 'Gespeelde spellen',
      PointsPerGame: 'Punten per spel',
      ExpectedPointsDiff: 'Verwacht puntenverschil',
      PassesTotalOwnHalf: 'Totaal aantal passes vanaf de eigen helft',
      PassesOwnHalf: 'Aantal succesvolle passes vanaf de eigen helft',
      PassesTotalOppHalf: 'Totaal aantal passes vanaf de helft van de tegenstander',
      ProgressivePassesTotal: 'Totaal aantal passages van 10 meter of meer in de X-as',
      DuelsWon: 'Succesvolle duels (tackles, luchtaanvallen, balaanrakingen, dribbels en gemaakte fouten)',
      NonPenaltySaves: 'Bespaart exclusief strafschoppen',
      BadActionsOppHalf: 'Som van alle gepleegde slechte acties (pass niet succesvol, take-on mislukt, onteigend, buitenspelpass, balaanraking mislukt) op de helft van de tegenstander',
      CarriesSuccessful: 'Aantal carry\'s van minimaal 7 meter eindigend met een succesvol evenement',
      ShotsOnTargetOutBox: 'Schoten op doel van buiten het strafschopgebied',
      TotalDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd',
      WalkingDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid lager dan 2 m/s (7.2 km/h)',
      JoggingDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid tussen 2 m/s (7.2 km/h) en 4 m/s (14.4 km/h)',
      RunningDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid tussen 4 m/s (14.4 km/h) en 5.5 m/s (19.8 km/h)',
      ExtremeAccelerations: 'Aantal keren dat de Speler meer dan 3 m/s<sup>2</sup> versnelt',
      NumberOfRuns: 'Aantal runs voltooid bij een snelheid tussen 4 m/s (14.4 km/h) en 5.5 m/s (19.8 km/h)',
      DistanceIP: 'Afstand (Team In Balbezit) die de Speler heeft afgelegd tijdens een wedstrijd met balbezit',
      DistanceOOP: 'Afstand OTIP (Tegenstander Team In Balbezit) die de Speler heeft afgelegd tijdens een wedstrijd zonder balbezit',
      HsrNumber: 'Aantal keren dat de Speler beweegt bij een snelheid die groter is dan of gelijk aan 5.5 m/s (19.8 km/h) maar minder dan 7 m/s (25.2 km/h) voor een tijdsperiode van ten minste 1 seconde',
      HsrDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid die groter is dan of gelijk aan 5.5 m/s (19.8 km/h) maar minder dan 7 m/s (25.2 km/h)',
      HsrDistancePct: 'Percentage van HSR (Hoge Snelheid Run) Afstand ten opzichte van totale afstand afgelegd',
      SprintsNumber: 'Aantal keren dat de Speler beweegt bij een snelheid die groter is dan of gelijk aan 7 m/s (25.2 km/h) voor een tijdsperiode van ten minste 1 seconde',
      SprintsDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid die groter is dan of gelijk aan 7 m/s (25.2 km/h)',
      SprintNumberDeclinePct: 'Percentage afname in het aantal sprints uitgevoerd vergeleken met de tweede helft van de wedstrijd',
      SprintDistanceDeclinePct: 'Percentage afname in de afstand gerend tijdens sprinten vergeleken met de tweede helft van de wedstrijd',
      SprintNumberDecline: 'Afname in het aantal sprints uitgevoerd vergeleken met de tweede helft van de wedstrijd',
      SprintDistanceDecline: 'Afname in de afstand gerend tijdens sprinten vergeleken met de tweede helft van de wedstrijd',
      SprintDistancePct: 'Percentage van Sprint Afstand ten opzichte van totale afstand afgelegd',
      Accelerations: 'Aantal keren dat de Speler versnelt tussen 1.5 m/s<sup>2</sup> en 3 m/s<sup>2</sup>',
      ExplosiveDistance: 'Explosieve Afstand',
      MaxSpeed: 'Maximale snelheid bereikt door de speler',
      AvgMaxSpeed: 'Gemiddelde van maximale snelheid bereikt door de speler',
      MaxAccelerations: 'Maximale meters/seconde<sup>2</sup> bereikt door de speler',
      BypassedPlayersByPasses: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via passes',
      BypassedDefendersByPasses: 'Totaal aantal tegenstanders (verdedigers) omzeild via passes',
      PassesBypassingPlayers: 'Aantal passes die spelers omzeilden',
      PassesBypassingDefenders: 'Aantal passes die verdedigers omzeilden',
      BypassedPlayersPerPass: 'Totaal aantal spelers omzeild per passes',
      BypassedDefendersPerPass: 'Totaal aantal verdedigers omzeild per passes',
      LineBreakingPasses: 'Aantal voltooide passes die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingPassesMD: 'Aantal voltooide passes die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingPassesM: 'Aantal voltooide passes die succesvol middenvelder lijn penetreren',
      LineBreakingThroughBalls: 'Aantal voltooide passes die succesvol defensieve lijn penetreren',
      LineBreakingPassesPerPass: 'Percentage van lijn doorbrekende passes per pass',
      TotalPassesUnderStrongPressure: 'Totaal aantal passes gemaakt onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      TotalPassesUnderLightPressure: 'Totaal aantal passes gemaakt onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      SuccessfulPassesUnderStrongPressure: 'Aantal succesvolle passes gemaakt onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      SuccessfulPassesUnderLightPressure: 'Aantal succesvolle passes gemaakt onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      PassingUnderStrongPressure: 'Percentage van succesvolle passes en totale passes beide onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      PassingUnderLightPressure: 'Percentage van succesvolle passes en totale passes beide onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      PassReceiptsInSpaceCompleted: 'Passes gemaakt waar de ontvanger in de aanvallende helft is en geen verdediger heeft in een 5 meter radius richting het doel',
      PassReceiptsInSpace: 'Passes ontvangen in de aanvallende helft en er is geen verdediger in een 5 meter radius richting het doel',
      PassReceiptsInSpaceCompletedFirstThird: 'Passes waarbij de ontvanger zich in het eerste derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedSecondThird: 'Passes waarbij de ontvanger zich in het tweede derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedFinalThird: 'Passes waarbij de ontvanger zich in het aanvallende derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passes waarbij de ontvanger zich in de rechterhelft van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passes waarbij de ontvanger zich in het midden van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passes waarbij de ontvanger zich in de linkerhelft van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceFirstThird: 'Passes ontvangen in het eerste derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceSecondThird: 'Passes ontvangen in het tweede derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceFinalThird: 'Passes ontvangen in het aanvallende derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfRight: 'Passes ontvangen in de rechterhelft van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfCenter: 'Passes ontvangen in het midden van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfLeft: 'Passes ontvangen in de linkerhelft van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      TotalStrongOnBallPressures: 'Aantal sterke op-bal druk (binnen 0-2 meter van de bal drager)',
      TotalLightOnBallPressures: 'Aantal op-bal druk (binnen 2-4 meter van de bal drager)',
      SuccessfulStrongOnBallPressures: 'Aantal succesvolle sterke op-bal druk (binnen 0-2 meter)',
      SuccessfulLightOnBallPressures: 'Aantal succesvolle op-bal druk (binnen 2-4 meter)',
      StrongOnBallPressuresPct: 'Percentage van succesvolle en totale sterke op-bal druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      LightOnBallPressuresPct: 'Percentage van succesvolle en totale op-bal druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      TimesBypassedByPasses: 'Totaal aantal keren omzeild door pass',
      TimesBypassedByCarries: 'Totaal aantal keren omzeild door balvoering',
      TimesBypassedByActions: 'Totaal aantal keren omzeild door pass en balvoering gecombineerd',
      BypassedPlayersByCarries: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via balvoering',
      BypassedDefendersByCarries: 'Totaal aantal tegenstanders (verdedigers) omzeild via balvoering',
      BypassedPlayersByActions: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via passes en balvoering gecombineerd',
      BypassedDefendersByActions: 'Totaal aantal tegenstanders (verdedigers) omzeild via passes en balvoering gecombineerd',
      CarriesBypassingPlayers: 'Aantal balvoering die spelers omzeilden',
      CarriesBypassingDefenders: 'Aantal balvoering die verdedigers omzeilden',
      BypassedPlayersPerCarry: 'Gemiddeld aantal tegenstanders omzeild per balvoering',
      BypassedDefendersPerCarry: 'Gemiddeld aantal verdedigers omzeild per balvoering',
      LineBreakingCarries: 'Aantal balvoering die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingCarriesMD: 'Aantal balvoering die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingCarriesM: 'Aantal balvoering die succesvol middenvelder lijn penetreren',
      LineBreakingCarriesD: 'Aantal balvoering die succesvol defensieve lijn penetreren',
      LineBreakingCarriesPerCarry: 'Percentage van lijn doorbrekende balvoering per balvoering',
      LineBreakingActions: 'Aantal passes en balvoering gecombineerd die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingActionsMD: 'Aantal passes en balvoering gecombineerd die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingActionsM: 'Aantal passes en balvoering gecombineerd die succesvol middenvelder lijn penetreren',
      LineBreakingActionsD: 'Aantal passes en balvoering gecombineerd die succesvol defensieve lijn penetreren',
      PassesPerLineBreakingPass: 'Verhouding tussen totaal aantal passes per lijn doorbrekende pass',
      CarriesPerLineBreakingCarry: 'Verhouding tussen totaal aantal balvoering per lijn doorbrekende balvoering',
      LinesBrokenByPasses: 'Totaal aantal lijnen gebroken via passes',
      LinesBrokenByCarries: 'Totaal aantal lijnen gebroken via balvoering',
      LinesBrokenByActions: 'Totaal aantal lijnen gebroken via passes en balvoering gecombineerd',
      LinesBrokenPerPass: 'Verhouding tussen totaal aantal lijnen gebroken per pass',
      LinesBrokenPerCarry: 'Verhouding tussen totaal aantal lijnen gebroken per balvoering',
      AvgLastDefenderDistanceIP: 'Afstand tussen de laatste verdediger (dichtst bij eigen doel) en de doellijn in balbezit',
      AvgLastDefenderDistanceOOP: 'Afstand tussen de laatste verdediger (dichtst bij eigen doel) en de doellijn zonder balbezit',
      AvgDefensiveLineDistanceIP: 'Afstand tussen de positie van de diepste defensieve lijn en het doel in balbezit',
      AvgDefensiveLineDistanceOOP: 'Afstand tussen de positie van de diepste defensieve lijn en het doel zonder balbezit',
      AvgRBDistanceIP: 'Afstand van rechtsback tot hun eigen doel in balbezit',
      AvgRBDistanceOOP: 'Afstand van rechtsback tot hun eigen doel zonder balbezit',
      AvgLBDistanceIP: 'Afstand van linksback tot hun eigen doel in balbezit',
      AvgLBDistanceOOP: 'Afstand van linksback tot hun eigen doel van balbezit',
      AvgBlockDistanceIP: 'Afstand tussen de diepste en meest gevorderde veldspeler in balbezit',
      AvgBlockDistanceOOP: 'Afstand tussen de diepste en meest gevorderde veldspeler zonder balbezit',
      AvgBlockAreaIP: 'Het gebied van de begrenzende box rond alle veldspelers (een maat voor hoeveel ruimte het team bezet) in balbezit',
      AvgBlockAreaOOP: 'Het gebied van de begrenzende box rond alle veldspelers (een maat voor hoeveel ruimte het team bezet) zonder balbezit',
      AvgDefensiveLineWidthOOP: 'De breedte van de achterste lijn van spelers (verst van hun eigen doel) zonder balbezit',
      AvgOffensiveLineLastThirdWidthIP: 'De horizontale breedte van de aanvallende lijn in de laatste derde in balbezit',
      AvgLByIP: 'Positie van de linksback in balbezit',
      AvgRByIP: 'Positie van de rechtsback in balbezit',
      AvgOffensiveLineDistanceIP: 'Afstand tussen het eigen doel en de aanvallende lijn in balbezit',
      AvgOffensiveLineLastThirdDistanceIP: 'Afstand tussen het eigen doel en de aanvallende lijn in de laatste derde in balbezit',
      AvgOffensiveLineWidthIP: 'De horizontale breedte van de aanvallende lijn in balbezit',
      OffBallRuns: 'Intentionele off-bal bewegingen (runs) om de aanvallende fase te ondersteunen',
      OffBallRunsOverlap: 'Runs waar de speler rond de buitenkant van een teamgenoot beweegt (dichter bij de zijlijn) terwijl die teamgenoot de bal heeft',
      OffBallRunsUnderlap: 'Runs waar de speler binnen een teamgenoot beweegt, een innerlijke route nemend (dichter bij het midden van het veld)',
      OffBallRunsRunAhead: 'Voorwaartse run die verder gaat dan de bal drager maar voor de laatste verdediger blijft',
      OffBallRunsRunBehind: 'Voorwaartse run die de laatste defensieve lijn doorbreekt, tussen verdedigers en doelman komt',
      OffBallRunsCrossReceiver: 'Een speler rent het zestienmetergebied in en positioneert zich om een voorzet van een teamgenoot te ontvangen',
      OffBallRunsSupport: 'De speler rent om uit te lijnen met de bal drager, een nabije pass optie biedend in aanval',
      OffBallRunsComingShort: 'De speler beweegt naar de bal drager om nauwe ondersteuning of een pass optie weg van het doel te bieden',
      AerialsOppHalf: 'Luchtduels succesvol naar tegenstander helft',
      CarriesIntoFinalThird: 'Pijpleidingen van minimaal 7 meter van buiten naar binnen het laatste derde deel',
      SpeedScore: 'Fysieke prestaties van spelers gebaseerd op verschillende snelheidsstatistieken',
      EnduranceScore: 'De fysieke prestaties van de speler zijn gebaseerd op verschillende statistieken',
      SwitchPlaySuccessful: 'Aantal voltooide passes over 32 meter waarbij de zijdelingse verplaatsing van de bal groter is dan de verplaatsing richting het doel van de tegenstander',
      SwitchPlayTotal: 'Totaal aantal pogingen tot passen over 32 meter waarbij de zijdelingse verplaatsing van de bal groter is dan de verplaatsing richting het doel van de tegenstander',
      PassesInsideOppHalf: 'Totaal aantal passes dat zowel begint als eindigt op de helft van de tegenstander',
      PassesInsideOppHalfSuccessful: 'Aantal voltooide passes die zowel beginnen als eindigen op de helft van de tegenstander',
      TacklesAttemptedFirstThird: 'Totaal aantal pogingen tot tackles in het eerste derde deel van het veld',
      TacklesAttemptedSecondThird: 'Totaal aantal pogingen tot tackles in het tweede derde deel van het veld',
      TacklesFirstThird: 'Aantal succesvolle tackles gemaakt in het eerste derde deel van het veld',
      TacklesSecondThird: 'Aantal succesvolle tackles gemaakt in het tweede derde deel van het veld',
      FoulsOwnHalf: 'Aantal fouten begaan op de eigen speelhelft van de speler',
      TouchesOppHalf: 'Aantal balaanrakingen op de helft van de tegenstander',
      TacklesAttemptedNotAdjusted: 'Totaal aantal pogingen tot tackles, zonder balbezitaanpassing',
      TacklesSuccessfulNotAdjusted: 'Totaal aantal succesvolle tackles, zonder balbezitaanpassing',
      AvgTop5MaxSpeed: 'Gemiddelde van de vijf hoogste maximale snelheden van de speler',
      LBPReceived: 'Aantal ontvangen line-breaking passes. Dit zijn voltooide passes die de bal minstens 10% dichter bij het doel van de tegenstander brengen en een paar verdedigers in de directe nabijheid kruisen of voorbij de verdedigingslijn komen.',
      LBPMReceived: 'Aantal ontvangen passes bij het doorbreken van de middenveldlijn van de tegenstander',
      LBPMDReceived: 'Aantal ontvangen passes waarmee zowel het middenveld als de verdedigingslinies van de tegenstander werden doorbroken',
      ThroughBallReceived: 'Aantal ontvangen passes waarmee de laatste verdedigingslinie van de oppositie werd doorbroken',
      HsrDistanceIP: 'Sprintafstand >21 km/u in balbezit',
      HsrDistanceOOP: 'Sprintafstand >21 km/u uit balbezit',
      JoggingDistanceIP: 'Joggingafstand in balbezit',
      JoggingDistanceOOP: 'Joggingafstand buiten balbezit',
      RunningDistanceIP: 'Loopafstand in balbezit',
      RunningDistanceOOP: 'Loopafstand buiten balbezit',
      SprintsDistanceIP: 'Sprintafstand >24 km/u in balbezit',
      SprintsDistanceOOP: 'Sprintafstand >24 km/u uit balbezit',
      WalkingDistanceIP: 'Op loopafstand in bezit',
      WalkingDistanceOOP: 'Op loopafstand uit balbezit',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Aantal keren dat je de tegenstander dwingt balbezit te verliezen',
      HandPassesSuccessful: 'Succesvolle passes gemaakt met de handen (keepers of inworp in spelhervatting)',
      HandPassesTotal: 'Totaal aantal met de handen gemaakte passes (keepers of inworp in spelhervatting)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Percentage van balbezit van het team',
      TimePossession: 'Tijd van balbezit van het team',
      PassesPerShots: 'Gemiddeld aantal passes gegeven per schot',
      PPDA: 'Druk die het team uitoefent op de tegenstander spelers wanneer zij balbezit hebben',
      Directness: 'Hogere kwantiteit van voorwaartse passes ten opzichte van zijwaartse passes',
      ExpectedPoints: 'Aantal punten verwacht door een team, berekend op basis van de Verwachte Doelpunten',
      PassesPerLongBall: 'Percentage van succesvolle lange passes uit het totale aantal voltooide passes',
      CrossingPerXG: 'Percentage van Verwachte Doelpunten afkomstig van voorzetten',
      PenaltySavedPenaltyFaced: 'Percentage van penalty schoten gered uit alle penalty schoten geconfronteerd',
      Goals: 'Aantal doelpunten gescoord',
      PenaltyShots: 'Totaal aantal schoten genomen vanaf penalty kicks',
      PenaltyGoals: 'Totaal aantal doelpunten genomen vanaf penalty kicks',
      NonPenaltyGoals: 'Doelpunten (exclusief penalties)',
      AerialWins: 'Luchtduel overwinningen',
      AerialEfficiency: 'Metriek die luchtduel overwinningen combineert met luchtduels totaal',
      AerialWinsPct: 'Percentage van luchtduel overwinningen',
      Assists: 'Assists',
      Catching: 'Percentage van reddingen waarin de GK de bal vangt',
      Caught: 'Bewaart waar de doelverdediger de bal vangt en vasthoudt, waardoor een tweede spel wordt voorkomen',
      ChancesCreated: 'Aantal passes die leiden tot een schot',
      ClaimAccuracy: 'Ballen geclaimd boven gemiddelde',
      CompletedCrosses: 'Voorzetten succesvol voltooid',
      Crossing: 'Percentage van succesvolle voorzetten',
      Dispossessed: 'Balverlies',
      Finishing: 'Percentage van schoten die eindigen in een doelpunt',
      xGEfficiency: 'Kwantiteit van verwachte doelpunten nodig voor een speler om een doelpunt te scoren',
      Fouls: 'Overtredingen begaan',
      DeepProgression: 'Aantal keren dat de laatste vijfde van het veld wordt bereikt door de bal te dragen, plus het aantal keren dat het balbezit in de laatste vijfde is',
      DeepProgressionFinalThird: 'Keren dat de speler het balbezit heeft in de laatste derde',
      FoulsTaken: 'Overtredingen ontvangen',
      IndividualPressure: 'Succesvolle inspanningen (balbezit herwonnen)',
      Interceptions: 'Bal Onderscheppingen',
      LongBallPct: 'Percentage van Voltooide Passes van ten minste 32 meter',
      LongBallTotal: 'Totaal aantal passen over 32 meter',
      LongBallSuccessful: 'Voltooide Passes van ten minste 32 meter',
      NPGOpenPlay: 'Doelpunten (exclusief penalties) door open spel acties',
      NPGSetPiece: 'Doelpunten (exclusief penalties) door vaste situatie acties',
      OpenPlayKeyPasses: 'Passes eindigend in een Schot (exclusief assists) in Open Spel',
      OpenPlayKeyPassesInTeam: 'Percentage van passes eindigend in een schot (exclusief assists) in open spel in Team',
      PassingFinalThird: 'Succesvolle passes naar de laatste derde',
      PassesFinalThirdTotal: 'Het totale aantal pogingen tot passes, exclusief voorzetten, spelhervattingen, corners en inworpen, die eindigen in het laatste derde deel',
      PassingFinalThirdPct: 'Percentage van Succesvolle Passes in Laatste Derde',
      PassingOppHalfPct: 'Percentage van Succesvolle Passes naar de Tegenstander Helft',
      PassingOwnHalfPct: 'Percentage van Succesvolle Passes naar de Eigen Helft',
      PassingPct: 'Percentage van Succesvolle Passes',
      Recoveries: 'Bal Herwinnen (via Tackles of Onderscheppingen)',
      SavesInBoxPct: 'Percentage van Reddingen van Schoten in Zestienmetergebied',
      SavesOutOfBoxPct: 'Percentage van Reddingen van Schoten buiten Zestienmetergebied',
      SavesPct: 'Percentage van Reddingen',
      ScoringContribution: 'Aantal assists en doelpunten',
      xAssistsOpenPlay: 'Aantal verwachte assists gegenereerd door open spel',
      xAssistsSetPiece: 'Aantal verwachte assists gegenereerd door vaste situatie',
      xAssistsOpenPlayInTeam: 'Aantal verwachte assists gegenereerd door open spel in team',
      xAssistsSetPieceInTeam: 'Aantal verwachte assists gegenereerd door vaste situatie in team',
      xGChainFinalThird: 'Kwantiteit van xG waar een speler aan heeft deelgenomen in de laatste derde',
      xGBuildupFinalThird: 'Kwantiteit van xG waar een speler aan heeft deelgenomen in de laatste derde (exclusief schoten en passes die leiden tot een schot)',
      BallProgressionPassing: 'Aantal keren dat de speler de bal 10 meter of meer voortbrengt door de bal te passen',
      BallProgressionDribbling: 'Aantal keren dat de speler de bal 10 meter of meer voortbrengt door de bal te dragen',
      Shooting: 'Percentage van Schoten (exclusief penalties) op Doel',
      Shots: 'Aantal Schoten gemaakt',
      ShotsPerGoal: 'Gemiddeld Aantal Schoten gemaakt om een Doelpunt te scoren',
      SuccessfulDribbles: 'Succesvolle Dribbels',
      TacklesSuccessful: 'Totaal Aantal Tackles',
      TacklesWasDribbled: 'Percentage van Duels Gewonnen via Tackelen',
      ThroughBalls: 'Aantal Passes die de defensieve lijn doorbreken',
      TouchesInOpponentBox: 'Aantal controles van de bal in het tegenstander zestienmetergebied',
      xAssists: 'Verwachte Assists gegenereerd',
      xG: 'Verwachte Doelpunten gegenereerd',
      xGDiff: 'Verschil tussen xG en Doelpunten',
      xGOpenPlay: 'Verwachte doelpunten gegenereerd door open spel',
      xGSetPiece: 'Verwachte doelpunten gegenereerd door vaste situatie',
      xGBuildup: 'Betrokkenheid in xG Opgebouwd',
      xGBuildupInTeam: 'Betrokkenheid in xG Opgebouwd in team',
      BallProgression: 'Voortgangen door te passen of de bal te dragen ten minste 10 meter',
      xGChain: 'Betrokkenheid in xG Geketend',
      xGPerNPG: 'Verwachte doelpunten nodig om een niet-penalty doelpunt te scoren',
      xGPerShot: 'Gemiddelde xG per Schot',
      xGSavedPerShot: 'Gemiddelde xG Gered per Schot geconfronteerd',
      xGSavedPerXGFacedOnTarget: 'Gemiddelde xG gered per xG geconfronteerd op doel',
      xGFacedOnTargetPerGoalReceived: 'Verwachte Doelpunten zijn nodig om een doelpunt te scoren tegen een bepaalde Doelman',
      xGFacedOnTargetEfficiency: 'Aantal Niet-Penalty Doelpunten voorkomen door de Doelman',
      xGFacedOnTarget: 'Totale xG (gered en gescoord) geconfronteerd door de doelman',
      HighTurnovers: 'Balverlies dichter dan 40 meter van het eigen doel',
      OpenPlayPassesIntoOpponentBox: 'Totaal open spel passes naar het tegenstander zestienmetergebied',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Open spel voltooide passes naar het tegenstander zestienmetergebied',
      ChancesCreatedOP: 'Aantal passes die leiden tot een schot tijdens open spel',
      PenaltiesTaken: 'Aantal keren dat de speler werd gefouled in het tegenstander zestienmetergebied',
      BlockedCrosses: 'Voorzetten geblokkeerd',
      BlockedShots: 'Schoten geblokkeerd',
      NonPenaltyGoalsAgainst: 'Aantal niet-penalty doelpunten toegestaan',
      Headers: 'Aantal Schoten gemaakt met het Hoofd',
      AveragePassDistance: 'Gemiddelde afstand van passes in meters',
      ProgressiveRuns: 'Succesvolle balvoering die het balbezit 20% dichter bij het tegenstander doel brengt',
      xT: 'Bedreiging gegenereerd door de bal te verplaatsen naar gevaarlijke gebieden',
      xTOpenPlay: 'Verwachte Bedreiging gegenereerd tijdens open spel',
      xTSetPiece: 'Verwachte Bedreiging gegenereerd door vaste situatie',
      xGOT: 'Aantal verwachte doelpunten geconfronteerd door de doelman',
      BadActions: 'Som van alle slechte acties begaan',
      BadActionsOwnHalf: 'Som van alle slechte acties begaan in de eigen helft',
      AerialsWonOwnBox: 'Luchtduel Overwinningen Eigen Zestienmetergebied',
      AerialsWonOppBox: 'Luchtduels Overwinningen Tegenstander Zestienmetergebied',
      AerialsTotalOppBox: 'Luchtduels Totaal Tegenstander Zestienmetergebied',
      AerialsTotalOwnBox: 'Luchtduels Totaal Eigen Zestienmetergebied',
      FoulsOwnHalfPct: 'Percentage van Overtredingen begaan in de Eigen Helft',
      RecoveriesOppHalf: 'Aantal ballen herwonnen door een speler in de tegenstander helft',
      DuelsPct: 'Percentage van Succesvolle Duels',
      TacklesUnsuccessful: 'Aantal keren dat een speler faalt om de bal te winnen terwijl een tegenstander succesvol langs hem dribbelt',
      TacklesWasDribbledFirstThird: 'Percentage van keren dat de speler de bal herwint wanneer geconfronteerd in de laatste derde',
      TacklesWasDribbledSecondThird: 'Gewonnen defensieve 1-tegen-1-duels  ⅔',
      TacklesWasDribbledFinalThird: 'Gewonnen defensieve 1-tegen-1-duels Laatste ⅓',
      BallProgressionFinalThird: 'Aantal keren dat een speler 10 of meer meter vooruitgaat in de laatste derde',
      DuelsTotal: 'Totaal aantal tackles, luchtduels, bal aanrakingen, dribbels en overtredingen begaan',
      QuickRecoveries: 'Herwinnen 40 meter of meer van het eigen doel gemaakt 8 seconden na het verliezen van het balbezit',
      ShotsPerNPG: 'Gemiddeld aantal schoten om een Niet-Penalty Doelpunt te scoren',
      ShotsOutBox: 'Aantal Schoten van buiten het zestienmetergebied',
      GoalsOutBox: 'Aantal Doelpunten van buiten het zestienmetergebied',
      ShootingOutBox: 'Percentage van schoten op doel van buiten het Zestienmetergebied',
      HandPassing: 'Pass Nauwkeurigheid met Handen',
      ShotEndingHighTurnovers: 'Hoge Balverlies (balverlies dichter dan 40 meter van het eigen doel) eindigend in een schot van het tegenstander team',
      GoalEndingHighTurnovers: 'Hoge Balverlies (balverlies dichter dan 40 meter van het eigen doel) eindigend in een doelpunt van het tegenstander team',
      AverageCarriesProgress: 'Gemiddelde afstand dat een speler de bal verticaal verplaatst per balvoering (meters)',
      ChanceEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een pass die wordt gevolgd door een schot',
      AssistEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een pass die wordt gevolgd door een doelpunt',
      ShotEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een schot',
      GoalEndingCarries: 'Balvoering van ten minste 7 meter eindigend in een doelpunt',
      ShotEndingSequence: 'Aantal Sequenties eindigend in een Schot waarbij de speler betrokken was',
      GoalEndingSequence: 'Aantal Sequenties eindigend in een Doelpunt waarbij de speler betrokken was',
      AerialWonOffensive: 'Aanvallende luchtduel overwinningen',
      AerialWonDefensive: 'Defensieve luchtduel overwinningen',
      xGAgainst: 'Verwachte doelpunten toegestaan',
      xGDiffAgainst: 'Verschil tussen Verwachte Doelpunten Toegestaan en Doelpunten Toegestaan',
      xGPerNPGAgainst: 'Verwachte doelpunten ontvangen per niet-penalty doelpunt toegestaan',
      xGOpenPlayAgainst: 'Verwachte doelpunten gegenereerd door open spel toegestaan',
      xGSetPieceAgainst: 'Verwachte doelpunten gegenereerd door vaste situatie toegestaan',
      xGPerShotAgainst: 'Verwachte doelpunten ontvangen per schot toegestaan',
      ShotsAgainst: 'Schoten toegestaan',
      ShotsOnTargetAgainst: 'Schoten op doel toegestaan',
      RivalPossession: 'Balbezit van tegenstander',
      AerialDefensivePct: 'Percentage van luchtduel overwinningen zonder balbezit',
      HighRecoveries: 'Herwinnen gemaakt 40 meter dicht bij het tegenstander doel',
      HighDefensiveActions: 'Defensieve Acties (Tackles, Onderscheppingen, Blokkades, Overtredingen en 1vs1) gemaakt 40 meter over de eigen basislijn',
      HighDefensiveActionPct: 'Percentage van Defensieve Acties (Tackles, Onderscheppingen, Blokkades, Overtredingen en 1vs1) gemaakt 40 meter over de eigen basislijn',
      HighDefensiveDistance: 'Gemiddelde afstand van eigen doel van alle Defensieve Acties',
      PassesPerPossession: 'Aantal passes per balbezit',
      LengthPerPossession: 'Afstand per balbezit',
      xTNet: 'Netto xT',
      AvgCarriesDistance: 'Gemiddelde Balvoering Afstand',
      PassesForwardPct: '% Passes Gaan Voorwaarts',
      PassesForwardSuccessful: 'Succesvolle voorwaartse passen',
      PassesForwardTotal: 'Totaal aantal voorwaartse passen',
      TacklesAttempted: 'Tackles Geprobeerd',
      DuelsLost: 'Duels Verloren',
      Carries: 'Balvoering',
      CarriesPct: '% Balvoering',
      Aerials: 'Totaal aantal luchtduels',
      ProgressivePassesReceivedIntoBox: 'Progressieve Passes Ontvangen naar Zestienmetergebied',
      PassesOppHalf: 'Succesvolle passes eindigend naar de tegenstander helft',
      LongBallReceived: 'Aantal Lange Passes (>32 meter) Ontvangen',
      ShotsOnTarget: 'Schoten gemaakt op Doel',
      AggressiveActions: 'Aantal Tackles geprobeerd in de volgende twee seconden na het verliezen van het balbezit',
      Crosses: 'Totaal Aantal Voorzetten',
      xGBuildup5pass: 'Kwantiteit van xG waar een speler aan heeft deelgenomen, alleen laatste 5 passes (exclusief schoten en passes die leiden tot een schot)',
      DefensiveDistance: 'Gemiddelde afstand tot eigen doel van defensieve duels uitgevoerd',
      SpeedSequence: 'Gemiddelde Snelheid (meters afgelegd door tijd besteed) van alle balbezit van een team',
      Touches: 'Aantal keren dat een speler balbezit heeft',
      AerialsTotalOppHalf: 'Luchtduels totaal naar tegenstander helft',
      AerialsWonOppHalf: 'Luchtduels succesvol in de helft van de tegenstander',
      AerialsWonOppHalfPct: 'Percentage van luchtduel overwinningen naar tegenstander helft',
      AerialsPctOppBox: 'Percentage van luchtduels overwinningen naar tegenstander zestienmetergebied',
      AerialsPctOwnBox: 'Percentage van luchtduels overwinningen naar eigen zestienmetergebied',
      AerialDefensive: 'Totaal aantal luchtduels wanneer tegenstander team balbezit heeft',
      AerialOffensive: 'Totaal aantal luchtduels wanneer eigen team balbezit heeft',
      AerialOffensivePct: 'Percentage van luchtduel overwinningen wanneer eigen team balbezit heeft',
      IndividualPressureOppHalf: 'Balbezit herwonnen door een speler bij het drukken van de tegenstander in de tegenstander helft',
      TouchesPerShot: 'Aantal keren dat spelers de bal aanraken per schot',
      PassesFinalThirdTotalPct: 'Percentage van passes (succesvol en onsuccesvol) naar laatste derde',
      xACrosses: 'Verwachte assists gegenereerd van voorzetten',
      Passes: 'Totaal aantal passes',
      PassesSuccessful: 'Aantal Voltooide Passes',
      TacklesWasDribbledFouls: 'Percentage van tackles gewonnen ten opzichte van totale tackles en overtredingen begaan',
      OffsidesCaught: 'Buitenspel Gevangen',
      ProgressivePassesReceivedFinalThird: 'Progressieve Passes Ontvangen Laatste ⅓',
      ProgressivePassesReceived: 'Progressieve Passes Ontvangen',
      Breadth: 'Som van tackles, uitdagingen, onderscheppingen en overtredingen begaan, aan de zijkanten van het veld',
      DuelsDefTotal: 'Som van totaal tackles, defensieve luchtduels en overtredingen begaan',
      DefensiveActions: 'Defensieve Acties wanneer een tegenstander probeert te dribbelen (Tackles, Uitdagingen en Overtredingen)',
      ProgressivePassesReceivedOppHalf: 'Progressieve Passes Ontvangen Tegenstander Helft',
      CompletedCrossesOP: 'Voltooide Voorzetten Open Spel',
      CrossingOP: 'Percentage van voorzetten voltooid uit alle voorzetten geprobeerd open spel',
      CrossesOP: 'Totaal aantal voorzetten tijdens open spel',
      PassingContribution: 'Percentage dat de bedreiging van passes meet rekening houdend met de positie van de ontvanger',
      BallProgressionOppHalfInTeam: '% Balvoortgang in tegenstander helft in team',
      PassesOPIntoBoxInTeam: '% Passes open spel naar zestienmetergebied in team',
      TouchesOppBoxInTeam: '% Aanrakingen tegenstander zestienmetergebied in team',
      xGOPInTeam: '% xG open spel in team',
      DeepPasses: 'Passes van buiten een 20-meter radius van het tegenstander doel die eindigen binnen dat gebied',
      DeepPassesTotal: 'Totaal aantal pogingen van buiten een straal van 20 meter rond het doel van de tegenstander die binnen dat gebied eindigen',
      DefensiveDuelsPct: 'Percentage van defensieve duels gewonnen uit totaal defensieve duels',
      QuickRecoveriesPct: 'Percentage van snelle herwinnen tot onderscheppingen en geprobeerde tackles',
      DiffDefensiveDistanceTeam: 'Verschil tussen de defensieve afstand van de speler en de defensieve afstand van zijn team',
      xTPassing: 'Verwachte bedreiging gegenereerd alleen van passes',
      xTPassing100Passes: 'Verwachte bedreiging gegenereerd alleen van passes en per 100 passes',
      ProgressivePassesAccurate: 'Voltooide passes van 10 meter of meer in de X-as',
      PassAbility: 'Verhouding van voltooide passes tot verwachte passes (xP)',
      OPPassesIntoOppBoxPct: 'Percentage van open spel voltooide passes naar het tegenstander zestienmetergebied en open spel geprobeerde passes naar het tegenstander zestienmetergebied',
      EntriesOppBox: 'Aantal passes en balvoering naar het tegenstander zestienmetergebied',
      Crosses6yardBox: 'Totaal aantal voorzetten eindigend in het zes-yard gebied',
      Cutbacks: 'Passen van basislijn naar achter en binnen het tegenstander zestienmetergebied',
      xTDribbling: 'Verwachte bedreiging gegenereerd alleen van dribbels',
      AvgShotDistance: 'Gemiddelde afstand van het totale aantal schoten genomen',
      xGOnTarget: 'Verwachte doelpunten van schoten gemaakt op doel',
      FinishingxGOT: 'Percentage van schoten op doel eindigend in een doelpunt boven gemiddelde',
      DribblesWonOwnHalf: 'Succesvolle dribbels gemaakt in eigen helft',
      DribblesOwnHalf: 'Aantal geprobeerde dribbels gemaakt in eigen helft',
      DribblesOwnHalfPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in eigen helft',
      DribblesWonOppHalf: 'Succesvolle dribbels gemaakt in tegenstander helft',
      DribblesOppHalf: 'Aantal geprobeerde dribbels gemaakt in tegenstander helft',
      DribblesOppHalfPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in tegenstander helft',
      DribblesWonFinalThird: 'Succesvolle dribbels gemaakt in de laatste derde',
      DribblesFinalThird: 'Aantal geprobeerde dribbels gemaakt in de laatste derde',
      DribblesFinalThirdPct: 'Percentage van succesvolle dribbels en geprobeerde dribbels gemaakt in de laatste derde',
      ShotEndingHighRecoveries: 'Hoge herwinnen (herwinnen gemaakt 40 meter of dichter bij het tegenstander doel) eindigend in een schot',
      PassingFinalThirdAgainst: 'Succesvolle passes van de tegenstander naar de laatste derde',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Totaal aantal passes geprobeerd van de tegenstander naar het eigen zestienmetergebied tijdens open spel',
      EntriesOppBoxAgainst: 'Aantal passes en balvoering van de tegenstander naar het eigen zestienmetergebied',
      DeepProgressionAgainst: 'Aantal keren dat de tegenstander de laatste vijfde van het veld bereikt door de bal te dragen, plus het aantal keren dat het balbezit in de eerste vijfde is',
      TouchesInOpponentBoxAgainst: 'Aantal keren dat de tegenstander balbezit heeft in ons zestienmetergebied',
      Score: 'Speler prestaties gebaseerd op verschillende metrieken',
      PDScore: 'Speler fysieke prestaties gebaseerd op verschillende fysieke metrieken',
      OrlegiScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      SirScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      ExcScore: 'Speler prestaties gebaseerd op verschillende metrieken',
      xTOPInTeam: 'Verwachte bedreiging gegenereerd tijdens open spel in team',
      YellowCards: 'Gele kaarten ontvangen',
      RedCards: 'Rode kaarten ontvangen',
      xTOpenPlayAgainst: 'Verwachte Bedreiging toegestaan tijdens open spel',
      xTSetPieceAgainst: 'Verwachte Bedreiging toegestaan door vaste situatie',
      NPGOpenPlayAgainst: 'Aantal niet penalty doelpunten toegestaan door open spel acties',
      NPGSetPieceAgainst: 'Aantal niet penalty doelpunten toegestaan door vaste situatie acties',
      PassesOppHalfPerPossession: 'Passes Tegenstander Helft per Balbezit',
      AverageTimeRecovery: 'Gem. Tijd Herstel',
      ExpectedPassing: 'Percentage van Passes die hadden moeten worden voltooid',
      NumPossession10Passes: 'Balbezit gegenereerd door 10 of meer passes',
      PassesReceived: 'Passes Ontvangen',
      PassesReceivedFinalThird: 'Passes Ontvangen Laatste ⅓',
      ProgressivePassesTotalPct: 'Percentage van Progressieve Passes',
      ShortPassesPct: 'Percentage van Korte Passes',
      TouchesOppBoxOppTeam: 'Aantal tegenstander acties toegestaan binnen eigen zestienmetergebied terwijl de speler op het veld is',
      ShotsOnTargetOppTeam: 'Schoten op doel toegestaan terwijl de speler op het veld is',
      NPGOppTeam: 'Niet-penalty doelpunten toegestaan terwijl de speler op het veld is',
      xGSetPiecePerxG: 'Verwachte Doelpunten gegenereerd door vaste situatie nodig om één verwacht doelpunt te genereren',
      ShotsOpenPlay: 'Aantal schoten gegenereerd door open spel',
      ShotsOpenPlayAgainst: 'Aantal schoten ontvangen door open spel',
      ShotsFromDribble: 'Schoten die worden afgevuurd nadat een tegenstander is uitgekapt',
      GoalsFromDribble: 'Doelpunten die worden gescoord nadat een tegenstander is uitgekapt',
      PassesIntoFinalThird: 'Geslaagde passes vanuit het aanvallende derde',
      PassesIntoFinalThirdTotal: 'Totaal aantal pogingen geprobeerd die buiten beginnen en eindigen in het laatste derde deel',
      PassesInsideFinalThird: 'Geslaagde passes binnen het aanvallende derde (begin en eind in dat gebied)',
      PassesInsideFinalThirdTotal: 'Totaal aantal pogingen tot passen in het laatste derde deel (start en einde in het laatste derde deel)',
      PassesFinalThirdNoArea: 'Passeert laatste derde (Z/O Box)',
      PassesIntoOppBox: 'Geslaagde passes die eindigen in het strafschopgebied van de tegenstander',
      CarriesFinalThird: 'Dribbels van minstens 7 meter die eindigen in het aanvallende derde',
      CarriesInsideFinalThird: 'Dribbels van minstens 7 meter binnen het aanvallende derde (begin en eind in dat gebied)',
      CarriesFinalThirdNoBox: 'Draagt ​​laatste derde (Z/O Box)',
      CarriesIntoOppBox: 'Dribbels van minstens 7 meter die eindigen in het strafschopgebied van de tegenstander',
      TimePossessionAgainst: 'Balbezit van de tegenstander',
      TimePossessionTotal: 'Totaal balbezit van beide teams',
      PassesInBox: 'Geslaagde passes binnen het eigen strafschopgebied',
      LongThrowInSuccessful: 'Succesvolle lange inworp vanaf de zijlijn, gericht op meer dan 20 meter',
      LongThrowInTotal: 'Totaal aantal lange inworpen vanaf de zijlijn, gericht op meer dan 20 meter',
      LongThrowInPct: 'Percentage van succesvolle lange inworpen (20+ meter)',
      Games: 'Gespeelde spellen',
      PointsPerGame: 'Punten per spel',
      ExpectedPointsDiff: 'Verwacht puntenverschil',
      PassesTotalOwnHalf: 'Totaal aantal passes vanaf de eigen helft',
      PassesOwnHalf: 'Aantal succesvolle passes vanaf de eigen helft',
      PassesTotalOppHalf: 'Totaal aantal passes vanaf de helft van de tegenstander',
      ProgressivePassesTotal: 'Totaal aantal passages van 10 meter of meer in de X-as',
      DuelsWon: 'Succesvolle duels (tackles, luchtaanvallen, balaanrakingen, dribbels en gemaakte fouten)',
      NonPenaltySaves: 'Bespaart exclusief strafschoppen',
      BadActionsOppHalf: 'Som van alle slechte acties gepleegd op de helft van de tegenstander',
      CarriesSuccessful: 'Aantal carry\'s van minimaal 7 meter eindigend met een succesvol evenement',
      ShotsOnTargetOutBox: 'Schoten op doel van buiten het strafschopgebied',
      TotalDistance: 'Totale Afstand',
      WalkingDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid lager dan 2 m/s (7.2 km/h)',
      JoggingDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid tussen 2 m/s (7.2 km/h) en 4 m/s (14.4 km/h)',
      RunningDistance: 'Totale afstand die de Speler heeft afgelegd tijdens een wedstrijd bij een snelheid tussen 4 m/s (14.4 km/h) en 5.5 m/s (19.8 km/h)',
      ExtremeAccelerations: 'Aantal keren dat de Speler meer dan 3 m/s<sup>2</sup> versnelt',
      NumberOfRuns: 'Aantal runs voltooid bij een snelheid tussen 14.4 km/h en 19.8 km/h',
      HsrDistance: 'Hoge Snelheid Run Afstand > 19.8 km/h',
      HsrNumber: 'Hoge Snelheid Run Kwantiteit > 19.8 km/h',
      HsrDistancePct: '% HSR Afstand',
      SprintsNumber: 'Sprint Kwantiteit > 25.2 km/h',
      SprintsDistance: 'Sprint Afstand > 25.2 km/h',
      SprintNumberDeclinePct: '% Sprint Kwantiteit Afname',
      SprintDistanceDeclinePct: '% Sprint Afstand Afname',
      SprintNumberDecline: 'Afname aantal sprints vergeleken met de tweede helft',
      SprintDistanceDecline: 'Afname afstand gerend tijdens sprinten vergeleken met de tweede helft',
      SprintDistancePct: '% Sprint Afstand',
      Accelerations: 'Versnelling Kwantiteit',
      MaxSpeed: 'Max. Snelheid',
      AvgMaxSpeed: 'Gemiddelde van maximale snelheid bereikt door de speler',
      MaxAccelerations: 'Maximale meters/seconde<sup>2</sup> bereikt door de speler',
      BypassedPlayersByPasses: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via passes',
      BypassedDefendersByPasses: 'Totaal aantal tegenstanders (verdedigers) omzeild via passes',
      PassesBypassingPlayers: 'Aantal passes die spelers omzeilden',
      PassesBypassingDefenders: 'Aantal passes die verdedigers omzeilden',
      BypassedPlayersPerPass: 'Totaal aantal spelers omzeild per passes',
      BypassedDefendersPerPass: 'Totaal aantal verdedigers omzeild per passes',
      LineBreakingPasses: 'Aantal passes die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingPassesMD: 'Aantal passes die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingPassesM: 'Aantal passes die succesvol middenvelder lijn penetreren',
      LineBreakingThroughBalls: 'Aantal passes die succesvol defensieve lijn penetreren',
      LineBreakingPassesPerPass: 'Percentage van lijn doorbrekende passes per pass',
      TotalPassesUnderStrongPressure: 'Totaal aantal passes gemaakt onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      TotalPassesUnderLightPressure: 'Totaal aantal passes gemaakt onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      SuccessfulPassesUnderStrongPressure: 'Aantal succesvolle passes gemaakt onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      SuccessfulPassesUnderLightPressure: 'Aantal succesvolle passes gemaakt onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      PassingUnderStrongPressure: 'Percentage van succesvolle passes en totale passes beide onder sterke druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      PassingUnderLightPressure: 'Percentage van succesvolle passes en totale passes beide onder druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      PassReceiptsInSpaceCompleted: 'Passes gemaakt waar de ontvanger in de aanvallende helft is en geen verdediger heeft in een 5 meter radius richting het doel',
      PassReceiptsInSpace: 'Passes ontvangen in de aanvallende helft en er is geen verdediger in een 5 meter radius richting het doel',
      PassReceiptsInSpaceCompletedFirstThird: 'Passes waarbij de ontvanger zich in het eerste derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedSecondThird: 'Passes waarbij de ontvanger zich in het tweede derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedFinalThird: 'Passes waarbij de ontvanger zich in het aanvallende derde bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passes waarbij de ontvanger zich in de rechterhelft van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passes waarbij de ontvanger zich in het midden van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passes waarbij de ontvanger zich in de linkerhelft van de tegenstander bevindt zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceFirstThird: 'Passes ontvangen in het eerste derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceSecondThird: 'Passes ontvangen in het tweede derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceFinalThird: 'Passes ontvangen in het aanvallende derde zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfRight: 'Passes ontvangen in de rechterhelft van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfCenter: 'Passes ontvangen in het midden van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      PassReceiptsInSpaceOppHalfLeft: 'Passes ontvangen in de linkerhelft van de tegenstander zonder verdediger binnen 5 meter richting het doel',
      TotalStrongOnBallPressures: 'Aantal sterke op-bal druk (binnen 0-2 meter van de bal drager)',
      TotalLightOnBallPressures: 'Aantal op-bal druk (binnen 2-4 meter van de bal drager)',
      SuccessfulStrongOnBallPressures: 'Aantal succesvolle sterke op-bal druk (binnen 0-2 meter)',
      SuccessfulLightOnBallPressures: 'Aantal succesvolle op-bal druk (binnen 2-4 meter)',
      StrongOnBallPressuresPct: 'Percentage van succesvolle en totale sterke op-bal druk (binnen 0-2 meter van de dichtstbijzijnde tegenstander)',
      LightOnBallPressuresPct: 'Percentage van succesvolle en totale op-bal druk (binnen 2-4 meter van de dichtstbijzijnde tegenstander)',
      TimesBypassedByPasses: 'Totaal aantal keren omzeild door pass',
      TimesBypassedByCarries: 'Totaal aantal keren omzeild door balvoering',
      TimesBypassedByActions: 'Totaal aantal keren omzeild door pass en balvoering gecombineerd',
      BypassedPlayersByCarries: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via balvoering',
      BypassedDefendersByCarries: 'Totaal aantal tegenstanders (verdedigers) omzeild via balvoering',
      BypassedPlayersByActions: 'Totaal aantal tegenstanders (verdedigers en middenvelders) omzeild via passes en balvoering gecombineerd',
      BypassedDefendersByActions: 'Totaal aantal tegenstanders (verdedigers) omzeild via passes en balvoering gecombineerd',
      CarriesBypassingPlayers: 'Aantal balvoering die spelers omzeilden',
      CarriesBypassingDefenders: 'Aantal balvoering die verdedigers omzeilden',
      BypassedPlayersPerCarry: 'Gemiddeld aantal tegenstanders omzeild per balvoering (ten minste 7 meter)',
      BypassedDefendersPerCarry: 'Gemiddeld aantal verdedigers omzeild per balvoering (ten minste 7 meter)',
      LineBreakingCarries: 'Aantal balvoering die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingCarriesMD: 'Aantal balvoering die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingCarriesM: 'Aantal balvoering die succesvol middenvelder lijn penetreren',
      LineBreakingCarriesD: 'Aantal balvoering die succesvol defensieve lijn penetreren',
      LineBreakingCarriesPerCarry: 'Percentage van lijn doorbrekende balvoering per balvoering',
      LineBreakingActions: 'Aantal passes en balvoering gecombineerd die succesvol een of meer defensieve lijnen penetreren',
      LineBreakingActionsMD: 'Aantal passes en balvoering gecombineerd die succesvol middenvelder en verdediger lijnen penetreren',
      LineBreakingActionsM: 'Aantal passes en balvoering gecombineerd die succesvol middenvelder lijn penetreren',
      LineBreakingActionsD: 'Aantal passes en balvoering gecombineerd die succesvol defensieve lijn penetreren',
      PassesPerLineBreakingPass: 'Verhouding tussen totaal aantal passes per lijn doorbrekende pass',
      CarriesPerLineBreakingCarry: 'Verhouding tussen totaal aantal balvoering per lijn doorbrekende balvoering',
      LinesBrokenByPasses: 'Totaal aantal lijnen gebroken via passes',
      LinesBrokenByCarries: 'Totaal aantal lijnen gebroken via balvoering',
      LinesBrokenByActions: 'Totaal aantal lijnen gebroken via passes en balvoering gecombineerd',
      LinesBrokenPerPass: 'Verhouding tussen totaal aantal lijnen gebroken per pass',
      LinesBrokenPerCarry: 'Verhouding tussen totaal aantal lijnen gebroken per balvoering',
      AvgLastDefenderDistanceIP: 'Afstand tussen de laatste verdediger (dichtst bij eigen doel) en de doellijn in balbezit',
      AvgLastDefenderDistanceOOP: 'Afstand tussen de laatste verdediger (dichtst bij eigen doel) en de doellijn zonder balbezit',
      AvgDefensiveLineDistanceIP: 'Afstand tussen de positie van de diepste defensieve lijn en het doel in balbezit',
      AvgDefensiveLineDistanceOOP: 'Afstand tussen de positie van de diepste defensieve lijn en het doel zonder balbezit',
      AvgRBDistanceIP: 'Afstand van rechtsback tot hun eigen doel in balbezit',
      AvgRBDistanceOOP: 'Afstand van rechtsback tot hun eigen doel zonder balbezit',
      AvgLBDistanceIP: 'Afstand van linksback tot hun eigen doel in balbezit',
      AvgLBDistanceOOP: 'Afstand van linksback tot hun eigen doel van balbezit',
      AvgBlockDistanceIP: 'Afstand tussen de diepste en meest gevorderde veldspeler in balbezit',
      AvgBlockDistanceOOP: 'Afstand tussen de diepste en meest gevorderde veldspeler zonder balbezit',
      AvgBlockAreaIP: 'Het gebied van de begrenzende box rond alle veldspelers (een maat voor hoeveel ruimte het team bezet) in balbezit',
      AvgBlockAreaOOP: 'Het gebied van de begrenzende box rond alle veldspelers (een maat voor hoeveel ruimte het team bezet) zonder balbezit',
      AvgDefensiveLineWidthOOP: 'De breedte van de achterste lijn van spelers (verst van hun eigen doel) zonder balbezit',
      AvgOffensiveLineLastThirdWidthIP: 'De horizontale breedte van de aanvallende lijn in de laatste derde in balbezit',
      AvgLByIP: 'Positie van de linksback in balbezit',
      AvgRByIP: 'Positie van de rechtsback in balbezit',
      AvgOffensiveLineDistanceIP: 'Afstand tussen het eigen doel en de aanvallende lijn in balbezit',
      AvgOffensiveLineLastThirdDistanceIP: 'Afstand tussen het eigen doel en de aanvallende lijn in de laatste derde in balbezit',
      AvgOffensiveLineWidthIP: 'De horizontale breedte van de aanvallende lijn in balbezit',
      OffBallRuns: 'Intentionele off-bal bewegingen (runs) om de aanvallende fase te ondersteunen',
      OffBallRunsOverlap: 'Runs waar de speler rond de buitenkant van een teamgenoot beweegt (dichter bij de zijlijn) terwijl die teamgenoot de bal heeft',
      OffBallRunsUnderlap: 'Runs waar de speler binnen een teamgenoot beweegt, een innerlijke route nemend (dichter bij het midden van het veld)',
      OffBallRunsRunAhead: 'Voorwaartse run die verder gaat dan de bal drager maar voor de laatste verdediger blijft',
      OffBallRunsRunBehind: 'Voorwaartse run die de laatste defensieve lijn doorbreekt, tussen verdedigers en doelman komt',
      OffBallRunsCrossReceiver: 'Een speler rent het zestienmetergebied in en positioneert zich om een voorzet van een teamgenoot te ontvangen',
      OffBallRunsSupport: 'De speler rent om uit te lijnen met de bal drager, een nabije pass optie biedend in aanval',
      OffBallRunsComingShort: 'De speler beweegt naar de bal drager om nauwe ondersteuning of een pass optie weg van het doel te bieden',
      AerialsOppHalf: 'Luchtduels succesvol naar tegenstander helft',
      CarriesIntoFinalThird: 'Pijpleidingen van minimaal 7 meter van buiten naar binnen het laatste derde deel',
      DribblesAttempted: 'Aantal dribbelpogingen',
      SpeedScore: 'Fysieke prestaties van spelers gebaseerd op verschillende snelheidsstatistieken',
      EnduranceScore: 'De fysieke prestaties van de speler zijn gebaseerd op verschillende statistieken',
      GoalsConceded: 'Aantal tegendoelpunten',
      HeadedGoals: 'Aantal doelpunten gescoord met het hoofd',
      SavesInBox: 'Aantal reddingen uit schoten in het strafschopgebied',
      SavesOutBox: 'Aantal reddingen uit schoten buiten het strafschopgebied',
      ShotsOnTargetInBoxAgainst: 'Aantal toegekende schoten op doel vanuit het strafschopgebied',
      ShotsOnTargetOutBoxAgainst: 'Aantal toegekende schoten op doel van buiten het strafschopgebied',
      SwitchPlaySuccessful: 'Aantal voltooide passes over 32 meter waarbij de zijdelingse verplaatsing van de bal groter is dan de verplaatsing richting het doel van de tegenstander',
      SwitchPlayTotal: 'Totaal aantal pogingen tot passen over 32 meter waarbij de zijdelingse verplaatsing van de bal groter is dan de verplaatsing richting het doel van de tegenstander',
      PassesInsideOppHalf: 'Totaal aantal passes dat zowel begint als eindigt op de helft van de tegenstander',
      PassesInsideOppHalfSuccessful: 'Aantal voltooide passes die zowel beginnen als eindigen op de helft van de tegenstander',
      TacklesAttemptedFirstThird: 'Totaal aantal pogingen tot tackles in het eerste derde deel van het veld',
      TacklesAttemptedSecondThird: 'Totaal aantal pogingen tot tackles in het tweede derde deel van het veld',
      TacklesFirstThird: 'Aantal succesvolle tackles gemaakt in het eerste derde deel van het veld',
      TacklesSecondThird: 'Aantal succesvolle tackles gemaakt in het tweede derde deel van het veld',
      FoulsOwnHalf: 'Aantal fouten begaan op de eigen speelhelft van de speler',
      TouchesOppHalf: 'Aantal balaanrakingen op de helft van de tegenstander',
      TacklesAttemptedNotAdjusted: 'Totaal aantal pogingen tot tackles, zonder balbezitaanpassing',
      TacklesSuccessfulNotAdjusted: 'Totaal aantal succesvolle tackles, zonder balbezitaanpassing',
      AvgTop5MaxSpeed: 'Gemiddelde van de vijf hoogste maximale snelheden van de speler',
      LBPReceived: 'Aantal ontvangen line-breaking passes',
      LBPMReceived: 'Aantal ontvangen passes bij het doorbreken van de middenveldlijn van de tegenstander',
      LBPMDReceived: 'Aantal ontvangen passes waarmee zowel het middenveld als de verdedigingslinies van de tegenstander werden doorbroken',
      ThroughBallReceived: 'Aantal ontvangen passes waarmee de laatste verdedigingslinie van de oppositie werd doorbroken',
      ShortPassesSuccessful: 'Aantal voltooide korte passen (minder dan 12 meter).',
      PassingSuccessForwardPct: 'Percentage succesvolle voorwaartse passes',
      PassingSuccessBackwardPct: 'Percentage succesvolle achterwaartse passes',
      PassingForwardBackwardPct: 'Verhouding tussen voorwaartse en achterwaartse passes',
      LongBallPerPassesPct: 'Percentage lange ballen ten opzichte van het totale aantal passes',
      LongBallReceivedOppHalf: 'Aantal ontvangen lange ballen in het rivaliserende veld',
      OffensiveActions: 'Offensieve acties',
      SuccessfulDribblesPct: 'Succesvolle dribbels/totaal aantal dribbelpogingen uitgevoerd',
      OffensiveTouchesOutBoxPct: '% aanvallende aanrakingen buiten het strafschopgebied',
      HsrDistanceIP: 'Sprintafstand >21 km/u in balbezit',
      HsrDistanceOOP: 'Sprintafstand >21 km/u uit balbezit',
      JoggingDistanceIP: 'Joggingafstand in balbezit',
      JoggingDistanceOOP: 'Joggingafstand buiten balbezit',
      RunningDistanceIP: 'Loopafstand in balbezit',
      RunningDistanceOOP: 'Loopafstand buiten balbezit',
      SprintsDistanceIP: 'Sprintafstand >24 km/u in balbezit',
      SprintsDistanceOOP: 'Sprintafstand >24 km/u uit balbezit',
      WalkingDistanceIP: 'Op loopafstand in bezit',
      WalkingDistanceOOP: 'Op loopafstand uit balbezit',
      PossessionRegain: 'Aantal keren dat je de tegenstander dwingt balbezit te verliezen',
      HandPassesSuccessful: 'Succesvolle passes gemaakt met de handen (keepers of inworp in spelhervatting)',
      HandPassesTotal: 'Totaal aantal met de handen gemaakte passes (keepers of inworp in spelhervatting)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SNIK',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Luchtduels Tegenstander Helft',
    CarriesIntoFinalThird: 'Rijdt tot de laatste ⅓',
    scoreDifference: 'Scoreverschil: laat zien of de prestatie van deze game boven of onder het seizoensgemiddelde lag',
    SpeedScore: 'Snelheidskrachtscore',
    EnduranceScore: 'Uithoudingsvermogenscore',
    HeadedShots: 'Kopschoten',
    HeadedXG: 'Onder leiding van xG',
    HeadedSetPieceTooltip: 'Er worden alleen spelers weergegeven die kopballen uit spelhervattingen hebben',
    SwitchPlaySuccessful: 'Wisselspel succesvol',
    SwitchPlayTotal: 'Wissel af met totaal',
    PassesInsideOppHalf: 'Gaat naar de tegenstanderhelft',
    PassesInsideOppHalfSuccessful: 'Passes binnen tegenstander Half succesvol',
    TacklesAttemptedFirstThird: 'Tackles geprobeerd als eerste ⅓',
    TacklesAttemptedSecondThird: 'Tackles geprobeerd tweede ⅓',
    TacklesFirstThird: 'Tackles succesvolle eerste ⅓',
    TacklesSecondThird: 'Tackles succesvolle tweede ⅓',
    FoulsOwnHalf: 'Overtredingen eigen helft',
    TouchesOppHalf: 'Raakt tegenstanderhelft aan',
    TacklesAttemptedNotAdjusted: 'Tackles geprobeerd, niet aangepast',
    TacklesSuccessfulNotAdjusted: 'Tackles succesvol, niet aangepast',
    AvgTop5MaxSpeed: 'Gemiddelde Top5 Max. Snelheid',
    LBPReceived: 'Line Breaking Passes ontvangen',
    LBPMReceived: 'Lijndoorbrekende passen (M-lijn) ontvangen',
    LBPMDReceived: 'Lijndoorbrekende passen (MD-lijn) ontvangen',
    ThroughBallReceived: 'Door middel van ontvangen ballen',
    recoveriesRate: 'Herstelverhouding',
    turnoversRate: 'Verliesratio',
    HsrDistanceIP: 'HSR-afstand IP',
    HsrDistanceOOP: 'HSR-afstand OOP',
    JoggingDistanceIP: 'Joggingafstand IP',
    JoggingDistanceOOP: 'Joggingafstand OOP',
    RunningDistanceIP: 'Loopafstand IP',
    RunningDistanceOOP: 'Loopafstand OOP',
    SprintsDistanceIP: 'Sprintafstand IP',
    SprintsDistanceOOP: 'Sprints Afstand OOP',
    WalkingDistanceIP: 'Op loopafstand IP',
    WalkingDistanceOOP: 'Op loopafstand OOP',
    PossessionRegain: 'Bezit herwinnen',
    HandPassesSuccessful: 'Succesvolle handpassen',
    HandPassesTotal: 'Handpassen',
    SprintsNumberIP: 'Sprints Hoeveelheid IP',
    SprintsNumberOOP: 'Sprints Aantal OOP',
    RunningNumberIP: 'Lopende hoeveelheid IP',
    RunningNumberOOP: 'Lopende hoeveelheid OOP',
    HsrNumberIP: 'HSR-hoeveelheid IP',
    HsrNumberOOP: 'HSR-hoeveelheid OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Team Blad',
    subtitle: 'Ga dieper in op de kenmerken en statistieken van het team',
    averageAge: 'Gem. leeftijd',
    transferBalance: 'Transfer Balans',
    roster: 'Selectie',
    stadium: 'Stadion',
    coach: 'Trainer',
    transfers: 'Transfers',
    trends: 'Trends',
    loans: 'Verhuur',
    loanFrom: 'Gehuurd van',
    loanTo: 'Verhuurd naar',
    latestGames: 'Laatste Wedstrijden',
    latestXGames: 'Laatste {0} Wedstrijden',
    playingFor: 'Spelend voor',
    overview: 'Overzicht',
    visualization: 'Visualisatie',
    location: 'Locatie',
    outcome: 'Uitslag',
    beeswarm: 'Ranglijst',
    parentTeam: 'Hoofdteam',
    childTeam: 'Jeugdteam',
    preferredFormation: 'Voorkeursformatie',
    mostFrecuentFormations: 'Meest voorkomende formaties',
    viewType: 'Weergavetype',
    overviewTab: {
      axisXTotal: 'Totaal',
      axisXper90: 'Per 90\'',
      dataPerGameText: 'Data per wedstrijd',
      season: 'Seizoen',
      last: 'Laatste',
      current: 'Huidige',
      TeamStyle: 'Stijl',
      TeamDefensive: 'Defensief',
      TeamOffensive: 'Offensief',
      TeamCustom1: 'Aangepast 1',
      TeamCustom2: 'Aangepast 2',
      TeamCustom3: 'Aangepast 3',
      TeamCustom4: 'Aangepast 4',
      coach: 'Trainer',
      groups: {
        Goals: {
          name: 'Doelpunten',
          desc: 'Toont Penalty Doelpunten en Niet-Penalty Doelpunten (Open Spel en Vaste Situatie).'
        },
        Assists: {
          name: 'Assists',
          desc: 'Spelers met meer Assists (Open Spel en Vaste Situatie) dit seizoen.'
        },
        xG: {
          name: 'Verwachte Doelpunten',
          desc: 'Verwachte Doelpunten van Open Spel en Vaste Situatie'
        },
        xA: {
          name: 'Verwachte Assists',
          desc: 'Verwachte Assists van Open Spel en Vaste Situatie.'
        },
        Finishing: {
          name: 'Afwerking',
          desc: 'Percentage van schoten die eindigen in een doelpunt.'
        },
        ScoringContribution: {
          name: 'Scoring Bijdrage',
          desc: 'Aantal Assists en Doelpunten van het team.'
        },
        xT: {
          name: 'Verwachte Bedreiging',
          desc: 'Verwachte Bedreiging gegenereerd van Open Spel, Vaste Situatie en negatieve xT.'
        }
      },
      stats: {
        openPlay: 'Open Spel',
        setPiece: 'Vaste Situatie',
        negative: 'Negatief',
        npg: 'Niet-Penalty Doelpunten',
        goalsPenalty: 'Penalty Doelpunten',
        npgOpenPlay: 'NPG Open Spel',
        npgSetPiece: 'NPG Vaste Situatie',
        assists: 'Assists',
        assistsConceded: 'Assists toegekend',
        assistsOpenPlay: 'Assists Open Spel',
        assistsSetPiece: 'Assists Vaste Situatie',
        xGOpenPlay: 'xG Open Spel',
        xGSetPiece: 'xG Vaste Situatie',
        xAOpenPlay: 'xA Open Spel',
        xASetPiece: 'xA Vaste Situatie',
        xAConceded: 'xA toegekend',
        nonPenaltyShots: 'Niet-Penalty Schoten',
        penaltyShots: 'Penalty Schoten',
        xT: 'Verwachte Bedreiging',
        xTOpenPlay: 'xT Open Spel',
        xTSetPiece: 'xT Vaste Situatie',
        xTNeg: 'Negatieve xT',
        totalFinishing: 'Afwerking',
        nonPenaltyFinishing: 'Niet Penalty Afwerking',
        goalsPenaltyFinishing: 'Penalty Afwerking',
        goal: 'Doelpunt',
        notGoal: 'Geen Doelpunt',
        chance: 'Kans',
        finished: 'Voltooid',
        notFinished: 'Niet Voltooid',
        walkingDistance: 'Wandelen',
        joggingDistance: 'Joggen ',
        runningDistance: 'Hardlopen ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprinten',
        runningNumber: 'Runs',
        hsrNumber: 'HSR Sprints',
        sprintsNumber: 'Sprints',
        maxSpeed: 'Max. Snelheid',
        accelerations: 'Versnellingen',
        extremeAccelerations: 'Extreme versnellingen',
        maxAcceleration: 'Maximale versnelling'
      }
    },
    teamAnalysis: 'Team Analyse',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: 'Linksback',
        centralDefender: 'Centrale Verdediger',
        rightFullback: 'Rechtsback',
        midfielder: 'Middenvelder',
        attackingMidfielder: 'Aanvallende Middenvelder',
        leftWinger: 'Linksbuiten',
        rightWinger: 'Rechtsbuiten',
        fw: 'Spits'
      },
      groups: {
        contractEnd: 'Maanden',
        age: 'Jaar Oud',
        availability: 'Beschikbaarheid'
      },
      placer: {
        legend: 'Sterkte gebaseerd op leeftijd, contract, beschikbaarheid en prestaties'
      }
    },
    transfersTab: {
      valueMovements: 'Bewegingen Waarde',
      valueTransfers: 'Transfers Waarde',
      valueLoans: 'Verhuur Waarde',
      avgAgeMovements: 'Bewegingen Gem. Leeftijd',
      avgAgeTransfers: 'Transfers Gem. Leeftijd',
      avgAgeLoans: 'Verhuur Gem. Leeftijd',
      operations: {
        buys: {
          buy: 'Kopen',
          loan: 'Huren',
          'end of loan': 'Einde Huur',
          'free transfer': 'Gratis',
          free: 'Gratis',
          'loan transfer': 'Huur',
          other: 'Anders'
        },
        sells: {
          buy: 'Verkopen',
          loan: 'Verhuren',
          'end of loan': 'Einde Huur',
          'free transfer': 'Gratis',
          free: 'Gratis',
          'loan transfer': 'Verhuur',
          other: 'Anders',
          retired: 'Gestopt'
        }
      }
    },
    trendsTab: {
      streaks: 'Reeksen',
      wins: 'Overwinningen',
      cleanSheets: 'Nul Gehouden',
      goalPeriods: 'Gescoorde Doelpunt Periodes',
      concededGoalPeriods: 'Toegestane Doelpunt Periodes',
      comebacks: 'Comebacks',
      avgTime: 'Gemiddelde Tijd',
      kindOfGoals: 'Soort Doelpunten',
      percentWinning: '% Winnen',
      percentDrawing: '% Gelijk',
      percentLosing: '% Verliezen',
      totalOf: 'Totaal van',
      minutes: 'minuten',
      before: 'Voor',
      after: 'Na',
      playedOn: 'Gespeeld op',
      scored: 'Gescoord',
      conceded: 'Toegestaan',
      ownGoals: 'Eigen Doelpunten',
      phasesOfGame: 'Fases van het Spel',
      intensityLabel: 'Zone-intensiteit',
      intensityByTeam: 'Per team %',
      intensityByLeagueAvg: 'Per liga-gemiddelde %',
      buildup: 'Opbouw',
      midfieldProgression: 'Middenveld Voortgang',
      attackOpposition: 'Aanval Tegenstander',
      attackingTransition: 'Aanvallende Transitie',
      highPress: 'Hoge Druk',
      midBlock: 'Midden Blok',
      lowBlock: 'Lage Blok',
      defensiveTransition: 'Defensieve Transitie',
      draws: 'Gelijkspel',
      losts: 'Verloren',
      chokes: 'Verstikkingen',
      zoneTooltip: 'Bepaalt de criteria die worden gebruikt voor het kleurverloop van elk blok:',
      teamPctTooltip: 'Gebaseerd op het percentage van de totale tijd gespeeld door het team in elke zone.',
      leagueAvgPctTooltip: 'Vergelijkt het percentage van het team met het competitiegemiddelde voor elke zone.',
      leagueAvgMinsTooltip: 'Past dezelfde vergelijkingscriteria toe met de competitie, maar evalueert de totale tijd in minuten in plaats van in percentages.',
      losses: 'Verliezen',
      results: 'Resultaten',
      kindOfConcededGoals: 'Typen toegekende doelpunten',
      showMinutes: 'Notulen weergeven'
    },
    onOff: 'Aan/Uit',
    dragUpToXPlayers: 'Sleep tot {x} spelers',
    selectUpToXPlayers: 'Selecteer tot {x} spelers',
    onOffTab: {
      G90: 'Doelpunten 90',
      GA90: 'Doelpunten Tegen 90',
      diffG90: 'Doelpunt Verschil 90',
      XG90: 'xG 90',
      XGA90: 'xG Tegen 90',
      diffXG90: 'xG Verschil 90',
      playersOn: 'Combo AAN',
      playersOff: 'Combo UIT',
      ground: 'Veld',
      playersOnThePitch: 'Spelers op het veld',
      playersOffThePitch: 'Spelers buiten het veld',
      attackTitle: 'Aanval',
      attackSubTitle: 'Offensieve Stats',
      defenseTitle: 'Verdediging',
      defenseSubTitle: 'Defensieve Stats',
      associationTitle: 'Associatie',
      associationSubTitle: 'Associatieve Stats',
      comboOn: 'Actieve Combo',
      comboOff: 'Elke andere',
      diffGoals90: 'G Verschil 90',
      goals90: 'Niet-Penalty Doelpunten 90',
      goalsAgainst90: 'Niet-Penalty Doelpunten Tegen 90',
      xgAgainstPer90: 'xG Tegen 90',
      xgDiffPer90: 'xG Verschil 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Schoten Op Doel 90',
      touchesOppBox90: 'Aanrakingen Tegenstander Zestienmetergebied 90',
      shotsOnTargetAgainst90: 'Schoten Op Doel Tegen 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Directheid 90',
      possession: 'Balbezit %',
      pctPasses: 'Passes %',
      pctPassesFinalThird: 'Passes Laatste Derde %',
      placeholder: 'Begin door een team te selecteren',
      subtitle: 'Optimaliseer de team metrieken door spelers toe te voegen of te verwijderen uit de opstelling'
    },
    terms: {
      short: 'Korte Termijn',
      mid: 'Middellange Termijn',
      long: 'Lange Termijn'
    },
    report: {
      title: 'Team Rapport',
      selectedPeriod: 'Geselecteerde Periode',
      stackedCharts: 'Gestapelde Grafieken',
      radars: 'Radars',
      generalData: 'Algemene Data',
      scoringChances: 'Scoring Kansen',
      areasReport: 'Gebieden Rapport',
      setPieceReport: 'Vaste Situatie Rapport',
      corners: 'Hoekschoppen',
      cornersAgainst: 'Hoekschoppen Tegen',
      indirectFreeKicks: 'Indirecte Vrije Trappen',
      indirectFreeKicksAgainst: 'Indirecte Vrije Trappen Tegen',
      freeKicks: 'Vrije Trappen',
      freeKicksAgainst: 'Vrije Trappen Tegen',
      penaltys: 'Penalty\'s',
      freeKicksContribution: 'Vrije Trappen Bijdrage',
      shotsContribution: 'Schoten Bijdrage',
      topXPlayersByStats: 'Top {x} Spelers op Stats',
      lastShotZone: 'Laatste Zone Schot',
      throwSide: 'Inworp Kant',
      kindOfThrow: 'Soort Inworp',
      scored: 'Gescoord',
      against: 'Tegen',
      perGame: 'per Wedstrijd',
      total: 'Totaal',
      efficiency: 'Efficiëntie',
      organizedAttack: 'Georganiseerde Aanval',
      offTransition: 'Aanvallende Transitie',
      chances: 'Kansen',
      chancesScored: 'Kansen Gescoord',
      chancesAgainst: 'Kansen Tegen',
      goalsScored: 'Doelpunten Gescoord',
      goalsAgainst: 'Doelpunten Tegen',
      goalsOrganizedAttack: 'Doelpunten Georganiseerde Aanval',
      goalsOffTransition: 'Doelpunten Aanvallende Transitie',
      goalsSetPiece: 'Doelpunten Vaste Situatie',
      goalsOrganizedAttackScored: 'Doelpunten Georg. Aanv. Gescoord',
      goalsOrganizedAttackAgainst: 'Doelpunten Georg. Aanv. Tegen',
      goalsOffTransitionScored: 'Doelpunten Aanv. Trans. Gescoord',
      goalsOffTransitionAgainst: 'Doelpunten Aanv. Trans. Tegen',
      goalsSetPieceScored: 'Doelpunten Vaste Situatie Gescoord',
      goalsSetPieceAgainst: 'Doelpunten Vaste Situatie Tegen',
      crossSide: 'Voorzet Kant',
      externalShot: 'Externe Schot',
      innerPlay: 'Binnenveld Spel',
      throwIn: 'Inworp',
      box: 'Zestienmetergebied',
      zone2: 'Zone 2',
      goalsPerPhases: 'Doelpunten per Fases'
    },
    minutesAlert: '*Toont alleen spelers met 450 of meer minuten gespeeld',
    minutesException: 'Er zijn geen spelers met 450 of meer minuten gespeeld. Toont alle spelers',
    analysis: 'Analyse',
    substitutions: 'Wissels',
    attackZones: 'Aanval Zones',
    formations: 'Formaties',
    shotZones: 'Schot Zones',
    crossings: 'Voorzetten',
    byTime: 'Op Tijd',
    byPosition: 'Op Positie',
    byPlayer: 'Op Speler',
    W: 'Winnen',
    D: 'Gelijk',
    L: 'Verliezen',
    substitutionsByGame: 'Wissels per wedstrijd',
    substitutionsShort: 'Wiss.',
    avgSeasonShort: 'Gem. Seizoen',
    startingAt: 'Beginnend bij',
    endingAt: 'Eindigend bij',
    startingAtInfo: 'Toont aandeel van balbezit gebaseerd op de locatie van het eerste evenement',
    endingAtInfo: 'Toont aandeel van balbezit gebaseerd op de locatie van het laatste evenement',
    endingWithShot: 'Eindigend met schot',
    endingInBox: 'Eindigend in zestienmetergebied',
    pfX: 'PF {x}',
    bySide: 'Op Kant',
    cornerKicks: 'Hoekschoppen',
    included: 'Inbegrepen',
    excluded: 'Uitgesloten',
    onlyCorner: 'Alleen Hoekschop',
    sizeByMarketValue: 'Grootte op Marktwaarde',
    timeInTeam: 'Seizoenen in Team',
    newSignings: 'Nieuwe Aanwinsten',
    sizeBy: 'Grootte op',
    connections: 'Verbindingen',
    assistant: 'Passer',
    finisher: 'Afmaker',
    playersMinutesAlert: 'Toont alleen spelers met minuten gespeeld in het geselecteerde seizoen',
    strategyFilterTooltip: 'Geef de gebeurtenissen weer die plaatsvonden tijdens spelhervattingen of tijdens een open spel',
    sideFilterTooltip: 'Alleen de spelhervattingen weergeven die aan de geselecteerde kant beginnen (links of rechts)',
    teamMinutesAlert: '*Alleen teams worden weergegeven met 450 of meer gespeelde minuten',
    homeCoach: 'Thuiscoach',
    awayCoach: 'Weg-coach'
  },
  leagueTable: {
    subtitle: 'Bekijk hoe de competities verlopen'
  },
  leagueMatchdays: {
    byRound: 'Op Speelronde',
    byDate: 'Op Datum',
    byTeam: 'Op Team'
  },
  teamStats: {
    subtitle: 'Vergelijk hoe teams presteren',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Verschil tussen Verwachte Doelpunten en Doelpunten',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Verschil tussen Verwachte Punten en Punten',
    games: 'WED',
    gamesExplicit: 'Wedstrijden gespeeld',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Punten per Wedstrijd'
  },
  roles: {
    ROLE_USER: 'Gebruiker',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Rapporten',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Fysieke Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Extraheer speler, team, wedstrijd en competitie informatie moeiteloos in JSON formaat.',
    ROLE_EVENTING_DATA_description: 'Duik diep in statistieken met Radar Grafieken, Speler Ranglijsten, kaarten en meer gebaseerd op +100 prestatie metrieken.',
    ROLE_PHYSICAL_DATA_description: 'Toegang tot fitness data en filter spelers op verschillende prestatie metrieken (afstand, snelheid, sprints, versnelling...).',
    ROLE_VIDEO_description: 'Geef video\'s en opstellingen en krijg wedstrijden getagd met evenementen en statistieken voor diepgaande analyse.',
    ROLE_DRIBLAB_HUB_description: 'Volg en beheer scout taken efficiënt met kalenders, notities, waarschuwingen en document delen.',
    ROLE_TRACKING_description: 'Ontvang positionele data van alle spelers in een wedstrijd via onze API voor uitgebreide analyse.',
    ROLE_ARRIGO_description: 'Combineer eventing en tracking data in innovatieve metrieken die verder gaan dan traditioneel en waarde toevoegen aan elke actie.',
    ROLE_REPORTS_description: 'Vraag gedetailleerde scout rapporten aan van ons team van analisten om het perfecte team of speler te vinden.',
    ROLE_RAW_EVENTING: 'Rauwe eventing'
  },
  administration: {
    pageSubtitle: 'Beheer de werking van de applicatie',
    newClient: 'Nieuwe Klant',
    clientDuplicateName: 'Er bestaat al een klant met deze naam. Selecteer die klant in de lijst en gebruik «Nieuwe Gebruiker» om daar gebruikers toe te voegen.',
    newUser: 'Nieuwe Gebruiker',
    editClient: 'Bewerk Klant',
    editUser: 'Bewerk Gebruiker',
    clientName: 'Naam',
    permissions: 'Machtigingen',
    releaseUser: 'Vrijgeven Gebruiker',
    connectAsUser: 'Verbind als Gebruiker',
    releaseModalTitle: 'Gebruiker Vrijgeven Bevestiging',
    releaseModalMessage: 'De gebruiker zal een e-mail ontvangen over zijn nieuwe account. Weet je zeker dat je hem wilt notificeren?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Team',
      Brand: 'Merk',
      Federation: 'Bond',
      Media: 'Media',
      Agency: 'Bureau',
      Individual: 'Individueel'
    },
    userType: {
      Ownership: 'Eigendom',
      SportingDirector: 'Sportief Directeur',
      Brand: 'Merk',
      Federation: 'Bond',
      Media: 'Media',
      Agency: 'Bureau',
      Individual: 'Individueel',
      Scout: 'Scout',
      Coach: 'Trainer',
      supervision: {
        title: 'Hiërarchie van toezicht',
        subtitle: 'Het toezicht stroomt alleen naar beneden. Toezicht op hetzelfde niveau is niet toegestaan.',
        supervisesLowerLevels: 'Houdt toezicht op alle onderstaande rollen',
        ruleNoSameLevel: 'Rollen op hetzelfde niveau kunnen elkaar niet controleren.',
        ruleOnlyDownwards: 'Toezicht is alleen toegestaan ​​van hogere naar lagere rollen.',
        ruleLevel3NoSupervision: 'Het laagste niveau heeft geen toezichtrechten.',
        currentUserType: 'Uw huidige gebruikerstype'
      }
    },
    visibleYears: 'Zichtbare Jaren',
    areaModalTitle: 'Competities Activeren/Deactiveren Bevestiging',
    areaModalMessage: 'Weet je zeker dat je alle competities van het geselecteerde gebied wilt activeren/deactiveren?',
    countStats: 'Tel Statistieken',
    userClientModalTitle: 'Gebruiker bestaat al in een andere klant',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Contract',
    contracts: 'Contracten',
    invoiceName: 'Factuur Naam',
    contractFee: 'Contract Vergoeding',
    renewal: 'Vernieuwing',
    consultancy: 'Consultancy',
    deleteContract: 'Verwijder Klant Contract',
    deleteContractMessage: 'Het contract wordt permanent verwijderd. Weet je het zeker?',
    activeVsHired: 'Actief vs Ingehuurd',
    requestedVsHired: 'Aangevraagd vs Ingehuurd',
    activeVsHiredWithPlaceholder: '{0} Actief versus {1} Aangeworven',
    requestedVsHiredWithPlaceholder: '{0} aangevraagd versus {1} ingehuurd',
    salesRepresentative: 'Verkoop Vertegenwoordiger',
    periodicities: {
      periodicity: 'Periodiciteit',
      annual: 'Jaarlijks',
      biannual: 'Tweejaarlijks',
      quarterly: 'Kwartaal',
      monthly: 'Maandelijks',
      bimonthly: 'Tweemaandelijks',
      onePayment: 'Eenmalige betaling',
      fourmonthly: 'Elke vier maanden'
    },
    paymentMethods: {
      payment: 'Betaling',
      method: 'Methode',
      transfer: 'Overschrijving',
      mandate: 'Mandaat'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Social Media Advertentie',
      videoWithFeedback: 'Video met Feedback'
    },
    status: {
      status: 'Status',
      pending: 'In behandeling',
      active: 'Actief',
      expiringSoon: 'Verloopt binnenkort',
      expired: 'Verlopen',
      expiringSoonWithDays: 'Het contract loopt binnenkort af: nog {0} dagen'
    },
    updates: {
      roleAdded: '<b>{0}</b> heeft rol <b>{1}</b> toegevoegd aan <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> heeft rol <b>{1}</b> verwijderd van <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> heeft <b>{1}</b> toegevoegd aan competitie <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> heeft <b>{1}</b> verwijderd uit competitie <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> heeft <b>{1}</b> toegevoegd aan seizoen <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> heeft <b>{1}</b> verwijderd uit seizoen <b>{2}</b>.',
      updateNotesPlaceholder: 'Voeg context toe voor de wijziging of relevante opmerkingen hier...',
      updates: 'Updates',
      products: 'Producten'
    },
    clients: 'Klanten',
    trials: 'Proeven',
    activeClients: 'Actieve klanten',
    activeTrials: 'Actieve proeven',
    activeTrialUsers: 'Actieve proefgebruikers',
    activeContracts: 'Actieve contracten',
    expiration: 'Vervaldatum',
    clientWarnings: {
      activeContractInactiveClient: 'Klanten met actieve contracten maar geen ingeschakelde gebruikers',
      activeContractTrialUsers: 'Klanten met proefgebruikers terwijl een contract actief is',
      activeUsersWithoutContract: 'Klanten met actieve niet-proefgebruikers maar zonder actief contract',
      upcomingExpirations: 'Aankomende vervaldata',
      renewedContracts: 'Klanten met verlengde contracten',
      clientsWithWarnings: 'Klanten die aandacht nodig hebben',
      enabledUsersWithoutContract: '\'Ingeschakelde niet-proefgebruikers zonder actief contract\'',
      trialUsersWithContract: 'Gebruikers in proefmodus ondanks een actief contract',
      activeContractInactiveUsers: 'Klant heeft een actief contract waarbij alle gebruikers inactief zijn',
      activeContract: 'Deze klant heeft een actief contract',
      noEnabledUsers: 'Deze client heeft geen ingeschakelde gebruikers',
      ongoingTrialInactiveUsers: 'Clients met een lopende proefperiode maar geen ingeschakelde gebruikers',
      neverLoggedIn: 'Klanten die nog nooit hebben ingelogd'
    },
    daysLeft: 'Nog dagen over',
    expiringSoon: 'Verloopt binnenkort',
    loggedThisWeek: 'Deze week ingelogd',
    withWarnings: 'Met waarschuwingen',
    ofActiveClients: 'van actieve klanten',
    endingIn30Days: 'eindigt over 30 dagen',
    neverLogged: 'nooit ingelogd',
    ofActiveTrials: 'van actieve proeven',
    activeClientsWithoutTrial: 'actieve klanten (excl. proefperiode)',
    renewals: 'Verlengingen',
    ofActiveContracts: 'van actieve contracten'
  },
  dashboards: {
    lastGame: 'Laatste wedstrijd analyse',
    lastGameSimple: 'Laatste wedstrijd',
    seeAllGameInfo: 'Bekijk alle wedstrijd info',
    nextGame: 'Volgende Wedstrijd Voorvertoning',
    myTeam: 'Mijn Team',
    lastMatchdayGames: 'Laatste Speelronde',
    lastAdded: 'Laatst Toegevoegd',
    myFavorites: 'Mijn Favorieten',
    seeAllFavorites: 'Bekijk alle favorieten',
    placeholderFavorites: 'Je kunt favorieten toevoegen vanuit speler detail',
    placeholderTeamFavorites: 'Je kunt favorieten toevoegen vanuit team detail',
    placeholderLeagueFavorites: 'Je kunt favorieten toevoegen vanuit competitie detail',
    myCollections: 'Mijn Collecties',
    placeholderCollections: 'Je hebt nog geen collecties',
    lastCreated: 'Laatst Aangemaakt',
    seeAllCollections: 'Bekijk alle collecties',
    seeRival: 'Bekijk Tegenstander',
    seeMyTeam: 'Bekijk Mijn Team',
    title: 'Dashboard Overzicht',
    subtitle: 'Welkom terug',
    recentPlayers: 'Recente spelers',
    lastScouted: 'Laatst gescout',
    scout: 'Scout',
    reportsRequested: 'Rapporten',
    lastRequested: 'Laatst aangevraagd',
    goInbox: 'Ga naar Inbox',
    placeholderLastScouted: 'Je kunt zoeken naar spelers in de linker balk of in de scout tool',
    placeholderReports: 'Je kunt rapporten aanvragen vanuit speler detail',
    nationalPlayers: 'Meest waardevolle nationale spelers in andere landen',
    lastGames: 'Laatste Wedstrijden',
    nationalPlayersShort: 'Nationale spelers in andere landen',
    nextMatchdayGames: 'Volgende Speelronde',
    injuredPlayers: 'Geblesseerde Spelers',
    atPresent: 'Tegenwoordig',
    seeAllPlayers: 'Bekijk alle spelers',
    suspendedPlayers: 'Geschorste Spelers',
    placeholderInjured: 'Er zijn geen geblesseerde spelers',
    teamValueImpacted: 'Team Waarde Beïnvloed',
    placeholderSuspended: 'Er zijn geen geschorste spelers',
    placeholderNextGame: 'Er is geen beschikbare wedstrijd',
    placeholderNoGames: 'Er zijn nog geen wedstrijden beschikbaar',
    placeholderLastMatchDayNotFound: 'Laatste speelronde niet beschikbaar',
    placeholderNextMatchDayNotFound: 'Volgende speelronde niet beschikbaar',
    usersMostSearch: 'Gebruikers met meeste zoekopdrachten',
    lastTwoDays: 'Laatste twee dagen',
    searchesHistory: 'Zoekgeschiedenis',
    dayByDay: 'Dagelijks',
    activeUsersTitle: 'Actieve Gebruikers',
    activeUsersSubtitle: 'Ingelogd ten minste één keer in de afgelopen maand',
    onlineUsersTitle: 'Online Gebruikers',
    onlineUsersSubtitle: 'Iets gezocht in het laatste uur',
    searchesPerformed: 'Zoekopdrachten Uitgevoerd',
    onlyClients: 'Alleen klanten',
    activeClientsTitle: 'Actieve Klanten',
    activeClientsSubtitle: 'Heeft ten minste één actieve gebruiker',
    last24Hours: 'Laatste 24 Uren',
    activityHistory: 'Activiteit Geschiedenis',
    loginHistory: 'Toegang Geschiedenis',
    failLogins: 'Mislukte Toegang',
    successLogins: 'Succesvolle Toegang',
    clientStats: 'Klant Statistieken',
    playersMostSearch: 'Spelers met meeste zoekopdrachten',
    toolsMoreUsed: 'Meest gebruikte tools',
    hotPlayers: 'Populaire Spelers',
    last_month: 'Laatste Maand',
    last_week: 'Laatste Week',
    last_day: 'Laatste Dag',
    nClients: 'Aantal Klanten',
    userDashboard: 'Gebruiker Dashboard',
    userDashboardSubtitle: 'Account activiteit samenvatting',
    offlineDaysOfClient: 'Offline dagen per klant',
    hideNoConnected: 'Verberg niet verbonden',
    onlyTrial: 'Alleen proefklanten',
    daysWithoutLogin: 'Dagen zonder inloggen',
    trialDays: 'Proefdagen'
  },
  faq: {
    subtitle: 'Leer meer over wat Driblab PRO is',
    categories: {
      playerMetrics: 'Speler Metrieken',
      teamMetrics: 'Team Metrieken',
      positions: 'Team Posities',
      tools: 'Tools',
      api: 'API',
      videos: 'Tutorials',
      playerPositions: 'Speler Posities',
      userTypes: 'Gebruikerstypen'
    },
    positions: {
      GK: 'Doelman',
      DR: 'Rechtsback / Rechtsback (RB)',
      DC: 'Centrale Verdediger / Centrale Verdediger (CB)',
      DL: 'Linksback / Linksback (LB)',
      DMR: 'Rechtsvleugelverdediger (RWB)',
      DMC: 'Centrale Defensieve Middenvelder (CDM)',
      DML: 'Linksvleugelverdediger (LWB)',
      MR: 'Rechts Middenvelder (RM)',
      MC: 'Centrale Middenvelder (CM)',
      ML: 'Links Middenvelder (LM)',
      AMR: 'Aanvallende Middenvelder Rechts / Rechtsbuiten (RW)',
      AMC: 'Aanvallende Middenvelder Centraal / Geavanceerde Middenvelder',
      AML: 'Aanvallende Middenvelder Links / Linksbuiten (LW)',
      FWR: 'Spits Rechts / Rechts Spits (RS)',
      FW: 'Spits / Spits (ST)',
      FWL: 'Spits Links / Links Spits (LS)'
    },
    metrics: {
      categories: {
        Association: 'Associatie',
        Saving: 'Redden',
        Shooting: 'Schieten',
        Defending: 'Verdedigen',
        Passing: 'Passen',
        BallHandling: 'Balbehandeling',
        Aerial: 'Luchtduel',
        Physical: 'Fysiek',
        Predictive: 'Voorspellend',
        Arrigo: 'Arrigo',
        Score: 'Score',
        Turnovers: 'Balverlies',
        Carries: 'Balvoering',
        SequenceInvolvement: 'Sequentie Betrokkenheid',
        Crosses: 'Voorzetten',
        Distance: 'Afstand',
        Sprint: 'Sprint',
        Acceleration: 'Versnelling',
        MaxAcceleration: 'Max Versnelling',
        Speed: 'Snelheid',
        OutPlay: 'Outplay',
        LineBreakingPasses: 'Lijn Doorbrekende Passes',
        LineBreakingCarries: 'Lijn Doorbrekende Balvoering',
        LineBreakingActions: 'Lijn Doorbrekende Acties',
        PassUnderPressure: 'Pass Onder Druk',
        BallReceived: 'Bal Ontvangst',
        PassesUnderPressure: 'Gaat Onder Druk Door',
        OnBallPressureReceived: 'Op-Bal Druk Ontvangen',
        OnBallPressure: 'Op-Bal Druk',
        BallReceiptsInSpace: 'Bal Ontvangst in Ruimte',
        SpatialCoverage: 'Ruimtelijke Dekking',
        OffBallPressure: 'Off-Bal Druk',
        OffBallRuns: 'Off-Bal Runs',
        NoCategory: 'Anderen',
        subcategories: {
          Quality: 'Kwaliteit',
          Quantity: 'Kwantiteit',
          TeamComparison: 'Team Vergelijking',
          Receptions: 'Ontvangsten',
          LongBalls: 'Lange Ballen',
          Efficiency: 'Efficiëntie',
          Ratio: 'Verhouding',
          Defensive: 'Defensief',
          Offensive: 'Offensief',
          Foot: 'Voet',
          Progression: 'Voortgang',
          TopValue: 'Top Waarde',
          Predictive: 'Voorspellend',
          Distance: 'Afstand',
          Aerial: 'Luchtduel',
          Crosses: 'Voorzetten',
          NoCategory: 'Anderen'
        },
        desc: {
          Association: 'Associatie',
          Saving: 'Redden',
          Shooting: 'Schieten',
          Defending: 'Verdedigen',
          Passing: 'Passen',
          BallHandling: 'Balbehandeling',
          Aerial: 'Luchtduel',
          Physical: 'Fysiek',
          Predictive: 'Voorspellend',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'Balverlies',
          Carries: 'Balvoering',
          SequenceInvolvement: 'Sequentie Betrokkenheid',
          Crosses: 'Voorzetten',
          Distance: 'Afstand afgelegd bij verschillende snelheden',
          Sprint: 'Sprint bij verschillende snelheden',
          Acceleration: 'Versnelling',
          Speed: 'Snelheid bereikt door spelers op een bepaald moment tijdens de wedstrijd',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Lijn Doorbrekende Passes',
          LineBreakingCarries: 'Lijn Doorbrekende Balvoering',
          LineBreakingActions: 'Lijn Doorbrekende Acties',
          PassUnderPressure: 'Pass Onder Druk',
          BallReceived: 'Bal Ontvangst',
          OnBallPressureReceived: 'Op-Bal Druk Ontvangen',
          OnBallPressure: 'Op-Bal Druk',
          BallReceiptsInSpace: 'Bal Ontvangst in Ruimte',
          SpatialCoverage: 'Ruimtelijke Dekking',
          OffBallPressure: 'Off-Bal Druk',
          OffBallRuns: 'Off-Bal Runs',
          HandPassing: 'Passes gemaakt met de hand door keepers of inworp in een spelhervatting'
        },
        abbr: {
          Association: 'Associatie',
          Saving: 'Redden',
          Shooting: 'Schieten',
          Defending: 'Verdedigen',
          Passing: 'Passen',
          BallHandling: 'Bal H.',
          Aerial: 'Luchtduel',
          Physical: 'Fysiek',
          Predictive: 'Voorspellend',
          Arrigo: 'Arrigo',
          Score: 'Score',
          Turnovers: 'TOV',
          Carries: 'Balvoering',
          SequenceInvolvement: 'Seq. Betr.',
          Crosses: 'Voorzetten',
          Distance: 'Afstand',
          Sprint: 'Sprint',
          Acceleration: 'Versnelling',
          MaxAcceleration: 'Max. Versnelling',
          Speed: 'Snelheid',
          OutPlay: 'Outplay',
          LineBreakingPasses: 'Lijn Doorbrekende Passes',
          LineBreakingCarries: 'Lijn Doorbrekende Balvoering',
          LineBreakingActions: 'Lijn Doorbrekende Acties',
          PassUnderPressure: 'Pass Onder Druk',
          BallReceived: 'Bal Ontvangst',
          OnBallPressureReceived: 'Op-Bal Druk Ontvangen',
          OnBallPressure: 'Op-Bal Druk',
          BallReceiptsInSpace: 'Bal Ontvangst in Ruimte',
          SpatialCoverage: 'Ruimtelijke Dekking',
          OffBallPressure: 'Off-Bal Druk',
          OffBallRuns: 'Off-Bal Runs',
          HandPassing: 'Hand passeren'
        },
        HandPassing: 'Hand passeren'
      },
      types: {
        1: 'Per 90',
        2: 'Percentage',
        3: 'Rate',
        4: 'Efficiëntie',
        5: 'Gemiddelde',
        6: 'Per Wedstrijd',
        7: 'Verschil',
        8: 'Max'
      },
      moreInfo: 'Je kunt hier meer lezen'
    },
    api: {
      subtitle: 'Krijg data van verschillende verzoeken',
      resourcesTitle: 'Bronnen',
      authentication: 'Authenticatie',
      authText: 'Om de API aan te roepen moet je in elke aanvraag de header `Authorization` opnemen met waarde `Bearer {API_TOKEN}`',
      generate: 'Genereren',
      tokenPlaceholder: 'Als je geen token hebt of deze is verlopen, klik op \'Genereren\'',
      pathParameters: 'Pad Parameters',
      queryParameters: 'Query Parameters',
      responseModel: 'Response Model',
      tokenWarning: '* Genereer een token om de API te gebruiken',
      pathParamsWarning: '* Er zijn oningevulde Pad Parameters',
      genericDescription: 'Een API (Application Programming Interface) stelt ontwikkelaars in staat om data of functionaliteit te benaderen en te integreren in hun eigen applicaties. Onze voetbal statistieken API biedt uitgebreide toegang tot een verscheidenheid aan datapunten over landen, competities, teams, spelers, wedstrijden en meer. Door deze API te gebruiken kun je applicaties bouwen die gebruik maken van onze rijke voetbaldata voor analyses, visualisaties of andere innovatieve oplossingen.',
      methods: {
        getAllCountries: 'Deze methode haalt een complete lijst op van alle landen beschikbaar in de API, met belangrijke details zoals de unieke identifier en naam van elk land. Dit endpoint is ideaal voor applicaties die geografische voetbaldata vereisen, waardoor functies zoals landselectie, filtering en analyses mogelijk worden. Het dient ook als een fundamentele bron voor interactie met andere endpoints die afhankelijk zijn van een `countryId` parameter, wat zorgt voor soepele navigatie en integratie met de bredere dataset van de API.',
        getCountryDetail: 'Deze methode biedt gedetailleerde informatie over een specifiek land beschikbaar in de API. Door dit endpoint te gebruiken kun je data ophalen zoals de naam van het land, code en alle relevante metadata die eraan gekoppeld zijn. Deze methode is bijzonder nuttig voor applicaties die landspecifieke details vereisen om de gebruikerservaring te verbeteren, zoals het weergeven van contextuele informatie of het creëren van op maat gemaakte inzichten gebaseerd op geografische data. Het vult andere endpoints aan door diepere verkenning van een geselecteerd land mogelijk te maken.',
        getCountryCompetitions: 'Deze methode haalt een lijst op van alle competities beschikbaar binnen een specifiek land. Het is een waardevolle bron voor het bouwen van functies die gebruikers in staat stellen om competities per regio te verkennen, wat een naadloze manier biedt om landdata te verbinden met de bijbehorende toernooien. Dit endpoint is essentieel voor applicaties die zich richten op gelokaliseerde voetbalcontent of regionale analyses.',
        getAllCompetitionTypes: 'Deze methode retourneert een lijst van alle competitie types beschikbaar in de API, zoals competities, bekers en internationale toernooien. Dit endpoint is ideaal voor het categoriseren van competities en het bieden van gebruikers een georganiseerd overzicht van de verschillende soorten evenementen die gedekt worden. Het is bijzonder nuttig voor het bouwen van functies zoals filters of dropdowns die gebruikers in staat stellen om voetbaldata te verkennen op basis van de aard van de competitie.',
        getAllCompetitions: 'Deze methode haalt een uitgebreide lijst op van alle competities beschikbaar in de API, ongeacht type of locatie. Dit endpoint is nuttig voor applicaties die een breed scala aan voetbalcompetities moeten weergeven of analyseren, waardoor gebruikers evenementen van interesse kunnen verkennen en selecteren.',
        getCompetitionAvailable: 'Deze methode haalt een lijst op van competities die momenteel als beschikbaar zijn gemarkeerd in de API. Dit zorgt ervoor dat de geretourneerde data up-to-date is en klaar voor gebruik in applicaties. Het is bijzonder nuttig voor ontwikkelaars die functies bouwen die afhankelijk zijn van actieve of toegankelijke competities, waardoor gebruikers relevante evenementen kunnen verkennen zonder verouderde of incomplete data tegen te komen.',
        getCompetitionDetail: 'Deze methode biedt gedetailleerde informatie over een specifieke competitie beschikbaar in de API. Het is bijzonder nuttig voor applicaties die diepgaande informatie over een competitie vereisen, waardoor functies zoals gedetailleerde weergaven, contextuele inzichten of filteropties gebaseerd op competitiekenmerken mogelijk worden.',
        getCompetitionSeasons: 'Deze methode haalt een lijst op van alle seizoenen geassocieerd met een specifieke competitie. Dit endpoint is essentieel voor applicaties die uitgebreide dekking van de geschiedenis of huidige staat van een competitie willen bieden, waardoor gebruikers data seizoen voor seizoen kunnen verkennen.',
        getSeasonAvailable: 'Deze methode biedt een lijst van seizoenen die momenteel als beschikbaar zijn gemarkeerd in de API. Het is bijzonder nuttig voor applicaties die zich richten op live of lopende voetbalevenementen, waardoor gebruikers kunnen interacteren met relevante en actuele seizoensdata.',
        getSeasonDetail: 'Deze methode haalt gedetailleerde informatie op over een specifiek seizoen, inclusief de tijdlijn, geassocieerde competitie en belangrijke metadata. Dit endpoint is essentieel voor applicaties die diepgaande inzichten in een bepaald seizoen vereisen, waardoor functies zoals seizoensoverzichten, filtering op competitie of het weergeven van gedetailleerde tijdlijnen voor gebruikersinteractie mogelijk worden.',
        getSeasonTeams: 'Deze methode biedt een lijst van alle teams die deelnemen aan een specifiek seizoen. Het is ideaal voor functies zoals selectiebeheer, team prestatieanalyse of het creëren van seizoensspecifieke filters voor gebruikers.',
        getSeasonPlayer: 'Deze methode haalt een lijst op van alle spelers geregistreerd in een specifiek seizoen. Het is ideaal voor het bouwen van functies zoals speler selecties, prestatie tracking of het filteren van spelers op basis van het geselecteerde seizoen.',
        getSeasonPlayerStats: 'Deze methode biedt gedetailleerde statistieken voor alle spelers in een specifiek seizoen. Het is bijzonder nuttig voor applicaties gericht op analyses, speler vergelijkingen of het creëren van dynamische visualisaties van seizoenslange speler prestaties.',
        getSeasonArrigoMetrics: 'Deze methode biedt gecombineerde statistieken voor alle spelers in een specifiek seizoen. Het is bijzonder nuttig voor applicaties gericht op analyses, speler vergelijkingen of het creëren van dynamische visualisaties van seizoenslange speler prestaties.',
        getSeasonTeamStats: 'Deze methode biedt uitgebreide statistieken voor alle teams die deelnemen aan een specifiek seizoen. Het is bijzonder nuttig voor applicaties gericht op teamanalyse, seizoenssamenvattingen of vergelijkingen van team prestaties gedurende het seizoen.',
        getSeasonCoaches: 'Deze methode haalt een lijst op van alle trainers die teams hebben begeleid tijdens een specifiek seizoen. Het is bijzonder nuttig voor applicaties die zich richten op seizoensinzichten, traineranalyse of het volgen van veranderingen in teammanagement gedurende een seizoen.',
        getSeasonGames: 'Deze methode biedt een lijst van alle wedstrijden gespeeld in een specifiek seizoen. Het is ideaal voor applicaties die volledige seizoenschema\'s moeten weergeven, wedstrijduitkomsten analyseren of gebruikers toegang bieden tot uitgebreide seizoenswedstrijddata.',
        getSeasonGamesMatchday: 'Deze methode haalt alle wedstrijden op voor een specifieke speelronde binnen een bepaald seizoen. Het is bijzonder nuttig voor applicaties die speelrondeschema\'s willen weergeven, specifieke rondes analyseren of gerichte inzichten bieden in een bepaalde set wedstrijden tijdens het seizoen.',
        getSeasonLeagueTable: 'Deze methode biedt de competitietabel voor een specifiek seizoen, inclusief ranglijsten, punten, overwinningen, gelijke spelen, verliezen en andere relevante statistieken voor elk team. Dit endpoint is essentieel voor applicaties gericht op het volgen van teamstanden, het analyseren van competitievoortgang of het presenteren van up-to-date ranglijsten gedurende het seizoen.',
        getTeamDetail: 'Deze methode biedt gedetailleerde informatie over een specifiek team, inclusief de naam, oprichtingsjaar, stadion en andere metadata. Dit endpoint is ideaal voor applicaties die teamspecifieke inzichten vereisen, waardoor functies zoals gedetailleerde teamprofielen, historische context of verbeterde gebruikerservaringen met rijke teamgerelateerde data mogelijk worden.',
        getTeamLoans: 'Deze methode haalt informatie op over huurtransacties waarbij een specifiek team betrokken is. Dit endpoint is bijzonder nuttig voor applicaties gericht op transferanalyse, team selectiebeheer of het volgen van spelerbewegingen tijdens een seizoen.',
        getTeamRoster: 'Deze methode biedt een complete lijst van spelers in de selectie van een specifiek team. Het is ideaal voor applicaties die teamopstellingen moeten weergeven, spelerrollen analyseren of selectiegerelateerde functionaliteiten voor een team beheren.',
        getTeamGames: 'Deze methode haalt een lijst op van alle wedstrijden gespeeld door een specifiek team. Het is bijzonder nuttig voor applicaties die zich richten op team prestaties, schema tracking of het bieden van gebruikers toegang tot de complete wedstrijdgeschiedenis van een team.',
        getTeamGameStats: 'Deze methode biedt gedetailleerde statistieken voor een specifiek team in een bepaalde wedstrijd. Het is bijzonder nuttig voor applicaties gericht op wedstrijdanalyses, prestatie evaluaties of diepgaande uitsplitsingen van de prestaties van een team in individuele wedstrijden.',
        getTeamTransfers: 'Deze methode haalt informatie op over transfertransacties waarbij een specifiek team betrokken is. Het is bijzonder nuttig voor applicaties die zich richten op transfermarktanalyse, team selectieveranderingen of het volgen van spelerbewegingen over tijd.',
        getGameStatus: 'Deze methode biedt een lijst van alle mogelijke wedstrijdstatussen beschikbaar in de API, zoals gepland, in uitvoering, voltooid, uitgesteld of geannuleerd. Dit endpoint is bijzonder nuttig voor applicaties die real-time wedstrijdtracking vereisen, wedstrijden filteren op status of gebruikers duidelijke updates bieden over de voortgang of staat van een wedstrijd.',
        getPlayerPositions: 'Deze methode retourneert een lijst van alle mogelijke spelerposities, zoals doelman, verdediger, middenvelder en spits. Dit endpoint is bijzonder nuttig voor applicaties die spelers categoriseren, positionele data analyseren of gebruikers in staat stellen om spelers te filteren op basis van hun rollen op het veld.',
        getGameDetail: 'Deze methode biedt uitgebreide informatie over een specifieke wedstrijd, inclusief details zoals deelnemende teams, datum en tijd, locatie, score en andere belangrijke metadata. Dit endpoint is ideaal voor applicaties die diepgaande wedstrijdinzichten vereisen, waardoor functies zoals gedetailleerde wedstrijdvoorvertoningen, rapporten of analyses mogelijk worden.',
        getGameStats: 'Deze methode biedt gedetailleerde statistieken voor een specifieke wedstrijd, inclusief metrieken zoals doelpunten, schoten, balbezitpercentages, passes en defensieve acties. Dit endpoint is bijzonder nuttig voor applicaties gericht op wedstrijdanalyse, na-wedstrijd rapporten of visualisaties van team prestaties tijdens een wedstrijd.',
        getGamePlayerStats: 'Deze methode haalt gedetailleerde prestatiestatistieken op voor alle spelers die deelnamen aan een specifieke wedstrijd. Het is bijzonder nuttig voor applicaties die individuele speler prestaties analyseren, wedstrijdrapporten genereren of spelers vergelijken binnen een enkele wedstrijdcontext.',
        getGamePlayerPhysicalStats: 'Deze methode biedt gedetailleerde fysieke prestatiemetrieken voor spelers in een specifieke wedstrijd. Het is bijzonder nuttig voor applicaties gericht op speler fitnessanalyse, fysieke prestatie tracking of het genereren van gedetailleerde wedstrijdinzichten voor individuele spelers.',
        getGameTeamPhysicalStats: 'Deze methode biedt gedetailleerde fysieke prestatiemetrieken voor teams in een specifieke wedstrijd. Dit omvat data zoals totale afgelegde afstand, aantal sprints, hoge intensiteit runs en andere fysieke attributen. Het is bijzonder nuttig voor applicaties gericht op team fitnessanalyse, het vergelijken van fysieke inspanningen tussen teams of het evalueren van algehele prestaties in een wedstrijd.',
        getGamePlayerArrigoMetrics: 'Deze methode biedt gedetailleerde arrigo metrieken voor spelers in een specifieke wedstrijd. Het is bijzonder nuttig voor applicaties gericht op het analyseren en genereren van gedetailleerde inzichten in spelers in een wedstrijd.',
        getGameTeamArrigoMetrics: 'Deze methode biedt gedetailleerde arrigo metrieken voor teams in een specifieke wedstrijd. Dit omvat data zoals omzeilde spelers en andere attributen. Het is bijzonder nuttig voor applicaties gericht op het analyseren en evalueren van algehele prestaties in een wedstrijd.',
        getGameLineup: 'Deze methode haalt de opstelling op voor een specifieke wedstrijd, inclusief startende spelers, wisselspelers en hun respectievelijke posities. Dit endpoint is bijzonder nuttig voor applicaties die voor-wedstrijd informatie weergeven, teamformaties analyseren of inzichten bieden in tactische beslissingen gemaakt door teams voor een bepaalde wedstrijd.',
        getGameTimeline: 'Deze methode biedt een chronologische lijst van evenementen die plaatsvonden tijdens een specifieke wedstrijd. Het is bijzonder nuttig voor applicaties die live wedstrijdupdates, na-wedstrijd samenvattingen of gedetailleerde analyses van wedstrijdevenementen bieden.',
        getGameTracking: 'Deze methode biedt een link om het tracking data bestand te downloaden voor een specifieke wedstrijd. Dit bestand bevat gedetailleerde beweging en positionele data voor spelers en de bal gedurende de wedstrijd. Het is bijzonder nuttig voor applicaties gericht op geavanceerde analyses, tactische analyse of het creëren van visualisaties van speler en bal bewegingen tijdens de wedstrijd.',
        getTrackingStatus: 'Deze methode retourneert een complete lijst van alle staten beschikbaar in de tracking, met belangrijke details zoals de unieke identifier en naam van elke staat. Dit endpoint is ideaal voor applicaties die wedstrijdtracking vereisen, waardoor functies zoals staatselectie, filtering en analyse mogelijk worden. Het dient ook als een kritieke bron voor interactie met andere endpoints die afhankelijk zijn van een `statusId` parameter, wat zorgt voor naadloze navigatie en integratie met de bredere dataset van de API.',
        getPlayerTransfersTypes: 'Deze methode haalt een lijst op van mogelijke speler transfer types, zoals permanente transfer, huur, gratis transfer of ruil. Dit endpoint is bijzonder nuttig voor applicaties die transfermarkt trends analyseren, spelerbewegingen categoriseren of gebruikers gedetailleerde inzichten bieden in de soorten transacties waarbij spelers betrokken zijn.',
        getPlayerDetail: 'Deze methode biedt gedetailleerde informatie over een specifieke speler, inclusief persoonlijke details, carrièrestatistieken en huidige teamaffiliatie. Dit endpoint is ideaal voor applicaties die spelerprofielen, historische inzichten of analyses bieden op individuele speler prestaties en carrièretrajecten.',
        getPlayerGames: 'Deze methode haalt een lijst op van alle wedstrijden waarin een specifieke speler heeft deelgenomen. Het is bijzonder nuttig voor applicaties gericht op speler prestatie tracking, wedstrijdgeschiedenis analyse of het bieden van gebruikers uitgebreide wedstrijdlogs voor individuele spelers.',
        getPlayerInjuries: 'Deze methode biedt een gedetailleerd overzicht van blessures opgelopen door een specifieke speler. Het is bijzonder nuttig voor applicaties gericht op speler gezondheidsanalyse, carrière impact beoordelingen of het volgen van herstel tijdlijnen.',
        getPlayerNationalTeam: 'Deze methode haalt gedetailleerde informatie op over de deelname van een speler aan nationale teamwedstrijden. Het is bijzonder nuttig voor applicaties gericht op speler prestaties op nationaal niveau, het volgen van internationale carrières of het bieden van inzichten in bijdragen tijdens toernooien en vriendschappelijke wedstrijden.',
        getPlayerSeasons: 'Deze methode biedt een lijst van alle seizoenen waarin een specifieke speler heeft deelgenomen. Het is bijzonder nuttig voor applicaties die de carrièrevoortgang van een speler volgen, prestaties over seizoenen analyseren of historische context bieden voor hun prestaties.',
        getPlayerTransfers: 'Deze methode haalt een gedetailleerde geschiedenis op van transfertransacties waarbij een specifieke speler betrokken is. Het is bijzonder nuttig voor applicaties gericht op speler carrièreanalyse, transfermarkt inzichten of het volgen van de beweging van spelers tussen teams over tijd.',
        getPlayerSeasonTeamStats: 'Deze methode biedt gedetailleerde prestatiestatistieken voor een specifieke speler tijdens een bepaald seizoen met een team. Het is bijzonder nuttig voor applicaties gericht op seizoenslange speleranalyse, vergelijkingen over teams of seizoenen en het volgen van individuele bijdragen aan team succes.',
        getPlayerSeasonPhysicalStats: 'Deze methode biedt gedetailleerde fysieke prestatiemetrieken voor een specifieke speler gedurende een seizoen. Het is bijzonder nuttig voor applicaties gericht op speler fitness tracking, fysieke prestatieanalyse of het beoordelen van de werklast van een speler tijdens een seizoen.',
        getPlayerSeasonGamePhysicalStats: 'Deze methode biedt gedetailleerde fysieke prestatiemetrieken voor een specifieke speler op een wedstrijd-voor-wedstrijd basis binnen een seizoen. Het is bijzonder nuttig voor applicaties gericht op wedstrijdspecifieke fitnessanalyse, het volgen van speler werklast of het vergelijken van fysieke prestaties over verschillende wedstrijden.',
        getPlayerSeasonGameStats: 'Deze methode haalt gedetailleerde prestatiestatistieken op voor een specifieke speler op een wedstrijd-voor-wedstrijd basis binnen een seizoen. Het is bijzonder nuttig voor applicaties gericht op wedstrijdspecifieke speleranalyse, prestatie trends of gedetailleerde vergelijkingen over wedstrijden binnen een seizoen.',
        getCoachDetail: 'Deze methode biedt gedetailleerde informatie over een specifieke trainer, inclusief hun naam, carrièregeschiedenis, begeleide teams en opmerkelijke prestaties. Dit endpoint is bijzonder nuttig voor applicaties die trainerprofielen benadrukken, managementcarrières volgen of de impact van trainers op team prestaties analyseren.',
        getCoachHistory: 'Deze methode haalt een uitgebreide geschiedenis op van de carrière van een specifieke trainer, inclusief de teams die ze hebben begeleid, competities waaraan ze hebben deelgenomen en hun ambtstermijnen. Dit endpoint is bijzonder nuttig voor applicaties die zich richten op het analyseren van trainer carrières, het volgen van managementveranderingen of het bieden van inzichten in de professionele reis en prestaties van een trainer.',
        getGameEventing: 'Deze methode biedt alle gebeurtenissen',
        getLinkStream: 'Met deze methode wordt de link opgehaald om gamevideo te bekijken',
        getLinkDownload: 'Met deze methode wordt de link opgehaald om gamevideo te downloaden',
        getGameTs: 'Deze methode levert de laatste tijdstempel in een specifieke wedstrijd',
        getGameFileTypes: 'Deze methode biedt de bestandstypen voor match',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Deze methode retourneert een lijst met mogelijke algemene posities, zoals doelman, verdediger, middenvelder en aanvaller.',
        getPercentiles: 'Deze methode levert alle beschikbare percentielen op',
        getPlayerPercentilesEventing: 'Deze methode biedt alle statistieken voor een specifiek percentiel en een specifieke positie'
      },
      responseCodes: 'Response Codes',
      furtherInformation: 'Voor meer informatie, lees onze API documentatie',
      clipboard: 'Gekopieerd naar klembord!',
      limit50: 'Alleen de eerste 50 resultaten worden weergegeven'
    }
  },
  globalSearch: {
    subtitle: 'Diep Filteren'
  },
  global: {
    teamElos: {
      title: 'TEAM ELO\'S',
      subtitle: 'Wereldwijde teamranglijsten en inzichten',
      team: 'Team',
      teams: 'Teams',
      dates: 'Datums',
      excludeInternational: 'Internationale teams uitsluiten',
      elo: 'ELO',
      selectButton: 'Selecteer Boven',
      selectTeamFromTable: 'Selecteer een team van de tabel om de ELO trend weer te geven.',
      showingTeamAveragesLastSeason: 'Toont teamgemiddelden voor het laatste seizoen',
      showingTeamStatsLastSeason: 'Toont alleen teamstatistieken voor hun laatste actieve seizoen',
      searchToolTip: 'Tip: Druk op Ctrl + B voor directe toegang tot de zoekbalk',
      selectTopTooltip: 'Geef ter vergelijking extra teams in het diagram weer',
      loadingPage: 'De gegevens voorbereiden...'
    },
    leagueElos: {
      title: 'LEAGUE ELO\'S',
      subtitle: 'Wereldwijde competitie-ranglijsten en analyses',
      rankings: 'RANGLIJSTEN',
      insights: 'INZICHTEN',
      filters: 'FILTERS',
      leagues: 'Competities',
      from: 'Van',
      to: 'Tot',
      elo: 'ELO',
      change: 'Verschil',
      league: 'Competitie',
      excludeContinental: 'Internationale competities uitsluiten',
      eloTrend: 'ELO-trend',
      eloRanking: 'ELO-ranglijst',
      currentELOLabel: '(Huidige ELO)',
      allTime: 'Altijd',
      average: 'Gemiddelde',
      noChartData: 'Geen grafiekdata beschikbaar voor de geselecteerde filters.',
      selectLeagueFromTable: 'Selecteer een competitie van de tabel om de ELO trend weer te geven.',
      noInsightsData: 'Geen inzichten beschikbaar voor de geselecteerde competities. Zorg ervoor dat de competities actieve seizoenen en teaminzichten bevatten.',
      showingLeagueAveragesLastSeason: 'Toont enkel competitie-gemiddelden voor hun laatste actieve seizoen',
      selectTopTooltip: 'Geef ter vergelijking extra competities in de grafiek weer',
      confederations: {
        world: 'Wereld',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Aantal competities',
      minimumElo: 'Minimale ELO'
    },
    players: {
      title: 'GPI van de speler',
      subtitle: 'Ranglijsten en inzichten van mondiale spelers',
      gpiRanking: 'GPI-ranglijst',
      rankTooltip: 'Beweeg de muis om de mondiale ranglijst weer te geven',
      globalRanking: 'Mondiale ranglijst',
      player: 'Speler',
      players: 'Spelers',
      gpiTrend: 'GPI-trend',
      currentGPILabel: '(Huidige GPI)',
      nationality: 'Geboorteland',
      position: 'Positie',
      marketValue: 'Marktwaarde',
      apply: 'Toepassen',
      marketValueAndAgeTooltip: 'Voer een bereik in en klik op Toepassen of druk op Enter.',
      searchPlaceholder: 'Zoek een speler...',
      selectTopTooltip: 'Geef ter vergelijking extra spelers in de grafiek weer',
      gpi: 'GPI',
      numberOfPlayers: 'Aantal spelers',
      showingPlayerStatsLastSeason: 'Toont alleen de gemiddelde spelersstatistieken voor hun laatste actieve seizoen',
      date: 'DATUM',
      showChartLabels: 'Etiketten tonen',
      marketValueTooltip: 'Voer een bereik in en klik op Toepassen of druk op Enter.',
      freeAgents: 'Vrije agenten',
      selectPlayerFromTable: 'Selecteer een speler uit de tafel om de GPI-trend te bekijken.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Cote d\'Ivoire',
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'JapÃ³n',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europe',
    INT: 'International',
    CW: 'CuraÃ§ao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Spelers Voorbereiden',
    teams: 'Teams Sorteren',
    games: 'Wedstrijden Ophalen',
    stats: 'Metrieken Berekenen',
    graphs: 'Grafieken Tekenen',
    gettingReady: 'Opwarmen',
    placeholder: 'Maak je Klaar'
  },
  requestReport: {
    subtitle: 'Ontvang een diepgaand rapport met alles wat je nodig hebt',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle: 'Wie zijn de beste spelers van een bepaalde competitie? En uit meerdere competities samen? Vraag een maatwerkrapport aan met elke gewenste filter (leeftijd, lengte, einde contract, enz.) en ontdek welke spelers het beste passen'
      },
      coaches: {
        title: 'Coaches',
        subtitle: 'Hoe past een trainer in het systeem van jouw team? Krijg gedetailleerde informatie of, op basis van een profiel, kom te weten welke trainers het beste passen'
      },
      'team analysis': {
        title: 'Team',
        subtitle: 'Specificeer een team en ontvang de seizoenssamenvatting met waardevolle inzichten over stijl, defensieve en offensieve prestaties, zwakke punten, beste spelers, enz.'
      },
      'game analysis': {
        title: 'Game Analysis',
        subtitle: 'Voor een wedstrijd: ontvang een diepgaande pre- en post-wedstrijdanalyse met gedetailleerde informatie'
      },
      'special projects': {
        title: 'Special Projects',
        subtitle: 'Hoe presteert een speler in uitwedstrijden? Hoe veranderen spelers per competitie? Welke spelers zijn beschikbaar voor huur? Stel elke vraag die je kunt bedenken'
      },
      conversation: {
        title: 'Conversation',
        subtitle: 'Start een gesprek met ons team'
      }
    },
    notesPlaceholder: 'Laat ons de competitie, het profiel, de statistieken, de trainer, het team of de wedstrijd weten waarover je meer wilt weten',
    chooseType: 'Selecteer een rapporttype',
    requestSummary: 'Samenvatting Aanvraag',
    reportType: 'Rapporttype',
    reportLanguage: 'Rapporttaal',
    detailTitle: 'Opvolging van rapport',
    detailSubtitle: 'Alle informatie over het door jou aangevraagde rapport'
  },
  bugReport: {
    modalSubtitle: 'Help ons te verbeteren',
    about: 'Over',
    sendSuccess: 'Succesvol gemeld. Bekijk updates in de Inbox',
    bugs: 'Bugs'
  },
  gbe: {
    autopass: 'Auto Pass',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Continentale Competitie',
    points: 'Punten',
    titleWinner: 'Titelwinnaar',
    qualifiedGroupsBandX: 'Gekwalificeerd voor groepsfase van een Band {0} Continentale Competitie',
    qualifiedQualifiersBandX: 'Gekwalificeerd voor kwalificaties van een Band {0} Continentale Competitie',
    midTable: 'Middenmoot',
    relegation: 'Degradatie',
    promotion: 'Promotie',
    final: 'Finale',
    semifinal: 'Halve Finale',
    quarterfinal: 'Kwartfinale',
    round16: 'Achtste finales',
    round32: 'Zestiende finales',
    groupstage: 'Groepsfase',
    firstRound: '1e Ronde',
    secondRound: '2e Ronde',
    thirdRound: '3e Ronde',
    fourthRound: '4e Ronde',
    preliminaryRound: 'Voorronde',
    other: 'Overig',
    score: 'Score',
    totalSummary: 'Totaaloverzicht',
    currentlyPlayingInUK: 'De speler is burger van het Verenigd Koninkrijk of Ierland, of de speler is permanent ingezetene in het Verenigd Koninkrijk',
    bandsAlert: 'Er zijn minuten gespeeld in meer dan één band, totaal is de maximumwaarde',
    bandsAlertMax: 'Er zijn minuten gespeeld in meer dan één band, totaal is de maximumwaarde',
    bandsAlertAvg: 'Er zijn minuten gespeeld in meer dan één band, totaal is de gemiddelde waarde',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut for Youth Player',
    table1: {
      name: 'Interlands van de speler',
      title1: 'Geaggregeerde FIFA-wereldranglijst van de nationale bond van de speler',
      title2: 'Interlands van de speler'
    },
    table2: {
      name: 'Binnenlandse minuten van de speler',
      title1: 'Binnenlandse minuten van de speler'
    },
    table3: {
      name: 'Continentale minuten van de speler',
      title1: 'Continentale minuten van de speler'
    },
    table4: {
      name: 'Eindklassering van de laatste club van de speler',
      title1: 'Eindklassering van de laatste club'
    },
    table5: {
      name: 'Continentale progressie van de laatste club van de speler',
      title1: 'Continentale progressie'
    },
    table6: {
      name: 'Competitiekwaliteit van de huidige club van de speler',
      title1: 'Band van de huidige club van de speler'
    },
    table7: {
      name: 'Jeugd - Debuut',
      title1: 'Band'
    },
    table8: {
      name: 'Jeugd - Eindklassering',
      title1: 'Eindklassering laatste club'
    },
    table9: {
      name: 'Jeugd - Continentale progressie',
      title1: 'Continentale progressie'
    },
    table10: {
      name: 'Jeugd - Competitiekwaliteit huidige club',
      title1: 'Band van de huidige club van de speler'
    },
    table11: {
      name: 'Jeugd - Competitiekwaliteit huidige club',
      title1: 'Band van de huidige club van de speler'
    },
    table12: {
      name: 'Jeugd - Interlands',
      title1: 'Interlands van de speler'
    }
  },
  mediaMode: {
    borderColor: 'Randkleur',
    fillColor: 'Vulkleur',
    bgColor: 'Achtergrondkleur',
    upperText: 'Boventekst',
    lowerText: 'Ondertekst',
    socialMedia: 'Social Media',
    textColor: 'Tekstkleur',
    axisColor: 'Assenkleur',
    logo: 'Logo',
    comparisonBorderColor: 'Vergelijking Randkleur',
    comparisonFillColor: 'Vergelijking Vulkleur',
    comparisonUpperText: 'Vergelijking Boventekst',
    comparisonLowerText: 'Vergelijking Ondertekst',
    homeFillColor: 'Thuis Vulkleur',
    homeBorderColor: 'Thuis Randkleur',
    awayFillColor: 'Uit Vulkleur',
    awayBorderColor: 'Uit Randkleur',
    face: 'Gezicht',
    nationalTeam: 'Nationale Ploeg',
    comparisonFace: 'Vergelijking Gezicht',
    upperTextX: 'Boventekst {0}',
    lowerTextX: 'Ondertekst {0}',
    borderColorX: 'Randkleur {0}',
    fillColorX: 'Vulkleur {0}',
    homeFillColorX: 'Vulkleur (Thuis) {0}',
    homeBorderColorX: 'Randkleur (Thuis) {0}',
    awayFillColorX: 'Vulkleur (Uit) {0}',
    awayBorderColorX: 'Randkleur (Uit) {0}',
    faceX: 'Gezicht {0}',
    selectField: 'Selecteer een eigenschap',
    orientationX: 'Oriëntatie {0}',
    searchBarPlaceholder: 'Zoek Spelers en/of Wedstrijden...',
    title: 'Media Dashboard',
    pageSubtitle: 'Verken en download kaarten en grafieken',
    chooseChart: 'Kies grafiek...',
    headerTextX: 'Koptekst {0}',
    avatarLineLength: 'Avatar Lijnlengte',
    avatarLineWeight: 'Avatar Lijngewicht',
    avatarSize: 'Avatar Grootte',
    chartX: 'Grafiek {0}',
    chartHeaderFontSize: 'Grafiek Koptekst Lettergrootte',
    chartHeaderFontWeight: 'Grafiek Koptekst Letterdikte',
    upperTextFontSize: 'Boventekst Lettergrootte',
    upperTextFontWeight: 'Boventekst Letterdikte',
    lowerTextFontSize: 'Ondertekst Lettergrootte',
    lowerTextFontWeight: 'Ondertekst Letterdikte',
    socialMediaFontSize: 'Social Media Lettergrootte',
    socialMediaFontWeight: 'Social Media Letterdikte',
    subtitle: 'Subtitel',
    subtitleFontSize: 'Subtitel Lettergrootte',
    subtitleFontWeight: 'Subtitel Letterdikte',
    subtitleX: 'Subtitel {0}',
    subtitleFontSizeX: 'Subtitel ${0} Lettergrootte',
    subtitleFontWeightX: 'Subtitel ${0} Letterdikte',
    titleX: 'Titel {0}',
    titleFontSize: 'Titel Lettergrootte',
    titleFontWeight: 'Titel Letterdikte',
    sponsor: 'Sponsor',
    fontFamily: 'Lettertype'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Scoutingrapporten',
      GAME_REPORT: 'Wedstrijdrapporten',
      MEDICAL_REPORT: 'Medische rapporten',
      PHYSICAL_REPORT: 'Fysieke rapporten',
      PSYCHOLOGICAL_REPORT: 'Psychologische rapporten',
      OTHER: 'Overige',
      QUICK_NOTES: 'Korte notities',
      PLAYER_REPORT: 'Spelerrapporten',
      GENERAL_COMMENTS: 'Algemene opmerkingen',
      PLAYER_ANALYSIS: 'Speleranalyse'
    },
    uploadDocument: 'Upload Document',
    notesPlaceholder: 'Schrijf beschrijvende notities of opmerkingen met betrekking tot het document',
    notesPlaceholderAlt: 'Schrijf beschrijvende notities of opmerkingen met betrekking tot de speler',
    uploadedBy: 'Geüpload door',
    updatedBy: 'Bijgewerkt door',
    seeNotes: 'Bekijk notities',
    addNote: 'Notitie toevoegen',
    rating: 'Beoordeling',
    position: 'Beste positie',
    physical: 'Fysiek',
    onBall: 'Aan de bal',
    offBall: 'Zonder bal',
    mental: 'Mentaal',
    potential: 'Potentieel',
    conclusion: 'Conclusie',
    recommendation: {
      1: 'Contracteren',
      2: 'Monitoren',
      3: 'Afwijzen',
      4: 'Interessant',
      label: 'Aanbeveling'
    },
    match: 'Wedstrijd',
    deleteQuickNote: 'Notitie verwijderen',
    deleteQuickNoteMessage: 'De notitie wordt permanent verwijderd. Weet je het zeker?',
    noQuickNotes: 'Geen gegevens. Begin met enkele korte notities toe te voegen!',
    deleteDocument: 'Document verwijderen',
    deleteDocumentMessage: 'Het document wordt permanent verwijderd. Weet je het zeker?',
    noDocuments: 'Geen gegevens. Begin met enkele documenten toe te voegen!'
  },
  notifications: {
    newReportMessage: 'Er is een nieuw bericht in een rapport'
  },
  blog: {
    subtitle: 'Laatste artikelen, updates en nieuws',
    newEntry: 'Nieuwe Invoer',
    title: 'Titel',
    text: 'Tekst',
    link: 'Link',
    image: 'Afbeelding',
    author: 'Auteur',
    date: 'Publicatiedatum',
    deleteEntry: 'Invoer verwijderen',
    deleteEntryMessage: 'Weet je zeker dat je deze invoer wilt verwijderen?',
    readMore: 'Czytaj więcej'
  },
  positionsOrlegi: {
    GK: 'Doelman',
    DC: 'Verdediger',
    DR: 'Back',
    MC: 'Middenvelder',
    AMC: 'Aanvallende middenvelder',
    FW: 'Aanvaller',
    FWR: 'Vleugelspeler'
  },
  library: {
    subtitle: 'Bekijk en deel geüploade documenten',
    mediaSubtitle: 'Bekijk en deel geëxporteerde grafieken',
    charts: 'Grafieken',
    goToLibrary: 'Ga naar bibliotheek'
  },
  scatterPlot: {
    bubbleSize: 'Bubbelformaat',
    byMinutes: 'Op Minuten',
    byAge: 'Op Leeftijd',
    byMarketValue: 'Op Marktwaarde'
  },
  eventChart: {
    successfulEvent: 'Succesvol',
    unsuccessfulEvent: 'Mislukt',
    possessionLost: 'Succesvol, niet hersteld',
    successfulPass: 'Succesvolle pass',
    unsuccessfulPass: 'Onsuksesvolle pass',
    successfulCarry: 'Succesvolle dribble',
    unsuccessfulCarry: 'Onsuksesvolle dribble',
    carryAndKeyPass: 'Dribble & Key Pass',
    carryAndAssist: 'Dribble & Assist',
    carryAndShot: 'Dribble & Schot',
    ballProgressionAndPass: 'Balprog. & Pass',
    ballProgression: 'Balprogressie',
    ballProgressionAndKeyPass: 'Balprog. & Key Pass',
    ballProgressionAndAssist: 'Balprog. & Assist',
    ballProgressionAndShot: 'Balprog. & Schot',
    ballProgressionAndGoal: 'Balprog. & Doelpunt',
    pass: 'Pass',
    carryAndPass: 'Dribble & Pass',
    carryAndGoal: 'Dribble & Doelpunt',
    totalTouches: 'Totale balcontacten',
    totalPasses: 'Totaal Passes',
    successful: 'Succesvol',
    unsuccessful: 'Onsuksesvol',
    tacklePossessionLost: 'Succesvol - bezit verloren',
    gamesSelected: '{count} wedstrijden geselecteerd',
    allGamesOfSeason: 'Alle wedstrijden van het seizoen',
    allGamesOfSeasons: 'Alle wedstrijden van de seizoenen',
    allEvents: 'Alle gebeurtenissen',
    eventTypesCount: '{count} gebeurtenistypen',
    totalEvents: 'Totaal aantal evenementen',
    zoneDominanceNote: 'De aanrakingen die door elk team in elke zone worden getoond, vertegenwoordigen alleen succesvolle aanrakingen',
    selectedEvents: 'Geselecteerde evenementen'
  },
  event: {
    Pass: 'Pass',
    TakeOn: 'Dribble',
    Takeon: 'Dribble',
    Foul: 'Fout',
    Error: 'Fout',
    Tackle: 'Tackle',
    Interception: 'Interception',
    Clearance: 'Wegwerken',
    MissedShot: 'Misgeschoten',
    ShotOnPost: 'Schot op de paal',
    SavedShot: 'Geredd Schot',
    Goal: 'Doelpunt',
    Aerial: 'Luchtduel',
    BallRecovery: 'Balherovering',
    Dispossessed: 'Balverlies',
    ChanceMissed: 'Kans gemist',
    BallTouch: 'Balcontact',
    BlockedPass: 'Geblokkeerde pass',
    Challenge: 'Duel',
    lossPossession: 'Balverlies',
    OffsidePass: 'Buitenspelpas',
    groundDuelsLost: 'Grondduels verloren',
    'Ball touch': 'Balcontact',
    Smother: 'Smooren',
    'Keeper pickup': 'Keeper pakt op',
    'Good skill': 'Goede actie',
    Punch: 'Boksen',
    'Saved shot': 'Geredd Schot',
    'Shot on post': 'Schot op de paal',
    'Missed shot': 'Misgeschoten',
    Save: 'Redding',
    'Take on': 'Dribble',
    'Offside pass': 'Buitenspelpass',
    Claim: 'Vangbal',
    'Blocked pass': 'Geblokkeerde pass',
    KeeperPickup: 'Keeper ophalen',
    'Ball recovery': 'Balherovering',
    'Ball Recovery': 'Balherovering',
    'Chance missed': 'Kans gemist',
    'Loss possession': 'Balverlies',
    Carries: 'Balvoering',
    BallProgression: 'Balvoortgang',
    MissedChance: 'Gemiste kans',
    Event: 'Evenement',
    Shot: 'Schot',
    Assist: 'Assist',
    KeyPass: 'Sleutelpas',
    'Foul taken': 'Fout ontvangen'
  },
  leagueTab: {
    leagueTable: 'Ranglijst',
    matchdays: 'Speelrondes',
    playerInsights: 'Spelerinzichten',
    onlyLocalPlayers: 'Alleen lokale spelers',
    teamInsights: 'Teaminzichten',
    head2head: 'Head-to-Head',
    addNewChart: 'Nieuwe grafiek toevoegen',
    rounds: {
      16: 'Achtste finales',
      32: 'Zestiende finales',
      W: 'Winnaar',
      F: 'Finale',
      SF: 'Halve finales',
      QF: 'Kwartfinales',
      GR: 'Groepsfase',
      '4R': 'Vierde ronde',
      '3R': 'Derde ronde',
      '2R': 'Tweede ronde',
      '1R': 'Eerste ronde',
      PR: 'Voorronde',
      QPO1: 'Plaatsing Zestiende finales lagere laag',
      QPO2: 'Kwalificatie Achtste finales',
      QPO3: 'Kwalificatieronde van 32'
    },
    positions: 'Posities',
    prediction: 'Voorspellingen',
    predicted: 'Voorspelling',
    groups: 'Groepen',
    ranking: 'Ranglijst',
    numberOfTeams: 'Aantal teams',
    statsWithMinimum: {
      message: 'Toont alleen spelers met meer dan {0} {1} in het geselecteerde seizoen',
      dribblesTotal90: 'dribbles per 90 minuten',
      crosses90: 'voorzetten per 90 minuten',
      tacklesAttempted90: 'pogingen tot tackles per 90 minuten',
      aerialsTotal90: 'luchtduels per 90 minuten'
    },
    numberOfLeagues: 'Aantal competities',
    position: {
      titleWinner: 'Titel winnaar',
      championsLeague: 'Champions League',
      qualifierChampionsLeague: 'Kwalificatie Champions League',
      europeLeague: 'Europa Liga',
      qualifierEuropeLeague: 'Kwalificatie Europa League',
      conferenceLeague: 'Conferentie Liga',
      qualifierConferenceLeague: 'Kwalificatie Conference League',
      midTable: 'Midden op tafel',
      relegation: 'Degradatie',
      promotion: 'Bevordering',
      relegationPlayoff: 'Degradatie Play-off',
      promotionPlayoff: 'Promotie Play-off',
      championshipGroup: 'Kampioenschap groep',
      relegationGroup: 'Degradatie groep',
      championshipPlayoffs: 'Kampioenschap play-offs',
      preChampionshipPlayoffs2: 'Pre-kampioenschapsplay-offs 2',
      preChampionshipPlayoffs3: 'Pre-kampioenschapsplay-offs 3',
      playoffsQualifierBand3: 'Play-offs kwalificatieband 3',
      continentalGroup: 'Continentale Groep'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'I',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Vind vergelijkbare spelers',
    searchBarPlaceholder: 'Zoek en selecteer een speler om gelijkaardige te vinden',
    radarFilters: 'Radarbeelden filters',
    similarityFilters: 'Vergelijkbaarheidsfilters',
    playersFilters: 'Spelersfilters',
    similarPlayers: 'Vergelijkbare spelers',
    seasonWarning: 'Alleen beschikbare seizoenen in de Similarity-tool waarin de speler meer dan 450 minuten heeft gespeeld'
  },
  squadBuilder: {
    subtitle: 'Schets je unieke elf',
    playerSelector: 'Speler selector',
    loadSquad: 'Selectie laden',
    yearsOld: 'jr.',
    playersPerPosition: 'Spelers per positie',
    custom: 'Aangepast',
    removeSquad: 'Selectie verwijderen',
    removeSquadMessage: 'Weet je zeker dat je de selectie wilt verwijderen?',
    deleteSquadSuccess: 'Selectie is succesvol verwijderd',
    playerDetails: 'Zichtbaarheid spelerdetails',
    ageFormat: 'Leeftijdsformaat',
    mainPlayer: 'Hoofdspeler',
    showDetails: 'Details tonen',
    all: 'Alle',
    squadPosition: 'Selectiepositie',
    noData: 'Geen gegevens. Begin met spelers op het veld toe te voegen!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Niet opnieuw tonen',
      skipTour: 'Rondleiding overslaan',
      previous: 'Vorige',
      next: 'Volgende',
      finish: 'Voltooien'
    },
    playerRadar: {
      step1: {
        title: 'PERSOONLIJK DOSSIER',
        message: 'Bekijk basisgegevens van de speler: leeftijd, lengte of contractdatum'
      },
      step2: {
        title: 'GBE FILTER',
        message: 'Functionaliteit om te weten of een speler genoeg GBE-punten heeft om in het VK te spelen'
      },
      step3: {
        title: 'BESCHIKBAARHEID',
        message: 'Percentage beschikbare minuten en percentage gespeelde minuten'
      },
      step4: {
        title: 'POSITIES',
        message: 'Ontdek op welke posities de speler heeft gespeeld en hoeveel minuten per positie'
      },
      step5: {
        title: 'WEERGAVEFORMATEN',
        message: 'Meet prestaties met 4 visualisaties: Radar, Polair, Lollipop en Tekst, en vergelijk met spelers op zijn positie'
      },
      step6: {
        title: 'PRESTATIERADAR',
        message: 'Hier wordt de prestatie visueel weergegeven. Het paneel is interactief: hover voor definities'
      },
      step7: {
        title: 'SEIZOENSSELECTIE',
        message: 'Selecteer of voeg seizoenen toe om de prestaties te meten'
      },
      step8: {
        title: 'AANGEPASTE TEMPLATESELECTIE',
        message: 'Gebruik je aangepaste templates om met andere metrieken dan de standaard radar te meten'
      },
      step9: {
        title: 'GESELECTEERDE POSITIES',
        message: 'Vink posities aan/uit om hem te meten in de positie die je wilt'
      },
      step10: {
        title: 'SELECTIE MINIMA EN MAXIMA',
        message: 'Meet met highs en lows van zijn seizoen, top-5 competities of het standaard seizoen van de gebruiker'
      },
      step11: {
        title: 'VERGELIJKINGEN',
        message: 'Vergelijk met zijn vorige prestaties, spelers op zijn positie en het gemiddelde van de positie'
      },
      step12: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SEIZOEN, SELECTIE EN POSITIE',
        message: 'Selecteer seizoen, selectie en positie om de speler mee te vergelijken'
      },
      step2: {
        title: 'BASISFILTERS',
        message: 'Filter spelers op leeftijd, gespeelde minuten of lengte'
      },
      step3: {
        title: 'MARKEREN EN UITSLLUITEN',
        message: 'Markeer gewenste spelers en sluit teams uit in de weergave'
      },
      step4: {
        title: 'FILTER OP CATEGORIE',
        message: 'Filter statistieken per categorie: Associatie, Verdedigen, Passen, Balbehandeling, enz.'
      },
      step5: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'WEERGAVE KIEZEN',
        message: 'Bekijk de afwerkingskaart in hoofdweergave, doelweergave of als tabel'
      },
      step2: {
        title: 'SEIZOENEN KIEZEN',
        message: 'Voeg seizoenen toe om je schotefficiëntie te meten'
      },
      step3: {
        title: 'SCHOTLOCATIE',
        message: 'Kies exacte locatie (cirkels) of per zones van zestien en veld (zones)'
      },
      step4: {
        title: 'xG OP DOEL',
        message: 'Vink xG to Goal en xG Completion aan om extra waarde na het schot te zien'
      },
      step5: {
        title: 'SCHOTTYPE',
        message: 'Filter op schottype, strategie, zone of lichaamsdeel'
      },
      step6: {
        title: 'MINUTENFILTER',
        message: 'Balk om schoten en goals per wedstrijdperiode te selecteren'
      },
      step7: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step8: {
        title: 'SCHOTKAART',
        message: 'Interactieve kaart. Hover elke cirkel om xG per schot te zien'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SEIZOENSSELECTIE',
        message: 'Voeg seizoenen toe om je schotefficiëntie te meten'
      },
      step2: {
        title: 'LOCATIE KEY PASS',
        message: 'Kies exacte locatie (cirkel) of per zones van zestien en veld (zones)'
      },
      step3: {
        title: 'AFWERKING NA KEY PASS',
        message: 'Filter op type schot, strategie, zone of lichaamsdeel na key pass'
      },
      step4: {
        title: 'MINUTENFILTER',
        message: 'Balk om schoten en goals per wedstrijdperiode te selecteren'
      },
      step5: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step6: {
        title: 'KEY PASS KAART',
        message: 'Interactieve kaart. Hover elke cirkel om xA per pass te zien'
      }
    },
    playerThreat: {
      step1: {
        title: 'SEIZOENSSELECTIE',
        message: 'Voeg seizoenen toe om je schotefficiëntie te meten'
      },
      step2: {
        title: 'BEDREIGING LOCATIE',
        message: 'Kies exacte locatie (cirkel) of per zones van zestien en veld (zones)'
      },
      step3: {
        title: 'ACTIE EN AFMAKING',
        message: 'Vink aan/uit op basis van actietype en afmaking die je wilt tonen'
      },
      step4: {
        title: 'MINUTEN EN BEDREIGING',
        message: 'Filter per periode, minuten en bedreigingswaarde van de acties'
      },
      step5: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step6: {
        title: 'BEDREIGINGSKAART',
        message: 'Interactieve kaart. Hover elke cirkel om de bedreiging per xT-actie per pass te zien'
      }
    },
    playerTouches: {
      step1: {
        title: 'WEDSTRIJD EN EVENTSELECTIE',
        message: 'Selecteer de wedstrijd en events die je op de kaart wilt tonen'
      },
      step2: {
        title: 'EVENTTYPE',
        message: 'Vink aan/uit volgens defensieve of offensieve aard van het event gedurende de wedstrijd'
      },
      step3: {
        title: 'WEERGAVEFILTER',
        message: 'Filter kaart op basisacties, heatmap, cirkels of vlakken'
      },
      step4: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step5: {
        title: 'BALCONTACTEN KAART',
        message: 'Interactieve kaart. Bekijk elk event door erop te klikken'
      }
    },
    playerAllGames: {
      step1: {
        title: 'BESCHIKBAARHEID',
        message: 'Bekijk beschikbaarheid en gespeelde minuten per wedstrijd'
      },
      step2: {
        title: 'POSITIES',
        message: 'Bekijk de posities waarin hij in elke wedstrijd heeft gespeeld'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORIE EN DAGEN VERLOREN',
        message: 'Bekijk blessures van het laatste jaar of volledige historie en duur per blessure in dagen'
      },
      step2: {
        title: 'BLESSURES PER CLUB',
        message: 'Bekijk blessures uitgesplitst per seizoen en/of club in zijn loopbaan'
      }
    },
    playerInfo: {
      step1: {
        title: 'CARRIÈRE EN TRANSFERS',
        message: 'Bekijk minuten, positie of beschikbaarheid bij club en nationale ploeg en transfers doorheen zijn carrière'
      }
    },
    teamOverview: {
      step1: {
        title: 'TEAMBLAD',
        message: 'Bekijk basisgegevens: gemiddelde leeftijd, basisformatie, ELO of transferbalans'
      },
      step2: {
        title: 'BASISSTATISTIEKEN',
        message: 'Bekijk balbezit, xG, schoten, PPDA of verticaliteit'
      },
      step3: {
        title: 'RADAR EN SEIZOEN',
        message: 'Selecteer radar, seizoen en thuis/uit om prestaties te meten'
      },
      step4: {
        title: 'FILTER OP TRAINER EN WEDSTRIJDEN',
        message: 'Selecteer prestaties per fase voor elke trainer'
      },
      step5: {
        title: 'PRESTATIERADAR',
        message: 'Interactief paneel: hover over elke metriek voor de definitie'
      },
      step6: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Twee downloadformaten beschikbaar: png en svg'
      },
      step7: {
        title: 'KALENDER',
        message: 'Bekijk het wedstrijdschema van het team'
      },
      step8: {
        title: 'BESTE SPELERS PER METRIEK',
        message: 'Selecteer metrieken en zie welke spelers het belangrijkst zijn'
      },
      step9: {
        title: 'VOLGENDE MATCH EN BLESSURES',
        message: 'Bekijk de volgende tegenstander en geblesseerde/geschorste spelers'
      },
      step10: {
        title: 'GRAFIEKEN EN TRENDS',
        message: 'Bekijk verschillende grafieken voor de laatste 10 of 20 wedstrijden'
      }
    },
    teamRoster: {
      step1: {
        title: 'WEERGAVETYPE',
        message: 'Bekijk de selectie vanuit 6 categorieën: positie, einde contract, leeftijd, beschikbaarheid, leeftijdsprofiel en veld'
      }
    },
    teamLoans: {
      step1: {
        title: 'GEHUURDE SPELERS',
        message: 'Bekijk spelers die verhuurd zijn en op welke positie ze spelen'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SEIZOEN EN SELECTIE',
        message: 'Filter op seizoen, radarselectie en vergelijk met competities naar keuze'
      },
      step2: {
        title: 'PRESTATIES PER METRIEK',
        message: 'Zie waar het team staat per metriek t.o.v. teams in geselecteerde competities'
      },
      step3: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SEIZOENSSELECTIE',
        message: 'Voeg seizoenen toe om schotefficiëntie te meten'
      },
      step2: {
        title: 'EIGEN OF TEGENSTANDER AFWERKING',
        message: 'Kies of je de afwerkingskaart van het team of van alle tegenstanders ziet'
      },
      step3: {
        title: 'SCHOTPLAATSING',
        message: 'Kies weergave van schoten: cirkels of zones (vlakken)'
      },
      step4: {
        title: 'SCHOTTYPE',
        message: 'Filter op schottype, strategie, zone of lichaamsdeel'
      },
      step5: {
        title: 'MINUTENFILTER',
        message: 'Balk om schoten en goals per wedstrijdperiode te selecteren'
      },
      step6: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step7: {
        title: 'SCHOTKAART',
        message: 'Interactieve kaart. Hover elke cirkel voor xG per schot'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SEIZOENSSELECTIE',
        message: 'Voeg seizoenen toe om schotefficiëntie te meten'
      },
      step2: {
        title: 'EIGEN OF TEGENSTANDER KEY PASSES',
        message: 'Kies of je de kaart van key passes van het team of alle tegenstanders ziet'
      },
      step3: {
        title: 'LOCATIE KEY PASS',
        message: 'Kies exacte locatie (cirkel) of per zone/veld (vlakken)'
      },
      step4: {
        title: 'AFWERKING NA PASS',
        message: 'Filter op type schot, strategie, zone of lichaamsdeel na key pass'
      },
      step5: {
        title: 'MINUTENFILTER',
        message: 'Balk om schoten en goals per wedstrijdperiode te selecteren'
      },
      step6: {
        title: 'AFBEELDING DOWNLOADFORMATEN',
        message: 'Drie downloadformaten beschikbaar: png, svg en embed'
      },
      step7: {
        title: 'SCHOTKAART',
        message: 'Interactieve kaart. Hover elke cirkel om xA per pass te zien'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'LAATSTE WEDSTRIJDEN',
        message: 'Bekijk resultaten, balbezit, xG en winst% van alle wedstrijden'
      }
    },
    teamTransfers: {
      step1: {
        title: 'AANKOMSTEN',
        message: 'Bekijk alle aankomsten (aankopen + transfers) per kalenderjaar'
      },
      step2: {
        title: 'VERTREKKEN',
        message: 'Bekijk alle vertrekken (verkopen + transfers) per kalenderjaar'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDS',
        message: 'Bekijk teamvorm via reeksen, zeges, clean sheets, comebacks, doelpuntperiodes of doelpunttypes'
      },
      step2: {
        title: 'VASTE SITUATIE',
        message: 'Vergelijk prestaties tussen spelhervattingen en open spel en krijg een overzicht van spelhervattingen'
      },
      step3: {
        title: 'WISSELS',
        message: 'Zie wanneer er gewisseld wordt en welke spelers het meest gewisseld worden'
      },
      step4: {
        title: 'VERBINDINGEN',
        message: 'Bekijk de meest voorkomende verbindingen tussen spelers. Filter op seizoen en type spel'
      },
      step5: {
        title: 'AANVALSZONES',
        message: 'Ontdek aanvalszones van het team en filter op seizoen of type aanval'
      },
      step6: {
        title: 'FORMATIES',
        message: 'Bekijk de meest gebruikte formaties en hun % zeges, gelijke spelen en nederlagen'
      },
      step7: {
        title: 'SCHOTZONES',
        message: 'Filter op seizoen, team of tegenstander, kaartweergave, schottypes of minuten'
      },
      step8: {
        title: 'VOORZETTEN',
        message: 'Filter op seizoen, weergavetype, succesvol/onsuccesvol, start- en eindpunt of incl. corners'
      },
      step9: {
        title: 'SPELERS',
        message: 'Filter op seizoen, weergavetype, succesvol/onsuccesvol, start- en eindpunt of incl. corners'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SEIZOENEN EN WEDSTRIJDEN',
        message: 'Filter op seizoen, wedstrijden of thuis/uit'
      },
      step2: {
        title: 'SPELERS',
        message: 'Bekijk prestaties van alle spelers via talloze metrieken'
      }
    }
  },
  alerts: {
    numPlayers: 'Aantal spelers',
    newPlayersLastWeek: 'Nieuwe spelers afgelopen week',
    subtitle: 'Ontvang alerts wanneer nieuwe spelers aan je zoekcriteria voldoen',
    generalSubtitle: 'Ontvang alerts over nieuwe spelers op basis van je criteria en nieuws over je favoriete spelers',
    subtitlePlayer: 'Ontvang alerts wanneer we nieuws hebben over je favoriete spelers',
    subtitleSearch: 'Ontvang alerts wanneer nieuwe spelers aan je zoekcriteria voldoen',
    favorite: 'Favoriet',
    newEventCalendar: 'Nieuw event',
    updatedEventCalendar: 'Bijgewerkt event',
    newShareFrom: 'Nieuwe share van',
    injuryAlert: 'Blessure-alert',
    contractAlert: 'Contract-alert',
    teamAlert: 'Aankoop-alert',
    marketValueAlert: 'Marktwaarde-alert',
    gameAlert: 'Gespeelde wedstrijd-alert'
  },
  videoEvents: {
    highlights: 'Highlights',
    fullGame: 'Volledige wedstrijd',
    autoplay: 'Autoplay',
    searchBarPlaceholder: 'Zoek speler, wedstrijd of team...',
    subtitle: 'Analyseer events via video',
    successful: 'Succesvol',
    unsuccessful: 'Onsuksesvol',
    playing: 'Afspelen',
    games: 'Wedstrijden',
    moreFilters: 'Meer filters...',
    startArea: 'Startzone',
    endArea: 'Eindzone',
    select: 'Selecteer',
    selectLastXGames: 'Selecteer laatste {0} wedstrijden',
    advancedFilters: 'Geavanceerde filters',
    freeKicks: 'Vrije trappen',
    cornerKicks: 'Hoekschoppen',
    allShots: 'Alle schoten',
    generateZip: 'Video\'s downloaden',
    zippedModalMessage: 'We maken nu je videolijst en sturen die spoedig per e-mail',
    clickToSeeVideo: 'Klik om video te bekijken'
  },
  videoUpload: {
    subtitle: 'Upload video en maak een nieuwe wedstrijd',
    uploadVideo: 'Upload video',
    selectPeriod: 'Selecteer periode',
    gameData: 'Wedstrijdgegevens',
    venue: 'Locatie',
    matchType: 'Wedstrijdtype',
    matchGroup: 'Wedstrijdgroep',
    roundType: 'Rondetype',
    roundNumber: 'Rondenummer',
    offsetFh: 'Offset eerste helft',
    offsetSh: 'Offset tweede helft',
    offsetFhOT: 'Offset verlenging eerste helft',
    offsetShOT: 'Offset verlenging tweede helft',
    homeLineup: 'Basiselftal thuis',
    awayLineup: 'Basiselftal uit',
    existingPlayer: 'Bestaande speler',
    newPlayer: 'Nieuwe speler',
    startingTeam: 'Basis',
    saveAndUpload: 'Opslaan en uploaden',
    existingGame: 'Wedstrijd bestaat al',
    sendToKora: 'Versturen',
    invalidForm: 'Ongeldig formulier',
    warningModalTitle: 'Er zijn anomalieën gedetecteerd',
    noScoreSheetWarning: 'Geen scoresheet toegevoegd',
    onlyOnePartUploadedWarning: 'Slechts één helft toegevoegd',
    continueQuestion: 'Doorgaan?',
    slaLimit: 'Je hebt {0} wedstrijden geüpload met {1}. Je limiet is {2}',
    requestedGames: 'Aangevraagde wedstrijden',
    limitClose: 'Nog slechts {0} wedstrijden aan te vragen',
    limitReached: 'Je hebt je videouploadlimiet bereikt. Extra uploads kunnen extra kosten met zich meebrengen.',
    seasonFinishedWarning: 'Dit maakt een wedstrijd aan in een seizoen dat al is afgelopen. Controleer of dit klopt.',
    teamCountryWarning: 'Dit team komt uit een ander land dan de gekozen competitie. Controleer of dit klopt.',
    uploading: 'Uploaden',
    doNotNavigateAway: 'Sluit dit tabblad niet, vernieuw de pagina niet en navigeer niet weg terwijl het uploaden bezig is.',
    severalMinutes: 'Dit proces kan enkele minuten duren.'
  },
  videoPlaylists: {
    subtitle: 'Collecties van videohighlights-filters',
    savePlaylist: 'Playlist opslaan',
    seeAllPlaylists: 'Bekijk alle playlists'
  },
  videoHighlights: {
    recap: 'Samenvatting',
    homeCondensed: 'Thuis Samengevatte Wedstrijd',
    awayCondensed: 'Uit Samengevatte Wedstrijd',
    selectedActions: 'Geselecteerde acties',
    noActions: 'Geen acties die voldoen aan de filtercriteria',
    noGames: 'Nog geen wedstrijden geüpload',
    attackingActions: 'Aanvallende Acties',
    defensiveActions: 'Defensieve Acties',
    groundDuels: 'Grondduels',
    penaltiesProvoked: 'Uitgelokte Penalties',
    goalkeeperActions: 'Keeperacties',
    addSomeGames: 'Begin met het toevoegen van wedstrijden!',
    goToVideoUploadTool: 'Ga naar Video Upload Tool',
    ballInPlay: 'Bal in spel',
    filterSeasons: 'Filter Seizoenen',
    streaming: 'Streaming',
    clips: 'Clips',
    qualifiers: {
      Pass: 'Pass',
      Save: 'Redding',
      'Saved Shot': 'Gered Schot',
      Shot: 'Schot',
      Goal: 'Doelpunt',
      'Missed Shot': 'Gemist Schot',
      'Shot on Post': 'Schot op Paal',
      Error: 'Fout',
      Clearance: 'Vrijschop',
      Aerial: 'Luchtduel',
      Challenge: 'Grondduel Verloren',
      Dispossessed: 'Balverlies',
      Foul: 'Overtreding',
      Card: 'Kaart',
      'Offside Pass': 'Buitenspelpass',
      Claim: 'Voorzet Geclaimd',
      'Keeper Pickup': 'Keeper Oppakken',
      'Ball Touch': 'Balaanraking',
      Dribble: 'Dribbel',
      Interception: 'Onderschepping',
      Tackle: 'Tackle',
      'Ball Recovery': 'Bal Herwinnen',
      Takeon: 'Dribbel'
    },
    qualifierIds: {
      1: 'Lange bal',
      2: 'Voorzet',
      5: 'Vrije trap genomen',
      6: 'Hoekschop genomen',
      9: 'Penalty',
      15: 'Hoofd',
      20: 'Rechtsvoetig',
      21: 'Ander lichaamsdeel',
      22: 'Normaal spel',
      23: 'Snelle tegenaanval',
      24: 'Spelhervatting',
      25: 'Van hoekschop',
      26: 'Vrije trap',
      28: 'Eigen doelpunt',
      29: 'Geassisteerd',
      31: 'Gele kaart',
      32: 'Tweede gele kaart',
      33: 'Rode kaart',
      72: 'Linksvoetig',
      73: 'Links',
      82: 'Gered schot (geen GK)',
      94: 'Defensieve blokkering',
      123: 'Keeper uitgooi',
      124: 'Doelschop',
      160: 'Inworp spelhervatting',
      170: 'Leidend tot doelpunt',
      173: 'Veilig weggewerkt',
      174: 'Gevaarlijk weggewerkt',
      177: 'Opgevangen',
      178: 'Staand',
      179: 'Duikend',
      182: 'Handen',
      183: 'Voeten',
      185: 'Geblokkeerde voorzet',
      210: 'Assist',
      215: 'Individueel spel',
      279: 'Aftrap',
      285: 'Defensief',
      286: 'Offensief'
    },
    areas: {
      goalArea: 'Doelgebied',
      boxLeft: 'Zestien Links',
      boxCenter: 'Zestien Midden',
      boxRight: 'Zestien Rechts',
      outBoxDeepLeft: 'Buiten Zestien Diep Links',
      outBoxDeepRight: 'Buiten Zestien Diep Rechts',
      outBoxLeft: 'Buiten Zestien Links',
      outBoxCentreLeft: 'Buiten Zestien Midden Links',
      outBoxCentre: 'Buiten Zestien Midden',
      outBoxCentreRight: 'Buiten Zestien Midden Rechts',
      outBoxRight: 'Buiten Zestien Rechts',
      midfieldLeft35: 'Middenveld Links',
      midfieldCentreLeft35: 'Middenveld Midden Links',
      midfieldCentre35: 'Middenveld Midden',
      midfieldCentreRight35: 'Middenveld Midden Rechts',
      midfieldRight35: 'Middenveld Rechts',
      ownGoalArea: 'Eigen Doelgebied',
      ownBoxLeft: 'Eigen Zestien Links',
      ownBoxCenter: 'Eigen Zestien Midden',
      ownBoxRight: 'Eigen Zestien Rechts',
      ownFieldOutOfBoxDeepLeft: 'Eigen Veld Buiten Zestien Diep Links',
      ownFieldOutOfBoxDeepRight: 'Eigen Veld Buiten Zestien Diep Rechts',
      ownFieldOutOfBoxLeft: 'Eigen Veld Buiten Zestien Links',
      ownFieldOutOfBoxCentreLeft: 'Eigen Veld Buiten Zestien Midden Links',
      ownFieldOutOfBoxCentre: 'Eigen Veld Buiten Zestien Midden',
      ownFieldOutOfBoxCentreRight: 'Eigen Veld Buiten Zestien Midden Rechts',
      ownFieldOutOfBoxRight: 'Eigen Veld Buiten Zestien Rechts',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Succes',
      fail: 'Mislukt',
      possessionWon: 'Balbezit Gewonnen',
      possessionNotWon: 'Balbezit Niet Gewonnen',
      received: 'Ontvangen',
      provoked: 'Uitgelokt'
    },
    homePlayerHighlights: 'Hoogtepunten van de thuisspeler',
    awayPlayerHighlights: 'Hoogtepunten uitspelers'
  },
  share: {
    shareTo: 'Verstuur naar',
    viaApp: 'App (Driblab Bericht)',
    viaEmail: 'E-mail',
    description: 'Beschrijving',
    titleTab: 'Shares',
    toMe: 'Ontvangen',
    fromMe: 'Verzonden',
    typeInternal: 'Intern',
    typeExternal: 'Extern',
    title: 'Gedeeld',
    subtitle: 'Overzicht van items in je sharelijst en je shares',
    selectUser: 'Selecteer gebruiker',
    expired: 'Verlopen',
    limitReached: 'Link heeft gebruikslimiet bereikt'
  },
  homeStats: {
    data: 'Beschikbare Gegevens',
    players: 'spelers',
    totalPlayers: 'totaal spelers',
    teams: 'teams',
    totalTeams: 'totaal teams',
    leagues: 'competities',
    totalLeagues: 'totaal competities',
    seasons: 'seizoenen',
    totalSeasons: 'totaal seizoenen',
    games: 'wedstrijden',
    totalGames: 'totaal wedstrijden'
  },
  scoutingCalendar: {
    subtitle: 'Maak en organiseer je scoutings taken',
    myCalendars: 'Privé kalender',
    publicCalendars: 'Openbare kalenders',
    otherCalendars: 'Andere kalenders',
    calendarSettings: 'Kalender instellingen',
    moreInfo: 'Meer info',
    individualScouting: 'Individueel Scouten',
    matchScouting: 'Wedstrijd Scouten',
    calendarView: {
      type: 'Kalendertype',
      month: 'Maand',
      week: 'Week',
      day: 'Dag'
    },
    weekView: {
      type: 'Weektype',
      monSun: 'Maandag - Zondag',
      sunSat: 'Zondag - Zaterdag',
      monFri: 'Maandag - Vrijdag'
    },
    tasks: {
      addNew: 'Nieuwe taak toevoegen',
      myTasks: 'Mijn taken',
      filterTasks: 'Filter taken',
      sharedWithMe: 'Met mij gedeeld',
      createTask: 'Taak aanmaken',
      newTask: 'Nieuwe taak',
      taskName: 'Taaknaam',
      allDay: 'Hele dag',
      startDate: 'Startdatum',
      endDate: 'Einddatum',
      startHour: 'Starthour',
      endHour: 'Eindhour',
      assignedTo: 'Toegewezen aan',
      assignedToMe: 'Aan mij toegewezen',
      color: 'Kleur',
      scoutingType: 'Scoutingtype',
      taskLocation: 'Taaklocatie',
      selectLeague: 'Selecteer competitie',
      selectMatch: 'Selecteer wedstrijd',
      useMatchdate: 'Gebruik wedstrijddatum als datum',
      stadium: 'Stadion',
      travel: 'Reizen',
      hotel: 'Hotel',
      tickets: 'Tickets',
      taskNotes: 'Typ beschrijvende notities of opmerkingen gerelateerd aan de taak',
      states: {
        toDo: 'Te doen',
        inProgress: 'Bezig',
        done: 'Klaar'
      },
      type: {
        player: 'Speler Beoordeling',
        team: 'Team Beoordeling',
        other: 'Anders'
      },
      location: {
        stadium: 'In stadion',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Accommodatie Details',
        ownArrangement: 'Eigen Regeling',
        required: 'Vereist',
        notRequired: 'Niet vereist',
        booked: 'Geboekt'
      },
      assignToMe: 'Toewijzen aan mij',
      addOther: 'Andere toevoegen',
      deleteTask: 'Taak verwijderen',
      deleteTaskMessage: 'Taak wordt verwijderd, weet je het zeker?',
      cancelUpdate: 'Update annuleren',
      cancelUpdateMessage: 'Wijzigingen worden niet opgeslagen, weet je het zeker?',
      selectGame: 'Selecteer een wedstrijd om bestanden toe te voegen',
      noData: 'Geen gegevens. Begin met taken toe te voegen!',
      widgetSubtitle: 'Bekijk je volgende taken',
      scoutingDetails: 'Scouting details',
      taskDetails: 'Taak details',
      playerDocuments: 'Speler documenten',
      teamDocuments: 'Team documenten',
      gameDocuments: 'Wedstrijd documenten',
      taskDocuments: 'Taak documenten',
      task: 'Taak'
    },
    nextGames: 'Volgende wedstrijden'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Deze week',
      month: 'Deze maand',
      year: 'Dit jaar'
    },
    noTasks: 'Maak nieuwe taken aan of sleep er een hierheen!',
    goToBoard: 'Ga naar bord'
  },
  profile: {
    title: 'Profiel',
    subtitle: 'Pas je account en abonnementsdetails aan'
  },
  hub: {
    onlyHub: 'Alleen beschikbaar in Driblab Hub',
    blue: 'blauw',
    purple: 'paars',
    orange: 'oranje',
    grey: 'grijs',
    indigo: 'indigo',
    teal: 'wintertaling',
    lightBlue: 'lichtblauw',
    brown: 'bruin'
  },
  uploadedGames: {
    subtitle: 'Alle geüploade wedstrijden',
    timeRequested: 'Tijd waarop het werd aangevraagd',
    timeReceived: 'Wanneer het werd ontvangen',
    diffHours: 'Verschil in uren',
    collectionCompleted: 'Collectie voltooid',
    dateFrom: 'Datum vanaf',
    dateTo: 'Datum tot',
    goToUploadedGames: 'Ga naar Geüploade Wedstrijden',
    sla: 'Server Level Agreement',
    matchDate: 'Wedstrijddatum',
    rejectedGame: 'Afgewezen',
    reviewed: 'Beoordeeld',
    requested: 'Gevraagd',
    koraStatus: 'Kora-status',
    aws: 'AWS',
    fullVideo: 'Volledige video',
    offset: 'Offset',
    updateFullVideo: 'Volledige video updaten?'
  },
  gameMap: {
    title: 'Kaart van Wedstrijden',
    subtitle: 'Verken de wedstrijden voor de komende dagen',
    warning: 'De tijd en plaats zijn mogelijk niet correct. Bevestig deze informatie.',
    taskAdded: 'Taak succesvol aangemaakt. Controleer de Scouting Kalender.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Succesvol gemeld',
    notPermissions: 'Je hebt geen toestemming om te bekijken',
    notPermissionsLeague: 'Je hebt geen toestemming om deze competitie te bekijken',
    notPermissionsGame: 'Je hebt geen toestemming om deze wedstrijd te bekijken',
    requestAccessTo: 'Toegang aanvragen voor',
    sendRequest: 'Verzoek Verzenden'
  },
  videoTeams: {
    subtitle: 'Vind de laatste wedstrijden getagd per team',
    noGamesUploaded: 'Nog geen wedstrijden geüpload'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scouting Analyse',
    scoutingAnalyses: 'Scouting Analyses',
    playerScoutingAnalyses: 'Speler Scouting Analyses',
    gameScoutingAnalyses: 'Wedstrijd Scouting Analyses',
    analyses: 'Analyses',
    addReport: 'Analyse toevoegen',
    technical: 'Technisch',
    tactical: 'Tactisch',
    physical: 'Fysiek',
    mental: 'Mentaal',
    technicalNotes: 'Technische notities',
    tacticalNotes: 'Tactische notities',
    physicalNotes: 'Fysieke notities',
    mentalNotes: 'Mentale notities',
    conclusion: 'Conclusie',
    charactersMax: 'Max 1000 karakters',
    globalRating: 'Globale beoordeling',
    noData: 'Geen gegevens. Begin met scouting analyses toe te voegen!',
    deleteAnalysis: 'Scouting Analyse Verwijderen',
    deleteAnalysisMessage: 'De analyse wordt permanent verwijderd. Weet je het zeker?',
    avgTooltip: 'Gemiddelde gebaseerd op eindbeoordelingen van analyses zichtbaar voor jou',
    avgOverallScoreTooltip: 'Gemiddelde gebaseerd op overall scores van de speler zichtbaar voor jou',
    scouter: 'Scout',
    lastEdited: 'Laatst bewerkt',
    analysisFilters: 'Analyse Filters',
    generalFilters: 'Algemene Filters',
    widgetSubtitle: 'Laatste toegevoegde analyses',
    addPlayerReport: 'Speler Scouting Analyse Toevoegen',
    seeReports: 'Bekijk rapporten',
    addGameReport: 'Wedstrijd Scouting Analyse Toevoegen',
    keyPlayers: 'Sleutelspelers',
    formation: 'Formatie',
    inPossession: 'In Balbezit',
    notesIP: 'In Balbezit notities',
    outOfPossession: 'Zonder Balbezit',
    notesOP: 'Zonder Balbezit notities',
    transitions: 'Transities',
    notesTransitions: 'Transitie notities',
    notesSP: 'Spelhervatting notities',
    finalRating: 'Eindbeoordeling',
    gameNotesPlaceholder: 'Typ beschrijvende notities of opmerkingen gerelateerd aan de wedstrijd',
    avgPotentialTooltip: 'Gemiddelde op basis van het potentieel aan voor u zichtbare analyses',
    potential: 'Potentieel',
    tags: 'Labels',
    tagsPlaceholder: 'Voeg enkele tags toe',
    tagsHint: 'Typ en druk op Enter om een ​​tag toe te voegen',
    exampleTags: {
      leadership: 'Leiderschap',
      resilience: 'Weerstand',
      competitiveMindset: 'Competitieve mentaliteit',
      calmUnderPressure: 'Rust onder druk',
      focus: 'Focus',
      discipline: 'Discipline',
      coachability: 'Coachbaarheid',
      poorBodyLanguage: 'Slechte lichaamstaal',
      lowConfidence: 'Weinig vertrouwen',
      easilyFrustrated: 'Gemakkelijk gefrustreerd'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Het aanmaken van een team zonder competitie kan een negatief effect hebben op de indexering en latere zoekfunctie binnen de applicatie.'
  },
  expenses: {
    expense: 'Uitgave',
    expenses: 'Uitgaven',
    addExpense: 'Uitgave toevoegen',
    transportation: 'Transport',
    accommodation: 'Accommodatie',
    dietary: 'Voeding',
    eventTicket: 'Evenement ticket',
    expenseType: 'Uitgavetype',
    amount: 'Bedrag',
    expenseDate: 'Uitgavedatum',
    expenseFilters: 'Uitgave filters',
    noData: 'Geen gegevens. Begin met uitgaven toe te voegen!',
    deleteExpense: 'Uitgave Verwijderen',
    deleteExpenseMessage: 'De uitgave wordt permanent verwijderd. Weet je het zeker?'
  },
  disabledTooltips: {
    general: 'Deze functie is momenteel uitgeschakeld',
    youth: 'Het moet jeugd zijn om een leeftijd in te stellen',
    unit: 'Statistiek moet Runs, HSR of SPR zijn',
    seasonsWithout60MinsGames: 'Speler heeft niet meer dan 60 minuten gespeeld in een enkele wedstrijd in het geselecteerde seizoen(en)',
    notEditable: 'Dit kan niet worden bewerkt',
    noMatchdate: 'Wedstrijddatum niet beschikbaar',
    selectGame: 'Selecteer eerst een wedstrijd',
    selectPlayer: 'Selecteer eerst een speler',
    selectTeam: 'Selecteer eerst een team',
    selectBoxes: 'Vlakken visualisatie moet geselecteerd zijn',
    selectYear: 'Selecteer eerst een jaar',
    pdScoreNotAvailable: 'Score niet beschikbaar voor spelers die minder dan 60 minuten in een wedstrijd hebben gespeeld',
    pdSeasonNotAvailable: 'Fysieke gegevens zijn niet beschikbaar voor dit seizoen',
    pdGameNotAvailable: 'Fysieke gegevens zijn niet beschikbaar voor deze wedstrijd'
  },
  leagueTypes: {
    regular: 'Regulier',
    continental: 'Continentaal',
    nationalTeam: 'Nationaal Team',
    countryCup: 'Landbeker',
    qualifier: 'Kwalificatie',
    playOff: 'Play-Off',
    regionalLeague: 'Regionale Competitie',
    friendly: 'Vriendschappelijk',
    nationalFriendly: 'Nationaal Vriendschappelijk',
    nationaQualifier: 'Nationale Kwalificatie'
  },
  playerSides: {
    'Left/Right': 'Links/Rechts',
    'Left/Centre/Right': 'Links/Midden/Rechts',
    Right: 'Rechts',
    Centre: 'Midden',
    'Centre/Right': 'Midden/Rechts',
    Left: 'Links',
    'Left/Centre': 'Links/Midden'
  },
  areaSelector: {
    selectAreas: 'Selecteer gebieden',
    filterAreas: 'Filter gebieden'
  },
  spatialCoverage: {
    lastDefenderDist: 'Laatste verdediger afstand',
    defensiveLineDist: 'Defensieve lijn afstand',
    fullBackAvgDist: 'Vleugelverdediger gemiddelde afstand',
    offensiveLineDist: 'Offensieve lijn afstand',
    distanceToGoal: 'Afstand tot doel',
    avgLineWidth: 'Gem. lijnbreedte',
    leagueAvgDistanceToGoal: 'Gem. competitie afstand tot doel',
    leagueAvgLineWidth: 'Gem. competitie lijnbreedte',
    avgShort: 'Gem.',
    meters: 'meter',
    leagueAvgDist: 'Gem. competitie afstand',
    distance: 'Afstand',
    avgPositionYAxis: 'Gem. afstand op het veld (Y)',
    leagueAvgPositionYAxis: 'Gem. competitie-afstand op het veld (Y)',
    lbRbDistanceSeparation: 'LB–RB-afstand',
    leagueAvgLbRbDistanceSeparation: 'Gem. competitie LB–RB-afstand',
    legendTeam: 'Team',
    legendLeagueAvg: 'Gem. competitie',
    maxLength: 'Maximale lengte',
    maxWidth: 'Maximale breedte',
    avgBlockDistance: 'Gem. blok afstand'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Intelligente data',
    passesUnderPressureSubtitle: 'Analyseer het succespercentage van passes onder defensieve druk',
    onBallPressureSubtitle: 'Analyseer defensieve drukgebeurtenissen en hun succeskans per veldzone',
    ballReceiptsInSpaceSubtitle: 'Analyseer in de ruimte ontvangen passen per veldzone',
    ballReceipts: 'ontvangstbewijzen',
    totalBallReceipts: 'Totaal Balontvangsten',
    totalBallReceiptsCompleted: 'Totaal Balontvangsten Voltooid',
    completed: 'Voltooid',
    lineBreakingPassesSubtitle: 'Analyseer de passes die linies doorbreken en voordelen creëren',
    bypassed: 'Bypass',
    oppsBypassed: 'Tegenstanders overklast',
    passer: 'Passer',
    passedTo: 'Pas naar',
    receivedFrom: 'Ontvangen van',
    distanceToNearestDefender: 'Afstand tot dichtstbijzijnde verdediger',
    lineBreaking: 'Regeleinde {0}',
    keyPass: 'Sleutelpas',
    receiver: 'Ontvanger',
    dynamicTracking: 'Dynamische Tracking',
    eventLockTooltip: 'Sommige spelers zijn niet zichtbaar in het spel',
    bypassedPlayers: '{0} uitgespeelde spelers',
    playersCount: '{0} spelers',
    bothTeams: 'Beide teams',
    matchesCount: '{0} wedstrijden',
    lbpType: {
      F: 'Aanvallende linie',
      M: 'Middenlinie',
      B: 'Verdedigende linie',
      MF: 'Midden- en aanvallende linies',
      BM: 'Verdedigende en middenlinies',
      BF: 'Verdedigende en aanvallende linies',
      BMF: 'Verdedigende, midden- en aanvallende linies'
    },
    lbpCategory: {
      'G-IN-T': 'Laag binnenkant (breekt de verdedigingslinie)',
      'G-IN-NT': 'Laag binnenkant (breekt de verdedigingslinie niet)',
      'G-OUT-T': 'Laag buitenkant (breekt de verdedigingslinie)',
      'G-OUT-NT': 'Laag buitenkant (breekt de verdedigingslinie niet)',
      'O-IN-T': 'Hoog binnenkant (breekt de verdedigingslinie)',
      'O-IN-NT': 'Hoog binnenkant (breekt de verdedigingslinie niet)',
      'O-OUT-T': 'Hoog buitenkant (breekt de verdedigingslinie)',
      'O-OUT-NT': 'Hoog buitenkant (breekt de verdedigingslinie niet)',
      ground: 'Laag',
      over: 'Over',
      inside: 'Binnenkant',
      outside: 'Buitenkant',
      through: 'Breekt de verdedigingslinie',
      notThrough: 'Breekt de verdedigingslinie niet',
      throughAbbr: 'Absoluut breken. lijn',
      notThroughAbbr: 'Niet breken zeker. lijn'
    },
    lbpCategorySplit: {
      G: 'Grond: De pass was grond',
      O: 'Vlieg: De pass was vlieg',
      OUT: 'Buiten: De pas ging naar buiten',
      IN: 'Binnen: De pass ging naar binnen',
      T: 'Breekt de verdedigingslinie: de pass breekt de verdedigingslinie van binnenuit',
      NT: 'Breekt de verdedigingslinie niet: de pass breekt ze niet van binnenuit; hij gaat er van buitenaf omheen',
      UIT: 'Buiten: De pass ging naar buiten'
    },
    obrType: {
      OL: 'Overlap',
      UL: 'Onderlap',
      RA: 'Vooruit rennen',
      RB: 'Achteruit rennen',
      CR: 'Cross Receiver',
      SP: 'Support',
      CS: 'Korte stop'
    },
    visualization: 'Visualisatie',
    points: 'Cirkels',
    zones: 'Warmtekaart',
    pressureIntensity: 'Drukintensiteit',
    pressureOutcome: 'Drukuitkomst',
    passesOutcome: 'Resultaat van de Passes',
    strong: 'Sterk',
    light: 'Licht',
    normal: 'Normaal',
    successful: 'Succesvol',
    unsuccessful: 'Mislukt',
    presses: 'Drukken',
    passes: 'Passeert',
    passUnder: 'Ga onderdoor',
    successRate: 'Succespercentage',
    pressureOn: 'Druk op',
    pressureOf: 'Druk van',
    pressure: 'Druk',
    totalLabel: 'totaal',
    totalPasses: 'Totaal aantal Passen',
    unknown: 'onbekend',
    selectGameToViewMap: 'Selecteer een wedstrijd om de drukkaart te bekijken',
    noEventsFoundForGame: 'Geen drukgebeurtenissen gevonden voor deze wedstrijd',
    noEventsFoundForTeamAndSeason: 'Geen drukgebeurtenissen gevonden voor dit team en seizoen',
    noEventsFoundForPlayerAndSeason: 'Geen drukgebeurtenissen gevonden voor deze speler en seizoen',
    noEventsMatchFilters: 'Geen gebeurtenissen gevonden die voldoen aan de huidige filters',
    totalEventsAvailable: 'totaal aantal gebeurtenissen',
    passType: {
      P: 'Doorgang',
      A: 'Helpen',
      KP: 'Sleutelpas',
      PiOB: 'Ga naar Opp. Doos',
      PiFT: 'Ga naar de laatste derde',
      SoPP: 'Wissel van Play Pass'
    },
    minFrom: 'Min. vanaf',
    minTo: 'Min tot',
    secondFrom: 'Seg van',
    secondTo: 'Seg tot',
    positionPlayed: 'Positie gespeeld',
    highlight: 'Hoogtepunt',
    passTypeLabel: 'Pastype',
    offBallRunSubtitle: 'Analyseer off-ball runs',
    insights: 'Inzichten',
    insightsSubtitle: 'De beste rangschikken met geavanceerde Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Hoe kan ik je vandaag helpen?',
    chatSubtext: 'Vraag alles over voetbaldata!',
    thinking: 'Denken...',
    giveFeedback: 'Geef feedback',
    disclaimer: 'DriblabAI kan fouten maken. Zorg ervoor dat u de informatie verifieert.',
    recent: 'Recent',
    noConversations: 'Hier ziet u uw recente gesprekken!',
    rename: 'Hernoemen',
    deleteConversation: 'Gesprek verwijderen',
    confirmDelete: 'Weet je zeker dat je dit gesprek wilt verwijderen?',
    feedback: 'Feedback',
    feedbackQuestion: 'Was dit antwoord nuttig?',
    feedbackComments: 'Aanvullende opmerkingen',
    feedbackPlaceholder: 'Vertel ons wat nuttig was of wat verbeterd kan worden...',
    errorMessage: 'Het bericht kon niet worden verwerkt. Probeer het opnieuw.',
    newConversation: 'Nieuwe chat',
    write: 'Schrijf een bericht...'
  },
  periodId: {
    1: 'Eerste helft',
    2: 'Tweede helft',
    3: 'Extra tijd - 1º',
    4: 'Extra tijd - 2º',
    5: 'Strafschoppenserie',
    6: 'Fulltime',
    7: 'Pre-wedstrijd',
    8: 'Verlaten',
    9: 'Live',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Ander'
  }
};
